// @ts-nocheck
// Page: usage-il-bayou  (utility-usage — Illinois + full LMI + Bayou variant)
//
// Ported from the inline <script> in
//   Enrollment_modules/usage-il-bayou/form.module/module.html (lines 834–8554).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. Inline onclick/ondrop/ondragover handlers stripped from markup and
//      re-bound root-scoped via bind() at end of init (no window leakage).
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl(); same-origin
//      redirects -> root-relative paths.
//   3. localStorage.getItem/setItem/removeItem -> storage.rawGet/rawSet/rawRemove.
//   4. Bayou declared module-locally.
//   5. Document-scoped selectors kept as-is (single instance per page —
//      root-scoping is a planned fast-follow).
//   6. @ts-nocheck used for bare-minimum migration; proper typing is a follow-up.
//
// NOTE: #manualmobileCamera camera buttons call triggerFileInput(event) with no
//   boolean args, which falls through to the standard #fileInput rather than
//   #manualfileInput — preserved faithfully (suspected bug in original).
// NOTE: id="keepIt" appears in both .manual-RemoveFilePopup and .RemoveFilePopup;
//   id="keepItt" appears in both .census-RemoveFilePopup and .income-RemoveFilePopup.
//   bind() uses parent-scoped selectors to reach each copy independently.

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

declare const Bayou: any

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/usage/usage-il-bayou.ts","init",[root,_config],["root","_config"]);
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/usage/usage-il-bayou.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  var credNotVerified = false
  var isGetConsumptionFaild = false
  var manualAccountNumber = false
  var checkedValue = ""

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). The old bar advanced a
  // fabricated percentage on wall-clock time and auto-closed at 100s; that fake
  // progress (and the setInterval) are gone by construction. Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. A deferred audit will split this into read vs
  // mutation withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBar(message = "We are getting in contact with your utility service provider."): void {
__ea_trace("modules/usage/usage-il-bayou.ts","openProgressBar",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBar(): void {
__ea_trace("modules/usage/usage-il-bayou.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  function openNoAccountAlert() {
__ea_trace("modules/usage/usage-il-bayou.ts","openNoAccountAlert",[],[]);
    if (credNotVerified === true) {
      document.querySelector(".progMessageAlert").innerHTML = "We were unable to validate your utility credentials."
      document.querySelector("#manualUsage").innerHTML = "Enter Utility Details Manually"
    } else if (isGetConsumptionFaild === true) {
      document.querySelector(".progMessageAlert").innerHTML =
        "We validated your credentials, but we cannot reach your bill information yet. Please enter it manually below."
      document.querySelector("#manualUsage").innerHTML = "Enter my Bill Information"
    } else {
      document.querySelector(".progMessageAlert").innerHTML =
        "We’ve validated your login credentials, but we are unable to get your billing and electricity usage information."
    }
    document.querySelector("#progressBarOverlayAlert").style.display = "block"
    document.querySelector("#progressBarAlert").style.display = "block"
  }
  function closeNoAccountAlert() {
__ea_trace("modules/usage/usage-il-bayou.ts","closeNoAccountAlert",[],[]);
    document.querySelector("#progressBarOverlayAlert").style.display = "none"
    document.querySelector("#progressBarAlert").style.display = "none"
  }

  function resetAfterAccountLookup() {
__ea_trace("modules/usage/usage-il-bayou.ts","resetAfterAccountLookup",[],[]);
    checkedValue = ""
    credNotVerified = false
    manualAccountNumber = false
    isGetConsumptionFaild = false
    verifyidenty = "no"
    document.querySelector(".selectedItemDetails #serviceAddress").disabled = true
    document.querySelector(".selectedItemDetails #serviceAddress2").disabled = true
    document.querySelector(".selectedItemDetails #serviceCity").disabled = true
    document.querySelector(".selectedItemDetails #serviceState").disabled = true
    document.querySelector(".selectedItemDetails #serviceZipCode").disabled = true
    document.querySelector(".selectedItemDetails").style.display = "none"
    document.querySelector("#euiLabel").style.display = "none"
    document.querySelector("#euiHelpText").style.display = "none"
    document.querySelector("#totalKwhUsageHelpImageText").style.display = "none"
    document.querySelector(".elec-usage-info-manual").style.display = "none"
    document.querySelector(".utilityPictureIpiaap3Wrapper").style.display = "none"
    document.querySelectorAll(".utilityAccountNoWrapper").forEach((el) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[el],["el"]);
      el.style.display = "none"
    })
    document.querySelector("div#haveOnlineAccountMainDiv > label").style.display = "block"
    document.querySelector("#have-online-details").style.display = "block"
    document.querySelector("#have-online-details iframe").style.display = "block"
    document.querySelector(".selectedItemDetails .serviceAddAttLabel").style.display = "block"
    document.querySelector(".selectedItemDetails #serviceAddAtt").style.display = "block"
    closeNoAccountAlert()
  }

  document.querySelector("#manualUsage").addEventListener("click", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    closeNoAccountAlert()
  })
  document.querySelector("#CloseManualUsage").addEventListener("click", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    resetAfterAccountLookup()
  })
  document.querySelector("#tryAgain").addEventListener("click", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    resetAfterAccountLookup()
  })

  var responseFromAPI = ""
  pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js"

  /* loader function */
  function setLoaderState(overlayId, loaderId, isOpen) {
__ea_trace("modules/usage/usage-il-bayou.ts","setLoaderState",[overlayId,loaderId,isOpen],["overlayId","loaderId","isOpen"]);
    var loader = document.getElementById(loaderId)
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById(overlayId).style.display = isOpen ? "block" : "none"
    loader.style.display = isOpen ? "flex" : "none"
    buttons.forEach((button) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[button],["button"]);
      button.disabled = isOpen
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = isOpen
    })
  }
  function _pageFoundOpenLoader() {
__ea_trace("modules/usage/usage-il-bayou.ts","_pageFoundOpenLoader",[],[]);
    setLoaderState("MUloaderOverlay", "myUsageLoader", true)
  }
  function _pageFoundCloseLoader() {
__ea_trace("modules/usage/usage-il-bayou.ts","_pageFoundCloseLoader",[],[]);
    setLoaderState("MUloaderOverlay", "myUsageLoader", false)
  }
  function passUpdatedOpenLoader() {
__ea_trace("modules/usage/usage-il-bayou.ts","passUpdatedOpenLoader",[],[]);
    setLoaderState("PassUpdatedloaderOverlay", "PassUpdatedresetPassLoader", true)
  }
  function _saveLaterOpenLoader() {
__ea_trace("modules/usage/usage-il-bayou.ts","_saveLaterOpenLoader",[],[]);
    setLoaderState("saveLaterloaderOverlay", "saveLaterresetPassLoader", true)
  }
  /* loader function */

  document.querySelector(".mailingItems .mailingAddress").addEventListener("input", validateAddress1)
  document.querySelector(".mailingItems .mailingCity").addEventListener("input", validateCity)
  document.querySelector(".mailingItems .mailingState").addEventListener("input", validateState)
  document.querySelector(".mailingItems .mailingZipCode").addEventListener("input", validateZipCode)

  document.getElementById("serviceZipCode").addEventListener("input", function (_e) {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[_e],["_e"]);
    this.value = this.value.replace(/\D/g, "") // remove non-digits
  })

  document.getElementById("totalKwhUsage").addEventListener("keypress", function (e) {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[e],["e"]);
    const char = e.key

    // Allow digits
    if (/[0-9]/.test(char)) return

    // Allow one decimal point
    if (char === "." && !this.value.includes(".")) return

    // Block everything else
    e.preventDefault()
  })

  function validateTextField(inputSelector, errorSelector, emptyMessage, invalidMessage, pattern, trimValue) {
__ea_trace("modules/usage/usage-il-bayou.ts","validateTextField",[inputSelector,errorSelector,emptyMessage,invalidMessage,pattern,trimValue],["inputSelector","errorSelector","emptyMessage","invalidMessage","pattern","trimValue"]);
    var value = document.querySelector(inputSelector).value
    var errorElement = document.querySelector(errorSelector)
    if (trimValue) {
      value = value.trim()
    }
    if (value === "") {
      errorElement.innerHTML = emptyMessage
      return "error"
    }
    if (pattern && !pattern.test(value)) {
      errorElement.innerHTML = invalidMessage
      return "error"
    }
    errorElement.innerHTML = ""
    return null
  }
  function validateAddress1() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateAddress1",[],[]);
    return validateTextField(
      ".mailingItems .mailingAddress",
      ".mailingItems #mailing_address_error_message",
      "Please enter address line 1.",
      null,
      null,
      true,
    )
  }
  function validateCity() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateCity",[],[]);
    return validateTextField(
      ".mailingItems .mailingCity",
      ".mailingItems #mailing_city_error_message",
      "Please enter city.",
      "Please enter a valid City with only alphabetic characters.",
      /^[a-zA-Z ]+$/,
      true,
    )
  }
  function validateState() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateState",[],[]);
    return validateTextField(
      ".mailingItems .mailingState",
      ".mailingItems #mailing_state_error_message",
      "Please enter state.",
      "Please enter a valid State with only alphabetic characters.",
      /^[a-zA-Z ]+$/,
      false,
    )
  }
  function validateZipCode() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateZipCode",[],[]);
    return validateTextField(
      ".mailingItems .mailingZipCode",
      ".mailingItems #mailing_zip_code_error_message",
      "Please enter a zip code.",
      "Please enter a valid zip code (e.g., 12345 or 12345-6789).",
      /^\d{5}(-\d{4})?$/,
      true,
    )
  }
  function validateServiceAddress1() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateServiceAddress1",[],[]);
    return validateTextField(
      ".selectedItemDetails > .serviceAddress",
      ".selectedItemDetails #serviceAddress_error_message",
      "Please enter address line 1.",
      null,
      null,
      true,
    )
  }
  function validateServiceCity() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateServiceCity",[],[]);
    return validateTextField(
      ".selectedItemDetails > .serviceCity",
      ".selectedItemDetails > #serviceCity_error_message",
      "Please enter city.",
      "Please enter a valid City with only alphabetic characters.",
      /^[a-zA-Z ]+$/,
      true,
    )
  }
  function validateServiceState() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateServiceState",[],[]);
    return validateTextField(
      ".selectedItemDetails > .serviceState",
      ".selectedItemDetails #serviceState_error_message",
      "Please enter state.",
      "Please enter a valid State with only alphabetic characters.",
      /^[a-zA-Z ]+$/,
      false,
    )
  }
  function validateServiceZipCode() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateServiceZipCode",[],[]);
    return validateTextField(
      ".selectedItemDetails > .serviceZipCode",
      ".selectedItemDetails #serviceZipCode_error_message",
      "Please enter a zip code.",
      "Please enter a valid zip code (e.g., 12345 or 12345-6789).",
      /^\d{5}(-\d{4})?$/,
      true,
    )
  }
  function validateServiceAddAtt() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateServiceAddAtt",[],[]);
    return validateTextField(
      ".selectedItemDetails > .serviceAddAtt",
      ".selectedItemDetails #serviceAddAtt_error_message",
      "Please enter a zip code.",
      "Please enter a valid zip code (e.g., 12345 or 12345-6789).",
      /^\d{5}(-\d{4})?$/,
      true,
    )
  }
  function showError(inputId, message) {
__ea_trace("modules/usage/usage-il-bayou.ts","showError",[inputId,message],["inputId","message"]);
    const errorDiv = document.getElementById(`${inputId}_error_message`)
    errorDiv.textContent = message
    errorDiv.style.display = "block"
  }
  function hideError(inputId) {
__ea_trace("modules/usage/usage-il-bayou.ts","hideError",[inputId],["inputId"]);
    const errorDiv = document.getElementById(`${inputId}_error_message`)
    errorDiv.style.display = "none"
  }

  function formatMonthYearInput(inputId) {
__ea_trace("modules/usage/usage-il-bayou.ts","formatMonthYearInput",[inputId],["inputId"]);
    const input = document.getElementById(inputId)
    let value = input.value.replace(/\D/g, "") // keep only digits

    if (value.length >= 3) {
      value = `${value.slice(0, 2)}/${value.slice(2, 6)}`
    }
    input.value = value
  }
  // 🔹 Format Date object → MM/DD/YYYY
  function formatToMMDDYYYY(dateObj) {
__ea_trace("modules/usage/usage-il-bayou.ts","formatToMMDDYYYY",[dateObj],["dateObj"]);
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0")
    const dd = String(dateObj.getDate()).padStart(2, "0")
    const yyyy = dateObj.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  function getStartDate(monthYear) {
__ea_trace("modules/usage/usage-il-bayou.ts","getStartDate",[monthYear],["monthYear"]);
    const [month, year] = monthYear.split("/").map(Number)
    return new Date(year, month - 1, 1) // first day of month
  }
  function getEndDate(monthYear) {
__ea_trace("modules/usage/usage-il-bayou.ts","getEndDate",[monthYear],["monthYear"]);
    const [month, year] = monthYear.split("/").map(Number)
    return new Date(year, month, 0) // last day of month (handles leap years)
  }

  function validateMonthYear(startId, endId) {
__ea_trace("modules/usage/usage-il-bayou.ts","validateMonthYear",[startId,endId],["startId","endId"]);
    const startVal = document.getElementById(startId).value.trim()
    const endVal = document.getElementById(endId).value.trim()

    const datePattern = /^(0[1-9]|1[0-2])\/\d{4}$/

    hideError(startId)
    hideError(endId)

    const today = new Date()

    const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)

    // =========================================
    // START DATE VALIDATION
    // =========================================
    if (startVal) {
      // Format check
      if (!datePattern.test(startVal)) {
        showError(startId, "Start date must be in the format MM/YYYY.")
        return "error"
      }

      const startDate = getStartDate(startVal)

      // 13 months limit
      const cutoffDate = new Date(today.getFullYear(), today.getMonth() - 13, 1)

      if (startDate < cutoffDate) {
        showError(startId, "Start date cannot be more than 13 months before today.")
        return "error"
      }

      // Future check
      if (startDate > currentMonthEnd) {
        showError(startId, "Start date cannot be in the future.")
        return "error"
      }
    }

    // =========================================
    // END DATE VALIDATION
    // =========================================
    if (endVal) {
      // Format check
      if (!datePattern.test(endVal)) {
        showError(endId, "End date must be in the format MM/YYYY.")
        return "error"
      }

      const endDate = getEndDate(endVal)

      // Future check
      if (endDate > currentMonthEnd) {
        showError(endId, "End date cannot be in the future.")
        return "error"
      }
    }

    // =========================================
    // RANGE VALIDATIONS
    // Run only when BOTH dates exist
    // =========================================
    if (!startVal || !endVal) {
      return true
    }

    const startDate = getStartDate(startVal)
    const endDate = getEndDate(endVal)

    // Minimum 3 months
    const minEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0)

    if (endDate < minEndDate) {
      showError(endId, "You must include at least 3 uninterrupted months of usage.")
      return "error"
    }

    // Maximum 12 months
    const maxEndDate = new Date(startDate.getFullYear() + 1, startDate.getMonth(), 0)

    if (endDate > maxEndDate) {
      showError(endId, "The entered date range includes 13 or more months. Please submit usage for 12 months only.")
      return "error"
    }

    return true
  }
  function getDaysBetween(startMonthYear, endMonthYear) {
__ea_trace("modules/usage/usage-il-bayou.ts","getDaysBetween",[startMonthYear,endMonthYear],["startMonthYear","endMonthYear"]);
    const datePattern = /^\d{2}\/\d{4}$/ // MM/YYYY

    if (!datePattern.test(startMonthYear) || !datePattern.test(endMonthYear)) {
      console.error("Invalid date format. Please use MM/YYYY.")
      return null
    }

    const [sMonth, sYear] = startMonthYear.split("/").map(Number)
    const [eMonth, eYear] = endMonthYear.split("/").map(Number)

    const startDate = new Date(sYear, sMonth - 1, 1) // First day
    const endDate = new Date(eYear, eMonth, 0) // Last day

    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      console.error("Invalid date value.")
      return null
    }

    const diffInMs = endDate - startDate
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

    return diffInDays
  }

  // Attach auto-format + validation
  document.getElementById("sdofbp").addEventListener("input", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    formatMonthYearInput("sdofbp")
    validateMonthYear("sdofbp", "edomrbp")
  })
  document.getElementById("edomrbp").addEventListener("input", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    formatMonthYearInput("edomrbp")
    validateMonthYear("sdofbp", "edomrbp")
  })

  function validateTotalKwhUsage() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateTotalKwhUsage",[],[]);
    const totalKwhUsageInput = document.getElementById("totalKwhUsage").value
    const totalKwhUsage = parseInt(totalKwhUsageInput, 10)

    if (Number.isNaN(totalKwhUsage) || totalKwhUsage <= 0) {
      showError("totalKwhUsage", "Total kWh Usage must be a positive integer equal to and greater than 1.")
      return "error"
    } else {
      hideError("totalKwhUsage")
      return true
    }
  }
  document.getElementById("totalKwhUsage").addEventListener("input", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    validateTotalKwhUsage()
  })

  var verifyidenty
  var _bayouFormCompleted = false
  var bayouToken = null
  var bayouTokenType = null
  var bayouUtility = null
  var bayouId = null
  var bayouAccountNo = null
  var firstId = null
  var meterId = null
  var meterType = null
  var rateClass = null
  var meterCity = null
  var meterState = null
  var meterLine1 = null
  var meterLine2 = null
  var _meterCountry = null
  var meterPostalCode = null
  var additionalAttributeItem = null
  var additionalAttributeValue = null

  // ------------- Get saved data -------------------------------
  var accountNofuncCallCount = 0
  var mfaRequired = "No"
  var customerTriedCount = 1

  var isManualAccNumbsFilled = false
  async function updateDealStageIl(value) {
__ea_trace("modules/usage/usage-il-bayou.ts","updateDealStageIl",[value],["value"]);
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value, // Utility Info
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      if (response.status === 200) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  async function manualFieldsForNoAccountFound() {
__ea_trace("modules/usage/usage-il-bayou.ts","manualFieldsForNoAccountFound",[],[]);
    verifyidenty = "yes"
    checkedValue = "manualFile"
    document.querySelector(".selectedItemDetails #serviceAddress").disabled = false
    document.querySelector(".selectedItemDetails > .serviceAddress").addEventListener("input", validateServiceAddress1)

    document.querySelector(".selectedItemDetails #serviceAddress2").disabled = false

    document.querySelector(".selectedItemDetails #serviceCity").disabled = false
    document.querySelector(".selectedItemDetails > .serviceCity").addEventListener("input", validateServiceCity)

    document.querySelector(".selectedItemDetails #serviceState").disabled = true
    document.querySelector(".selectedItemDetails #serviceState").value = storage.rawGet("FarmStateAbbreviation")

    document.querySelector(".selectedItemDetails #serviceZipCode").disabled = false
    document.querySelector(".selectedItemDetails #serviceZipCode").value = storage.rawGet("zip_code")

    document.querySelector(".selectedItemDetails .serviceAddAttLabel").style.display = "none"
    document.querySelector(".selectedItemDetails #serviceAddAtt").style.display = "none"

    document.querySelector("div#haveOnlineAccountMainDiv > label").style.display = "none"
    document.querySelector("#have-online-details").style.display = "none"
    document.querySelector("#have-online-details iframe").style.display = "none"
    document.querySelectorAll(".utilityAccountNoWrapper").forEach((el) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[el],["el"]);
      el.style.display = "block"
    })
    document.querySelector(".selectedItemDetails").style.display = "block"
    document.getElementById("addressSameCheckbox").addEventListener("change", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
      const content = document.querySelector(".selectedItemDetails .mailingItems")
      if (this.checked) {
        content.style.display = "none" // Show content
      } else {
        content.style.display = "block" // Hide content
      }
    })

    document.querySelector("#euiLabel").style.display = "block"
    document.querySelector("#euiHelpText").style.display = "block"
    document.querySelector("#totalKwhUsageHelpImageText").style.display = "block"
    document.querySelector(".elec-usage-info-manual").style.display = "block"
    document.querySelector(".utilityPictureIpiaap3Wrapper").style.display = "block"
  }

  function getValidTariff(meter) {
__ea_trace("modules/usage/usage-il-bayou.ts","getValidTariff",[meter],["meter"]);
    if (!meter.tariffs || meter.tariffs.length === 0) {
      return null // no tariffs at all
    }

    let selectedTariff

    if (meter.tariffs.length === 1) {
      // single tariff
      selectedTariff = meter.tariffs[0]
    } else {
      // multiple tariffs → pick the one with biggest period_to
      selectedTariff = meter.tariffs.reduce((latest, current) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[latest,current],["latest","current"]);
        return new Date(current.period_to) > new Date(latest.period_to) ? current : latest
      })
    }

    // check if selected tariff period_to is more than 1 year older than today
    const periodToDate = new Date(selectedTariff.period_to)
    const today = new Date()

    const oneYearLater = new Date(today)
    oneYearLater.setFullYear(today.getFullYear() + 1)

    const oneYearAgo = new Date(today)
    oneYearAgo.setFullYear(today.getFullYear() - 1)

    const isMoreThanOneYearFuture = periodToDate > oneYearLater
    const isOlderThanOneYearPast = periodToDate < oneYearAgo

    // You can control account number visibility here
    const showAccountNumber = isMoreThanOneYearFuture || isOlderThanOneYearPast

    return {
      tariff: selectedTariff,
      isMoreThanOneYear: showAccountNumber,
    }
  }
  /* --------------- for first enrollment ----------------------- */
  async function getTokenAndDateStamp() {
__ea_trace("modules/usage/usage-il-bayou.ts","getTokenAndDateStamp",[],[]);
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var dateStamp = dataa.userValue.properties.date_stamp
      var _bToken = dataa.userValue.properties.bayou_onboarding_token
      var bContactId = dataa.userValue.properties.bayou_contact_id
      storage.rawSet("dateStamp", dateStamp)
      storage.rawSet("bayou_contact_id", bContactId)
      //             storage.rawSet("LoggedName", firstName + " " + lastName);
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function GetDataFromDealRecord() {
__ea_trace("modules/usage/usage-il-bayou.ts","GetDataFromDealRecord",[],[]);
    await updateDealStageIl("984278684")
    openProgressBar("We are getting in contact with your utility service provider.")
    await BayouCreateCustomer()
    //         var email = storage.rawGet("userEmail");
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        var _doYouHaveAccount = dataa.userValue.properties.do_you_have_an_account_with_utility_service_provider
        var _dealStage = dataa.userValue.properties.dealstage
        var manualUsageEntry = dataa.userValue.properties.manual_usage_entry
        if (manualUsageEntry === "Yes") {
          var msad = dataa.userValue.properties.mail_street_address
          var msad2 = dataa.userValue.properties.mail_street_address_2
          var mct = dataa.userValue.properties.mail_city
          var mst = dataa.userValue.properties.mail_state
          var mpcd = dataa.userValue.properties.mail_postal_code
          var mtku = dataa.userValue.properties.manual_total_kwh_usage
          var _mrstd = dataa.userValue.properties.manual_reading_start_date
          var _mred = dataa.userValue.properties.manual_reading_end_date
          var st = dataa.userValue.properties.street_address
          var st2 = dataa.userValue.properties.street_address_2
          var ct = dataa.userValue.properties.city
          var ssab = dataa.userValue.properties.service_state_abbreviation
          var pcd = dataa.userValue.properties.postal_code
          var _cnty = dataa.userValue.properties.county
          var uan1V = dataa.userValue.properties.uan_1_value
          var uan2V = dataa.userValue.properties.uan_2_value
          document.querySelector("#mailingAddress").value = msad
          document.querySelector("#mailingAddress2").value = msad2
          document.querySelector("#mailingCity").value = mct
          document.querySelector("#mailingState").value = mst
          document.querySelector("#mailingZipCode").value = mpcd
          if (mtku !== undefined && mtku != null && mtku !== "undefined" && mtku !== "null") {
            document.querySelector("#totalKwhUsage").value = mtku
          }
          document.querySelector("#serviceAddress").value = st
          document.querySelector("#serviceAddress2").value = st2
          document.querySelector("#serviceCity").value = ct
          document.querySelector("#serviceState").value = ssab
          document.querySelector("#serviceZipCode").value = pcd

          document.querySelector("#utilityAccountNo0").value = uan1V
          document.querySelector("#utilityAccountNo1").value = uan2V
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function getAccountNumberByWebhook(token, type, utility, id) {
__ea_trace("modules/usage/usage-il-bayou.ts","getAccountNumberByWebhook",[token,type,utility,id],["token","type","utility","id"]);
    //         var ContactId = storage.rawGet("RecordId");
    const hensonApiUrl = `https://hansen.danmarcrm.com/getAccountNumbers.php?contact_id=${id}`
    const requestBody = {
      contact_id: id,
    }
    var catchdata = ""
    try {
      const response = await fetch(hensonApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
      catchdata = requestBody
      const responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)

      // Check if there is at least one id
      if (responseData.length > 0) {
        if (responseData.length >= 1) {
          var Accdiv = document.createElement("div")
          var h2 = document.createElement("h2")
          h2.textContent = "Please select Account Number"
          Accdiv.appendChild(h2)
          const accul = document.createElement("ul")
          accul.classList.add("accountNumbersUl")
          await getDataFromUANConfigTable()
          var existAccNoLength = 0

          for (const item of responseData) {
            const accli = document.createElement("li")
            const accspan = document.createElement("span")
            accli.classList.add(`acc${item.id}`) // Add class to li
            accli.style.display = "none"
            accspan.textContent = item.id
            accli.id = item.id
            accli.appendChild(accspan)
            if (item.meters.length >= 1) {
              var div = document.createElement("div")
              div.classList.add("meterWrapper")
              var h4 = document.createElement("h4")
              h4.textContent = "Please select Additional Attributes"
              div.appendChild(h4)
              div.id = `meterId${item.id}`
              const meterul = document.createElement("ul")
              meterul.id = "meterList"
              item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
                const meterli = document.createElement("li")
                var mtType = meter.type
                mtType = mtType.toUpperCase()
                if (mtType === "ELECTRIC") {
                  accli.style.display = "block"
                  meterli.id = `${meter.id}`
                  meterli.type = meter.type
                  meterli.setAttribute("city", meter.address.city)
                  meterli.setAttribute("state", meter.address.state)
                  meterli.setAttribute("line_1", meter.address.line_1)
                  meterli.setAttribute("line_2", meter.address.line_2)
                  meterli.setAttribute("country", meter.address.country)
                  meterli.setAttribute("postal_code", meter.address.postal_code)
                  meterli.setAttribute("tariff", meter.tariffs[0].tariff)
                  if (meter.additional_attributes != null) {
                    meterli.setAttribute(
                      "aa",
                      meter.additional_attributes[additionalAttributeItem]
                        ? meter.additional_attributes[additionalAttributeItem]
                        : "",
                    )
                  }

                  meterId = `${meter.id}`
                  meterType = meter.type
                  rateClass = meter.tariffs[0].tariff
                  meterCity = meter.address.city
                  meterState = meter.address.state
                  meterLine1 = meter.address.line_1
                  meterLine2 = meter.address.line_2
                  _meterCountry = meter.address.country
                  meterPostalCode = meter.address.postal_code
                  var resultT = getValidTariff(meter)
                  if (resultT.isMoreThanOneYear === true) {
                    accli.style.display = "none" // hide
                  } else {
                    accli.style.display = "block" // show
                  }
                  if (meter.additional_attributes !== undefined) {
                    if (meter.additional_attributes != null) {
                      if (meter.additional_attributes[additionalAttributeItem] != null) {
                        accli.classList.remove("hidden")
                        div.classList.remove("hidden")
                        if (
                          additionalAttributeValue !== "" &&
                          additionalAttributeValue != null &&
                          additionalAttributeValue !== undefined
                        ) {
                          if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                            div.classList.add("hidden")
                          } else {
                            div.classList.remove("hidden")
                          }
                        } else {
                          div.classList.add("hidden")
                        }
                        additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                      } else {
                        if (storage.rawGet("utility_id") === "COMED-SF") {
                          accli.classList.add("hidden")
                          document.querySelector("#serviceAddAtt").style.display = "block"
                          document.querySelector(".serviceAddAttLabel").style.display = "block"
                        } else {
                          accli.classList.remove("hidden")
                          document.querySelector("#serviceAddAtt").style.display = "none"
                          document.querySelector(".serviceAddAttLabel").style.display = "none"
                        }
                      }
                    } else {
                      if (storage.rawGet("utility_id") === "COMED-SF") {
                        accli.classList.add("hidden")
                        document.querySelector("#serviceAddAtt").style.display = "block"
                        document.querySelector(".serviceAddAttLabel").style.display = "block"
                      } else {
                        accli.classList.remove("hidden")
                        document.querySelector("#serviceAddAtt").style.display = "none"
                        document.querySelector(".serviceAddAttLabel").style.display = "none"
                      }
                    }
                  } else {
                    if (storage.rawGet("utility_id") === "COMED-SF") {
                      accli.classList.add("hidden")
                      document.querySelector("#serviceAddAtt").style.display = "block"
                      document.querySelector(".serviceAddAttLabel").style.display = "block"
                    } else {
                      accli.classList.remove("hidden")
                      document.querySelector("#serviceAddAtt").style.display = "none"
                      document.querySelector(".serviceAddAttLabel").style.display = "none"
                    }
                  }
                  if (additionalAttributeValue == null) {
                    additionalAttributeValue = ""
                  }
                  meterli.textContent = additionalAttributeValue
                  meterul.appendChild(meterli)
                  div.appendChild(meterul)
                  accli.appendChild(div)
                }
              })
            }
            var property = "uan_1_value"
            var value = item.id
            const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ property, value }),
            })
            const data = await response.json()
            if (response.ok) {
              if (data.total === 0 || data.total === undefined) {
              } else if (data.total === 1) {
                var dealIdFromDealFound = data.results[0].id
                var dealIdFromCurrentPage = storage.rawGet("dealId")
                if (dealIdFromDealFound === dealIdFromCurrentPage) {
                } else {
                  ++existAccNoLength
                  accli.style.cursor = "not-allowed"
                  accli.style.pointerEvents = "none"
                  accli.style.color = "#999"
                  accli.style.opacity = "0.5"
                }
              } else {
                ++existAccNoLength
                accli.style.cursor = "not-allowed"
                accli.style.pointerEvents = "none"
                accli.style.color = "#999"
                accli.style.opacity = "0.5"
              }
            }
            accul.appendChild(accli)
            Accdiv.appendChild(accul)
            document.querySelector(".have-online-details").appendChild(Accdiv)
          }
          closeProgressBar()
          if (existAccNoLength === responseData.length) {
            verifyidenty = "no"
            passUpdatedOpenLoader()
          }
          document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
            li.style.display = "none"
          })
          function accountNumberSelected(event) {
__ea_trace("modules/usage/usage-il-bayou.ts","accountNumberSelected",[event],["event"]);
            document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
              span.style.backgroundColor = "#ffffff"
            })
            document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
              li.style.display = "none"
            })
            const clickedElement = event.target
            firstId = clickedElement.parentElement.id
            bayouAccountNo = firstId
            const meterWrapper = clickedElement.parentElement.querySelector(".meterWrapper")
            const ulElement = meterWrapper.querySelector("ul")
            const liElements = ulElement.querySelectorAll("li")
            const numberOfLi = liElements.length
            if (numberOfLi === 1) {
              verifyidenty = "yes"
              meterWrapper.style.display = "none"
              liElements.forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
                meterId = li.id
                meterType = li.type
                meterCity = li.getAttribute("city")
                meterState = li.getAttribute("state")
                meterLine1 = li.getAttribute("line_1")
                meterLine2 = li.getAttribute("line_2")
                _meterCountry = li.getAttribute("country")
                meterPostalCode = li.getAttribute("postal_code")
                additionalAttributeValue = li.getAttribute("aa")
                if (li.tariffs) {
                  rateClass = li.tariffs[0].tariff
                }
              })
            } else {
              ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
                span.style.backgroundColor = "#ffffff"
              })
              meterWrapper.style.display = "block"
              ulElement.querySelectorAll("li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
                li.addEventListener("click", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
                  verifyidenty = "yes"
                  ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
                    span.style.backgroundColor = "#ffffff"
                  })
                  this.style.backgroundColor = "#f18020"
                  meterId = this.id
                  meterType = this.type
                  meterCity = this.getAttribute("city")
                  meterState = this.getAttribute("state")
                  meterLine1 = this.getAttribute("line_1")
                  meterLine2 = this.getAttribute("line_2")
                  _meterCountry = this.getAttribute("country")
                  meterPostalCode = this.getAttribute("postal_code")
                  additionalAttributeValue = this.getAttribute("aa")
                  if (this.tariffs) {
                    rateClass = this.tariffs[0].tariff
                  }
                })
              })
            }

            clickedElement.style.backgroundColor = "#f18020"
            document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
              span.removeAttribute("data-selected")
            })
            clickedElement.setAttribute("data-selected", "true")

            if (meterLine2 == null || meterLine2 === "null") {
              meterLine2 = ""
            }

            document.querySelector(".selectedItemDetails #name").value = meterType
            document.querySelector(".selectedItemDetails #name").disabled = true

            if (meterLine1 == null || meterLine1 === "" || meterLine1 === undefined || meterLine1 === "null") {
              document.querySelector(".selectedItemDetails #serviceAddress").disabled = false
              document
                .querySelector(".selectedItemDetails > .serviceAddress")
                .addEventListener("input", validateServiceAddress1)
            } else {
              document.querySelector(".selectedItemDetails #serviceAddress").value = meterLine1
              document.querySelector(".selectedItemDetails #serviceAddress").disabled = true
            }

            if (meterLine2 == null || meterLine2 === "" || meterLine2 === undefined || meterLine2 === "null") {
              document.querySelector(".selectedItemDetails #serviceAddress2").disabled = false
            } else {
              document.querySelector(".selectedItemDetails #serviceAddress2").disabled = true
              document.querySelector(".selectedItemDetails #serviceAddress2").value = meterLine2
            }

            if (meterCity == null || meterCity === "" || meterCity === undefined || meterCity === "null") {
              document.querySelector(".selectedItemDetails #serviceCity").disabled = false
              document
                .querySelector(".selectedItemDetails > .serviceCity")
                .addEventListener("input", validateServiceCity)
            } else {
              document.querySelector(".selectedItemDetails #serviceCity").disabled = true
              document.querySelector(".selectedItemDetails #serviceCity").value = meterCity
            }

            if (meterState == null || meterState === "" || meterState === undefined || meterState === "null") {
              document.querySelector(".selectedItemDetails #serviceState").disabled = false
              document
                .querySelector(".selectedItemDetails > .serviceState")
                .addEventListener("input", validateServiceState)
            } else {
              document.querySelector(".selectedItemDetails #serviceState").disabled = true
              document.querySelector(".selectedItemDetails #serviceState").value = meterState
            }

            if (
              meterPostalCode == null ||
              meterPostalCode === "" ||
              meterPostalCode === undefined ||
              meterPostalCode === "null"
            ) {
              document.querySelector(".selectedItemDetails #serviceZipCode").disabled = false
              document
                .querySelector(".selectedItemDetails > .serviceZipCode")
                .addEventListener("input", validateServiceZipCode)
            } else {
              document.querySelector(".selectedItemDetails #serviceZipCode").disabled = true
              document.querySelector(".selectedItemDetails #serviceZipCode").value = meterPostalCode
            }

            if (
              additionalAttributeValue == null ||
              additionalAttributeValue === "" ||
              additionalAttributeValue === undefined ||
              additionalAttributeValue === "null"
            ) {
              document.querySelector(".selectedItemDetails #serviceAddAtt").disabled = false
              document
                .querySelector(".selectedItemDetails > .serviceAddAtt")
                .addEventListener("input", validateServiceAddAtt)
            } else {
              document.querySelector(".selectedItemDetails #serviceAddAtt").disabled = true
              document.querySelector(".selectedItemDetails #serviceAddAtt").value = additionalAttributeValue
            }

            document.querySelector(".selectedItemDetails").style.display = "block"
            document.getElementById("addressSameCheckbox").addEventListener("change", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
              const content = document.querySelector(".selectedItemDetails .mailingItems")
              if (this.checked) {
                content.style.display = "none" // Show content
              } else {
                content.style.display = "block" // Hide content
              }
            })
          }
          document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
            span.addEventListener("click", accountNumberSelected)
          })

          const actnoUL = document.querySelector(".accountNumbersUl")
          const liItems = actnoUL.querySelectorAll("li")
          const allHidden = Array.from(liItems).every((li) => li.classList.contains("hidden"))
          if (allHidden) {
            document.querySelector("#have-online-details").style.display = "none"
            document.querySelector("#have-online-details iframe").style.display = "none"
            document.querySelector(".utilityAccountNoWrapper").style.display = "block"
            manualAccountNumber = true
          } else {
            document.querySelector("#have-online-details iframe").style.display = "block"
            document.querySelector("#have-online-details").style.display = "block"
            document.querySelector(".utilityAccountNoWrapper").style.display = "none"
            manualAccountNumber = false
          }
        }
        bayouToken = token
        bayouTokenType = type
        bayouUtility = utility
        bayouId = id
        bayouAccountNo = firstId
        closeProgressBar()
        await updateProviderInContact()
      } else {
        if (accountNofuncCallCount === 50) {
          // --------- append manual account number field if did not found any account number
          credNotVerified = false
          document.querySelector("#have-online-details").style.display = "none"
          document.querySelector("#have-online-details iframe").style.display = "none"
          document.querySelector(".utilityAccountNoWrapper").style.display = "block"
          manualAccountNumber = true
          closeProgressBar()
          openNoAccountAlert()
          await manualFieldsForNoAccountFound()
          // --------- append manual account number field if did not found any account number
        } else {
          document.querySelector("#have-online-details").style.display = "block"
          document.querySelector("#have-online-details iframe").style.display = "block"
          document.querySelector(".utilityAccountNoWrapper").style.display = "none"
          manualAccountNumber = false
          ++accountNofuncCallCount
          await getAccountNumberByWebhook(token, type, utility, id)
        }
      }
      if (response.status === 500 || response.status === 404) {
        credNotVerified = false
        manualAccountNumber = true
        closeProgressBar()

        await manualFieldsForNoAccountFound()
        openNoAccountAlert()
      }
    } catch (error) {
      credNotVerified = false
      manualAccountNumber = true
      closeProgressBar()
      await manualFieldsForNoAccountFound()
      openNoAccountAlert()

      console.error("Error calling API:", error)
    }
  }
  async function _updateBayouResponseInDeal(_token, _type, _utility, _id, _firstId) {
__ea_trace("modules/usage/usage-il-bayou.ts","_updateBayouResponseInDeal",[_token,_type,_utility,_id,_firstId],["_token","_type","_utility","_id","_firstId"]);
    var dealId = storage.rawGet("dealId")
    openProgressBar("We are saving your utility information")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          bayous_utility_id: bayouUtility,
          bayous_type: bayouTokenType,
          bayous_id: bayouId,
          bayous_onboarding_token: bayouToken,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        closeProgressBar()
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function updateProviderInContact() {
__ea_trace("modules/usage/usage-il-bayou.ts","updateProviderInContact",[],[]);
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          is_enrolled_for_bayou: "yes",
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      responseFromAPI = await response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateTokenAndDateInContact(token, date, tokenLink) {
__ea_trace("modules/usage/usage-il-bayou.ts","updateTokenAndDateInContact",[token,date,tokenLink],["token","date","tokenLink"]);
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          bayou_onboarding_token: token,
          date_stamp: date,
          bayou_onboarding_link: tokenLink,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      responseFromAPI = await response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  function formatDateAsMMDDYYYY(date) {
__ea_trace("modules/usage/usage-il-bayou.ts","formatDateAsMMDDYYYY",[date],["date"]);
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const year = date.getFullYear()
    return `${month}/${day}/${year}`
  }
  function getCurrentDate() {
__ea_trace("modules/usage/usage-il-bayou.ts","getCurrentDate",[],[]);
    return formatDateAsMMDDYYYY(new Date())
  }
  function selectMeter(event) {
__ea_trace("modules/usage/usage-il-bayou.ts","selectMeter",[event],["event"]);
    verifyidenty = "yes"
    document.querySelectorAll("#meterList li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
      li.style.backgroundColor = "#ffffff"
    })
    const clickedElement = event.target
    meterId = clickedElement.id
    meterType = clickedElement.type
    rateClass = clickedElement.tariff
    additionalAttributeValue = clickedElement.getAttribute("aa")
    clickedElement.style.backgroundColor = "#f18020"
    document.querySelectorAll("#meterList li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
      li.removeAttribute("data-selected")
    })
    clickedElement.setAttribute("data-selected", "true")
  }
  async function BayouGetCustomersWhenTokenExpire() {
__ea_trace("modules/usage/usage-il-bayou.ts","BayouGetCustomersWhenTokenExpire",[],[]);
    var _bayou_reason = storage.rawGet("bayou_reason")
    var bayouContactId = storage.rawGet("bayou_contact_id")
    verifyidenty = "no"
    const hensonApiUrl = `https://hansen.danmarcrm.com/getContactByID.php?contact_id=${bayouContactId}`
    const requestBody = {
      contact_id: bayouContactId,
    }
    var _catchdata = ""
    try {
      const response = await fetch(hensonApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
      _catchdata = requestBody
      var responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)
      const onboardingToken = responseData.onboarding_token
      const onboardingLink = responseData.onboarding_link
      storage.rawSet("onboarding_token", onboardingToken)
      storage.rawSet("dateStamp", getCurrentDate())
      await updateTokenAndDateInContact(onboardingToken, getCurrentDate(), onboardingLink)
      Bayou.loadOnboardingForm(
        document.getElementById("have-online-details"),
        60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
        onboardingToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
        (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
          document.getElementById("verification-error-message").innerHTML = ""
          if (event.type === "customerHasAuthenticated") {
            closeNoAccountAlert()
            credNotVerified = false
            mfaRequired = "No"
            openProgressBar("We are getting in contact with your utility service provider.")
            //                     alert("Customer has completed the form");
            storage.rawSet("BayouContactId", event.data.id)
            updateDealStageIl("984278685")
            bayouToken = onbToken
            bayouTokenType = event.type
            bayouUtility = event.data.utility
            bayouId = event.data.id
            setTimeout(() => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
              getAccountNumberByWebhook(onboardingToken, event.type, event.data.utility, event.data.id)
            }, 5000)
          } else if (event.type === "customerEnteredInvalidCredentials") {
            closeNoAccountAlert()
            mfaRequired = "No"
            //                         alert("Customer entered invalid credentials");
            if (customerTriedCount >= 3) {
              //                             saveLaterOpenLoader();
            } else {
              customerTriedCount++
            }
            verifyidenty = "no"

            // --------- append manual account number field if did not found any account number
            credNotVerified = true
            document.querySelector("#have-online-details iframe").style.display = "none"
            document.querySelector(".utilityAccountNoWrapper").style.display = "block"
            manualAccountNumber = true
            closeProgressBar()
            openNoAccountAlert()
            manualFieldsForNoAccountFound()
            // --------- append manual account number field if did not found any account number
          } else if (event.type === "customerEnteredInvalidMFAChallenge") {
            closeNoAccountAlert()
            mfaRequired = "Yes"
            //                         alert("Customer entered invalid MFA challenge");
            if (customerTriedCount >= 3) {
              //                             saveLaterOpenLoader();
            } else {
              customerTriedCount++
            }
            verifyidenty = "no"

            // --------- append manual account number field if did not found any account number
            credNotVerified = true
            document.querySelector("#have-online-details iframe").style.display = "none"
            document.querySelector(".utilityAccountNoWrapper").style.display = "block"
            manualAccountNumber = true
            closeProgressBar()
            openNoAccountAlert()
            manualFieldsForNoAccountFound()
            // --------- append manual account number field if did not found any account number
          }
        },
      )
      closeProgressBar()
    } catch (error) {
      verifyidenty = "no"
      closeProgressBar()
      console.error("Error calling API:", error)
    }
  }
  async function BayouCreateCustomer() {
__ea_trace("modules/usage/usage-il-bayou.ts","BayouCreateCustomer",[],[]);
    var _UtilitySessionDetails = JSON.parse(storage.rawGet("UtilitySessionDetails"))
    var _ContactId = storage.rawGet("contactId")
    verifyidenty = "no"
    var _dealId = storage.rawGet("dealId")
    var onbToken = storage.rawGet("onboarding_token")

    await getTokenAndDateStamp()
    var _tokenCreatedDate = storage.rawGet("dateStamp")
    var _currentDate = getCurrentDate()
    function isNineDaysPassed(tokenCreatedDate) {
__ea_trace("modules/usage/usage-il-bayou.ts","isNineDaysPassed",[tokenCreatedDate],["tokenCreatedDate"]);
      const created = new Date(tokenCreatedDate)
      const today = new Date()

      // Calculate difference in milliseconds
      const diffInMs = today - created

      // Convert to days
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

      return diffInDays >= 9
    }

    var tokenCreatedDate = storage.rawGet("dateStamp") // e.g., "04/28/2025"
    if (tokenCreatedDate && isNineDaysPassed(tokenCreatedDate)) {
      await BayouGetCustomersWhenTokenExpire()
    } else {
      Bayou.loadOnboardingForm(
        document.getElementById("have-online-details"),
        60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
        onbToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
        (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
          document.getElementById("verification-error-message").innerHTML = ""
          if (event.type === "customerHasAuthenticated") {
            closeNoAccountAlert()
            credNotVerified = false
            mfaRequired = "No"
            openProgressBar("We are getting in contact with your utility service provider.")
            //                     alert("Customer has completed the form");
            storage.rawSet("BayouContactId", event.data.id)
            updateDealStageIl("984278685")
            bayouToken = onbToken
            bayouTokenType = event.type
            bayouUtility = event.data.utility
            bayouId = event.data.id
            setTimeout(() => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
              getAccountNumberByWebhook(onbToken, event.type, event.data.utility, event.data.id)
            }, 5000)
          } else if (event.type === "customerEnteredInvalidCredentials") {
            closeNoAccountAlert()
            mfaRequired = "No"
            //                         alert("Customer entered invalid credentials");
            if (customerTriedCount >= 3) {
              //                             saveLaterOpenLoader();
            } else {
              customerTriedCount++
            }
            verifyidenty = "no"

            // --------- append manual account number field if did not found any account number
            credNotVerified = true
            document.querySelector("#have-online-details iframe").style.display = "none"
            document.querySelector(".utilityAccountNoWrapper").style.display = "block"
            manualAccountNumber = true
            closeProgressBar()
            openNoAccountAlert()
            manualFieldsForNoAccountFound()
            // --------- append manual account number field if did not found any account number
          } else if (event.type === "customerEnteredInvalidMFAChallenge") {
            closeNoAccountAlert()
            mfaRequired = "Yes"
            //                         alert("Customer entered invalid MFA challenge");
            if (customerTriedCount >= 3) {
              //                             saveLaterOpenLoader();
            } else {
              customerTriedCount++
            }
            verifyidenty = "no"

            // --------- append manual account number field if did not found any account number
            credNotVerified = true
            document.querySelector("#have-online-details iframe").style.display = "none"
            document.querySelector(".utilityAccountNoWrapper").style.display = "block"
            manualAccountNumber = true
            closeProgressBar()
            openNoAccountAlert()
            manualFieldsForNoAccountFound()
            // --------- append manual account number field if did not found any account number
          }
        },
      )
    }
    await getAvailability()
    //         closeProgressBar();
  }
  /* --------------- for first enrollment ----------------------- */

  /* --------------- for multi enrollment ----------------------- */
  async function GetDataFromDealRecordMulti() {
__ea_trace("modules/usage/usage-il-bayou.ts","GetDataFromDealRecordMulti",[],[]);
    await updateDealStageIl("984278684")
    openProgressBar("We are getting in contact with your utility service provider.")
    await BayouGetCustomers()
    //         var email = storage.rawGet("userEmail");
    var bId = storage.rawGet("BayouContactId")
    if (bId === "" || bId === undefined || bId == null) {
      storage.rawSet("BayouContactId", storage.rawGet("bayou_contact_id"))
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        var _doYouHaveAccount = dataa.userValue.properties.do_you_have_an_account_with_utility_service_provider
        var _dealStage = dataa.userValue.properties.dealstage
        var manualUsageEntry = dataa.userValue.properties.manual_usage_entry
        if (manualUsageEntry === "Yes") {
          var msad = dataa.userValue.properties.mail_street_address
          var msad2 = dataa.userValue.properties.mail_street_address_2
          var mct = dataa.userValue.properties.mail_city
          var mst = dataa.userValue.properties.mail_state
          var mpcd = dataa.userValue.properties.mail_postal_code
          var mtku = dataa.userValue.properties.manual_total_kwh_usage
          var _mrstd = dataa.userValue.properties.manual_reading_start_date
          var _mred = dataa.userValue.properties.manual_reading_end_date
          var st = dataa.userValue.properties.street_address
          var st2 = dataa.userValue.properties.street_address_2
          var ct = dataa.userValue.properties.city
          var ssab = dataa.userValue.properties.service_state_abbreviation
          var pcd = dataa.userValue.properties.postal_code
          var _cnty = dataa.userValue.properties.county
          var uan1V = dataa.userValue.properties.uan_1_value
          var uan2V = dataa.userValue.properties.uan_2_value
          document.querySelector("#mailingAddress").innerHTML = msad
          document.querySelector("#mailingAddress2").innerHTML = msad2
          document.querySelector("#mailingCity").innerHTML = mct
          document.querySelector("#mailingState").innerHTML = mst
          document.querySelector("#mailingZipCode").innerHTML = mpcd
          if (mtku !== undefined && mtku != null && mtku !== "undefined" && mtku !== "null") {
            document.querySelector("#totalKwhUsage").innerHTML = mtku
          }
          document.querySelector("#serviceAddress").innerHTML = st
          document.querySelector("#serviceAddress2").innerHTML = st2
          document.querySelector("#serviceCity").innerHTML = ct
          document.querySelector("#serviceState").innerHTML = ssab
          document.querySelector("#serviceZipCode").innerHTML = pcd

          document.querySelector("#utilityAccountNo0").innerHTML = uan1V
          document.querySelector("#utilityAccountNo1").innerHTML = uan2V
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function BayouGetCustomers() {
__ea_trace("modules/usage/usage-il-bayou.ts","BayouGetCustomers",[],[]);
    var bayou_reason = storage.rawGet("bayou_reason")
    var _UtilitySessionDetails = JSON.parse(storage.rawGet("UtilitySessionDetails"))
    var bayouContactId = storage.rawGet("bayou_contact_id")
    var _dealId = storage.rawGet("dealId")
    const hensonApiUrl = `https://hansen.danmarcrm.com/getContactByID.php?contact_id=${bayouContactId}`
    const requestBody = {
      contact_id: bayouContactId,
    }
    var catchdata = ""
    try {
      const response = await fetch(hensonApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
      catchdata = requestBody
      var responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)
      if (bayou_reason == null || bayou_reason === undefined || bayou_reason === "" || "null") {
        const _accountNumbers = responseData.account_numbers.map((account) => account.id)
        const accountDetails = responseData.account_numbers.map((account) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[account],["account"]);
          return {
            account_number: account.id,
            meters: account.meters.map((meter) => ({
              id: meter.id,
              type: meter.type,
              tariffs: meter.tariffs,
              address: meter.address,
              additional_attributes: meter.additional_attributes,
            })),
          }
        })
        if (accountDetails.length > 0) {
          updateDealStageIl("984278685")
          if (accountDetails.length === 1) {
            findmultiAccountNumber(storage.rawGet("contactId"), accountDetails, accountDetails)
          } else if (accountDetails.length > 1) {
            findmultiAccountNumber(storage.rawGet("contactId"), accountDetails, accountDetails)
          }
        } else {
          credNotVerified = false
          document.querySelector("#have-online-details iframe").style.display = "none"
          document.querySelector(".utilityAccountNoWrapper").style.display = "block"
          manualAccountNumber = true
          await manualFieldsForNoAccountFound()
          closeProgressBar()
        }
        await getAvailability()
      } else {
        await getTokenAndDateStamp()
        var _tokenCreatedDate = storage.rawGet("dateStamp")
        var _currentDate = getCurrentDate()
        function isNineDaysPassed(tokenCreatedDate) {
__ea_trace("modules/usage/usage-il-bayou.ts","isNineDaysPassed",[tokenCreatedDate],["tokenCreatedDate"]);
          const created = new Date(tokenCreatedDate)
          const today = new Date()

          // Calculate difference in milliseconds
          const diffInMs = today - created

          // Convert to days
          const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

          return diffInDays >= 9
        }

        var tokenCreatedDate = storage.rawGet("dateStamp") // e.g., "04/28/2025"
        if (tokenCreatedDate && isNineDaysPassed(tokenCreatedDate)) {
          await BayouGetCustomersWhenTokenExpire()
        } else {
          var onbToken = storage.rawGet("onboarding_token")
          Bayou.loadOnboardingForm(
            document.getElementById("have-online-details"),
            60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
            onbToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
            (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
              document.getElementById("verification-error-message").innerHTML = ""
              if (event.type === "customerHasAuthenticated") {
                closeNoAccountAlert()
                credNotVerified = false
                mfaRequired = "No"
                openProgressBar("We are getting in contact with your utility service provider.")
                storage.rawSet("BayouContactId", event.data.id)
                updateDealStageIl("984278685")
                bayouToken = onbToken
                bayouTokenType = event.type
                bayouUtility = event.data.utility
                bayouId = event.data.id
                setTimeout(() => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
                  getAccountNumberByWebhook(onbToken, event.type, event.data.utility, event.data.id)
                }, 5000)
              } else if (event.type === "customerEnteredInvalidCredentials") {
                closeNoAccountAlert()
                mfaRequired = "No"
                if (customerTriedCount >= 3) {
                  //                                     saveLaterOpenLoader();
                } else {
                  customerTriedCount++
                }
                verifyidenty = "no"

                // --------- append manual account number field if did not found any account number
                credNotVerified = true
                document.querySelector("#have-online-details iframe").style.display = "none"
                document.querySelector(".utilityAccountNoWrapper").style.display = "block"
                manualAccountNumber = true
                closeProgressBar()
                openNoAccountAlert()
                manualFieldsForNoAccountFound()
                // --------- append manual account number field if did not found any account number
              } else if (event.type === "customerEnteredInvalidMFAChallenge") {
                closeNoAccountAlert()
                mfaRequired = "Yes"
                if (customerTriedCount >= 3) {
                } else {
                  customerTriedCount++
                }
                verifyidenty = "no"

                // --------- append manual account number field if did not found any account number
                credNotVerified = true
                document.querySelector("#have-online-details iframe").style.display = "none"
                document.querySelector(".utilityAccountNoWrapper").style.display = "block"
                manualAccountNumber = true
                closeProgressBar()
                openNoAccountAlert()
                manualFieldsForNoAccountFound()
                // --------- append manual account number field if did not found any account number
              } else {
              }
            },
          )
        }
        await getAvailability()
        //                 closeProgressBar();
      }
      if (response.status === 500 || response.status === 404) {
        credNotVerified = false
        verifyidenty = "no"
        document.querySelector("#have-online-details").style.display = "none"
        document.querySelector("#have-online-details iframe").style.display = "none"
        document.querySelector(".utilityAccountNoWrapper").style.display = "block"
        manualAccountNumber = true
        //                 alert("We’ve validated your login credentials, but we are unable to get your billing and electricity usage information.");
        await manualFieldsForNoAccountFound()
        closeProgressBar()
      }
    } catch (error) {
      credNotVerified = false
      verifyidenty = "no"
      document.querySelector("#have-online-details").style.display = "none"
      document.querySelector("#have-online-details iframe").style.display = "none"
      document.querySelector(".utilityAccountNoWrapper").style.display = "block"
      manualAccountNumber = true
      await manualFieldsForNoAccountFound()
      closeProgressBar()
      console.error("Error calling API:", error)
    }
  }
  async function _findsingleAccountNumber(_contactId, accountnumber, responseData) {
__ea_trace("modules/usage/usage-il-bayou.ts","_findsingleAccountNumber",[_contactId,accountnumber,responseData],["_contactId","accountnumber","responseData"]);
    var property = "uan_1_value"
    var value = accountnumber
    const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ property, value }),
    })
    const data = await response.json()
    responseFromAPI = JSON.stringify(data)
    if (response.ok) {
      if (data.total === 0 || data.total === undefined) {
        //                 document.querySelector('#SkipThisFornNow').style.display = "none";
        await getDataFromUANConfigTable()
        //                 alert("Account number not exists.");
        firstId = accountnumber
        bayouAccountNo = firstId
        responseData.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
          if (item.meters.length === 1) {
            item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
              verifyidenty = "yes"
              var mtType = meter.type
              mtType = mtType.toUpperCase()
              if (mtType === "ELECTRIC") {
                meterId = meter.id
                meterType = meter.type
                rateClass = meter.tariffs[0].tariff
                if (meter.additional_attributes != null) {
                  additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                }
              } else {
                meterId = ""
                meterType = ""
                rateClass = ""
                additionalAttributeValue = ""
              }
            })
          } else if (item.meters.length > 1) {
            var _ifelectricMetermorethan1 = 0
            var div = document.createElement("div")
            div.classList.add("meterWrapper")
            var h4 = document.createElement("h4")
            h4.textContent = "Please select Additional Attributes"
            div.appendChild(h4)
            const meterul = document.createElement("ul")
            meterul.id = "meterList"
            item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
              const meterli = document.createElement("li")
              var mtType = meter.type
              mtType = mtType.toUpperCase()
              if (mtType === "ELECTRIC") {
                meterli.id = `${meter.id}`
                meterli.type = meter.type
                meterli.setAttribute("tariff", meter.tariffs[0].tariff)
                if (meter.additional_attributes != null) {
                  meterli.setAttribute(
                    "aa",
                    meter.additional_attributes[additionalAttributeItem]
                      ? meter.additional_attributes[additionalAttributeItem]
                      : "",
                  )
                }
                _ifelectricMetermorethan1++
                meterId = `${meter.id}`
                meterType = meter.type
                rateClass = meter.tariffs[0].tariff
                if (meter.additional_attributes != null) {
                  div.classList.remove("hidden")
                  if (
                    additionalAttributeValue !== "" &&
                    additionalAttributeValue != null &&
                    additionalAttributeValue !== undefined
                  ) {
                    if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                      div.classList.add("hidden")
                    } else {
                      div.classList.remove("hidden")
                    }
                  } else {
                    div.classList.add("hidden")
                  }
                  additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                } else {
                  div.classList.add("hidden")
                }
                //                                 meterli.textContent = `${meter.id}`;
                if (additionalAttributeValue == null) {
                  additionalAttributeValue = ""
                }
                meterli.textContent = additionalAttributeValue
                meterul.appendChild(meterli)
              }
            })
            const meterWrapper = document.querySelector(".meterWrapper")
            if (!meterWrapper.classList.contains("hidden")) {
              div.appendChild(meterul)
              document.querySelector(".have-online-details").appendChild(div)
              function handleClick(event) {
__ea_trace("modules/usage/usage-il-bayou.ts","handleClick",[event],["event"]);
                selectMeter(event)
              }
              document.querySelectorAll("#meterList li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
                li.addEventListener("click", handleClick)
              })
            } else {
              verifyidenty = "yes"
            }
          }
        })
      } else if (data.total === 1) {
        var dealIdFromDealFound = data.results[0].id
        var dealIdFromCurrentPage = storage.rawGet("dealId")
        if (dealIdFromDealFound === dealIdFromCurrentPage) {
          await getDataFromUANConfigTable()
          firstId = accountnumber
          bayouAccountNo = firstId
          responseData.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
            if (item.meters.length === 1) {
              item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
                verifyidenty = "yes"
                var mtType = meter.type
                mtType = mtType.toUpperCase()
                if (mtType === "ELECTRIC") {
                  meterId = meter.id
                  meterType = meter.type
                  rateClass = meter.tariffs[0].tariff
                  if (meter.additional_attributes != null) {
                    additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                  }
                } else {
                  meterId = ""
                  meterType = ""
                  rateClass = ""
                  additionalAttributeValue = ""
                }
              })
            } else if (item.meters.length > 1) {
              var _ifelectricMetermorethan1 = 0
              var div = document.createElement("div")
              div.classList.add("meterWrapper")
              var h4 = document.createElement("h4")
              h4.textContent = "Please select Additional Attributes"
              div.appendChild(h4)
              const meterul = document.createElement("ul")
              meterul.id = "meterList"
              item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
                const meterli = document.createElement("li")
                var mtType = meter.type
                mtType = mtType.toUpperCase()
                if (mtType === "ELECTRIC") {
                  meterli.id = `${meter.id}`
                  meterli.type = meter.type
                  meterli.setAttribute("tariff", meter.tariffs[0].tariff)
                  if (meter.additional_attributes != null) {
                    meterli.setAttribute(
                      "aa",
                      meter.additional_attributes[additionalAttributeItem]
                        ? meter.additional_attributes[additionalAttributeItem]
                        : "",
                    )
                  }
                  _ifelectricMetermorethan1++
                  meterId = `${meter.id}`
                  meterType = meter.type
                  rateClass = meter.tariffs[0].tariff
                  if (meter.additional_attributes != null) {
                    div.classList.remove("hidden")
                    if (
                      additionalAttributeValue !== "" &&
                      additionalAttributeValue != null &&
                      additionalAttributeValue !== undefined
                    ) {
                      if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                        div.classList.add("hidden")
                      } else {
                        div.classList.remove("hidden")
                      }
                    } else {
                      div.classList.add("hidden")
                    }
                    additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                  } else {
                    div.classList.add("hidden")
                  }
                  if (additionalAttributeValue == null) {
                    additionalAttributeValue = ""
                  }
                  meterli.textContent = additionalAttributeValue
                  meterul.appendChild(meterli)
                }
              })
              const meterWrapper = document.querySelector(".meterWrapper")
              if (!meterWrapper.classList.contains("hidden")) {
                div.appendChild(meterul)
                document.querySelector(".have-online-details").appendChild(div)
                function handleClick(event) {
__ea_trace("modules/usage/usage-il-bayou.ts","handleClick",[event],["event"]);
                  selectMeter(event)
                }
                document.querySelectorAll("#meterList li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
                  li.addEventListener("click", handleClick)
                })
              } else {
                verifyidenty = "yes"
              }
            }
          })
        } else {
          verifyidenty = "no"
          passUpdatedOpenLoader()
        }
      } else {
        verifyidenty = "no"
        passUpdatedOpenLoader()
      }
    }
  }
  async function findmultiAccountNumber(_contactId, _accountnumber, responseData) {
__ea_trace("modules/usage/usage-il-bayou.ts","findmultiAccountNumber",[_contactId,_accountnumber,responseData],["_contactId","_accountnumber","responseData"]);
    await getDataFromUANConfigTable()
    var Accdiv = document.createElement("div")
    var h2 = document.createElement("h2")
    h2.textContent = "Please select Account Number"
    Accdiv.appendChild(h2)
    const accul = document.createElement("ul")
    accul.classList.add("accountNumbersUl")
    var existAccNoLength = 0

    for (const item of responseData) {
      const accli = document.createElement("li")
      const accspan = document.createElement("span")
      accli.classList.add(`acc${item.account_number}`) // Add class to li
      accli.style.display = "none"
      accspan.textContent = item.account_number
      accli.id = item.account_number
      accli.appendChild(accspan)
      if (item.meters.length >= 1) {
        var div = document.createElement("div")
        div.classList.add("meterWrapper")
        var h4 = document.createElement("h4")
        h4.textContent = "Please select Additional Attributes"
        div.appendChild(h4)
        div.id = `meterId${item.account_number}`
        const meterul = document.createElement("ul")
        meterul.id = "meterList"
        item.meters.forEach((meter) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[meter],["meter"]);
          const meterli = document.createElement("li")
          var mtType = meter.type
          mtType = mtType.toUpperCase()
          if (mtType === "ELECTRIC") {
            accli.style.display = "block"
            meterli.id = `${meter.id}`
            meterli.type = meter.type
            meterli.setAttribute("city", meter.address.city)
            meterli.setAttribute("state", meter.address.state)
            meterli.setAttribute("line_1", meter.address.line_1)
            meterli.setAttribute("line_2", meter.address.line_2)
            meterli.setAttribute("country", meter.address.country)
            meterli.setAttribute("postal_code", meter.address.postal_code)
            meterli.setAttribute("tariff", meter.tariffs[0].tariff)
            if (meter.additional_attributes !== undefined) {
              if (meter.additional_attributes != null) {
                meterli.setAttribute(
                  "aa",
                  meter.additional_attributes[additionalAttributeItem]
                    ? meter.additional_attributes[additionalAttributeItem]
                    : "",
                )
              }
            }
            meterId = `${meter.id}`
            meterType = meter.type
            rateClass = meter.tariffs[0].tariff
            meterCity = meter.address.city
            meterState = meter.address.state
            meterLine1 = meter.address.line_1
            meterLine2 = meter.address.line_2
            _meterCountry = meter.address.country
            meterPostalCode = meter.address.postal_code
            var resultT = getValidTariff(meter)
            if (resultT.isMoreThanOneYear === true) {
              accli.style.display = "none" // hide
            } else {
              accli.style.display = "block" // show
            }
            if (meter.additional_attributes !== undefined) {
              if (meter.additional_attributes[additionalAttributeItem] != null) {
                accli.classList.remove("hidden")
                div.classList.remove("hidden")
                if (
                  additionalAttributeValue !== "" &&
                  additionalAttributeValue != null &&
                  additionalAttributeValue !== undefined
                ) {
                  if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                    div.classList.add("hidden")
                  } else {
                    div.classList.remove("hidden")
                  }
                } else {
                  div.classList.add("hidden")
                }
                additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
              } else {
                div.classList.add("hidden")
                if (storage.rawGet("utility_id") === "COMED-SF") {
                  accli.classList.add("hidden")
                } else {
                  accli.classList.remove("hidden")
                }
                if (storage.rawGet("utility_id") === "AMCIPS-SF") {
                  document.querySelector("#serviceAddAtt").style.display = "none"
                  document.querySelector(".serviceAddAttLabel").style.display = "none"
                } else {
                  document.querySelector("#serviceAddAtt").style.display = "block"
                  document.querySelector(".serviceAddAttLabel").style.display = "block"
                }
              }
            } else {
              //                             div.classList.add('hidden');
              if (storage.rawGet("utility_id") === "COMED-SF") {
                accli.classList.add("hidden")
              } else {
                accli.classList.remove("hidden")
              }
              if (storage.rawGet("utility_id") === "AMCIPS-SF") {
                document.querySelector("#serviceAddAtt").style.display = "none"
                document.querySelector(".serviceAddAttLabel").style.display = "none"
              } else {
                document.querySelector("#serviceAddAtt").style.display = "block"
                document.querySelector(".serviceAddAttLabel").style.display = "block"
              }
            }
            if (additionalAttributeValue == null) {
              additionalAttributeValue = ""
            }
            meterli.textContent = additionalAttributeValue
            meterul.appendChild(meterli)
            div.appendChild(meterul)
            accli.appendChild(div)
          }
        })
      }
      var property = "uan_1_value"
      var value = item.account_number
      const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ property, value }),
      })
      const data = await response.json()
      responseFromAPI = JSON.stringify(data)
      if (response.ok) {
        if (data.total === 0 || data.total === undefined) {
        } else if (data.total === 1) {
          var dealIdFromDealFound = data.results[0].id
          var dealIdFromCurrentPage = storage.rawGet("dealId")
          if (dealIdFromDealFound === dealIdFromCurrentPage) {
          } else {
            ++existAccNoLength
            accli.style.cursor = "not-allowed"
            accli.style.pointerEvents = "none"
            accli.style.color = "#999"
            accli.style.opacity = "0.5"
          }
        } else {
          ++existAccNoLength
          accli.style.cursor = "not-allowed"
          accli.style.pointerEvents = "none"
          accli.style.color = "#999"
          accli.style.opacity = "0.5"
        }
      }
      accul.appendChild(accli)
      Accdiv.appendChild(accul)
      document.querySelector(".have-online-details").appendChild(Accdiv)
    }
    if (existAccNoLength === responseData.length) {
      verifyidenty = "no"
      passUpdatedOpenLoader()
    }
    document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
      li.style.display = "none"
    })
    function accountNumberSelected(event) {
__ea_trace("modules/usage/usage-il-bayou.ts","accountNumberSelected",[event],["event"]);
      document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
        span.style.backgroundColor = "#ffffff"
      })
      document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
        li.style.display = "none"
      })
      const clickedElement = event.target
      firstId = clickedElement.parentElement.id
      bayouAccountNo = firstId
      const meterWrapper = clickedElement.parentElement.querySelector(".meterWrapper")
      const ulElement = meterWrapper.querySelector("ul")
      const liElements = ulElement.querySelectorAll("li")
      const numberOfLi = liElements.length
      if (numberOfLi === 1) {
        verifyidenty = "yes"
        meterWrapper.style.display = "none"
        liElements.forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
          meterId = li.id
          meterType = li.type
          meterCity = li.getAttribute("city")
          meterState = li.getAttribute("state")
          meterLine1 = li.getAttribute("line_1")
          meterLine2 = li.getAttribute("line_2")
          _meterCountry = li.getAttribute("country")
          meterPostalCode = li.getAttribute("postal_code")
          additionalAttributeValue = li.getAttribute("aa")
          if (li.tariffs) {
            rateClass = li.tariffs[0].tariff
          }
        })
      } else {
        ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
          span.style.backgroundColor = "#ffffff"
        })
        meterWrapper.style.display = "block"
        ulElement.querySelectorAll("li").forEach((li) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[li],["li"]);
          li.addEventListener("click", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
            verifyidenty = "yes"
            ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
              span.style.backgroundColor = "#ffffff"
            })
            this.style.backgroundColor = "#f18020"
            meterId = this.id
            meterType = this.type
            meterCity = this.getAttribute("city")
            meterState = this.getAttribute("state")
            meterLine1 = this.getAttribute("line_1")
            meterLine2 = this.getAttribute("line_2")
            _meterCountry = this.getAttribute("country")
            meterPostalCode = this.getAttribute("postal_code")
            additionalAttributeValue = this.getAttribute("aa")
            if (this.tariffs) {
              rateClass = this.tariffs[0].tariff
            }
          })
        })
      }
      clickedElement.style.backgroundColor = "#f18020"
      document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
        span.removeAttribute("data-selected")
      })
      clickedElement.setAttribute("data-selected", "true")
      if (meterLine2 == null || meterLine2 === "null") {
        meterLine2 = ""
      }

      document.querySelector(".selectedItemDetails #name").value = meterType
      document.querySelector(".selectedItemDetails #name").disabled = true

      if (
        meterLine1 == null ||
        meterLine1 === "" ||
        meterLine1 === undefined ||
        meterLine1 === "null" ||
        meterLine1 === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceAddress").disabled = false
        document
          .querySelector(".selectedItemDetails > .serviceAddress")
          .addEventListener("input", validateServiceAddress1)
      } else {
        document.querySelector(".selectedItemDetails #serviceAddress").value = meterLine1
        document.querySelector(".selectedItemDetails #serviceAddress").disabled = true
      }

      if (
        meterLine2 == null ||
        meterLine2 === "" ||
        meterLine2 === undefined ||
        meterLine2 === "null" ||
        meterLine2 === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceAddress2").disabled = false
      } else {
        document.querySelector(".selectedItemDetails #serviceAddress2").disabled = true
        document.querySelector(".selectedItemDetails #serviceAddress2").value = meterLine2
      }

      if (
        meterCity == null ||
        meterCity === "" ||
        meterCity === undefined ||
        meterCity === "null" ||
        meterCity === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceCity").disabled = false
        document.querySelector(".selectedItemDetails > .serviceCity").addEventListener("input", validateServiceCity)
      } else {
        document.querySelector(".selectedItemDetails #serviceCity").disabled = true
        document.querySelector(".selectedItemDetails #serviceCity").value = meterCity
      }

      if (
        meterState == null ||
        meterState === "" ||
        meterState === undefined ||
        meterState === "null" ||
        meterState === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceState").disabled = false
        document.querySelector(".selectedItemDetails > .serviceState").addEventListener("input", validateServiceState)
      } else {
        document.querySelector(".selectedItemDetails #serviceState").disabled = true
        document.querySelector(".selectedItemDetails #serviceState").value = meterState
      }

      if (
        meterPostalCode == null ||
        meterPostalCode === "" ||
        meterPostalCode === undefined ||
        meterPostalCode === "null" ||
        meterPostalCode === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceZipCode").disabled = false
        document
          .querySelector(".selectedItemDetails > .serviceZipCode")
          .addEventListener("input", validateServiceZipCode)
      } else {
        document.querySelector(".selectedItemDetails #serviceZipCode").disabled = true
        document.querySelector(".selectedItemDetails #serviceZipCode").value = meterPostalCode
      }

      if (
        additionalAttributeValue == null ||
        additionalAttributeValue === "" ||
        additionalAttributeValue === undefined ||
        additionalAttributeValue === "null" ||
        additionalAttributeValue === "NULL"
      ) {
        document.querySelector(".selectedItemDetails #serviceAddAtt").disabled = false
        document.querySelector(".selectedItemDetails > .serviceAddAtt").addEventListener("input", validateServiceAddAtt)
      } else {
        document.querySelector(".selectedItemDetails #serviceAddAtt").disabled = true
        document.querySelector(".selectedItemDetails #serviceAddAtt").value = additionalAttributeValue
      }

      document.querySelector(".selectedItemDetails").style.display = "block"
      document.getElementById("addressSameCheckbox").addEventListener("change", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
        const content = document.querySelector(".selectedItemDetails .mailingItems")
        if (this.checked) {
          content.style.display = "none" // Show content
        } else {
          content.style.display = "block" // Hide content
        }
      })
    }
    document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[span],["span"]);
      span.addEventListener("click", accountNumberSelected)
    })
    closeProgressBar()
  }

  // If user is not logedIn then redirected them to login page -------------------------------------------------
  function getEmail() {
__ea_trace("modules/usage/usage-il-bayou.ts","getEmail",[],[]);
    var storedEmail = storage.rawGet("userEmail")
    if (!storedEmail) {
      window.location.href = "/"
      return false
    }
  }
  getEmail()
  // If user is not logedIn then redirected them to login page -------------------------------------------------

  var _selectRadioValue
  var isChecked = false
  var _storedDisplayElementList = JSON.parse(storage.rawGet("usageDisplayelementList"))
  var _storedRequireElementList = JSON.parse(storage.rawGet("usagerequireElementList"))
  var _shouldValidate = false

  /* utilityNumberRegexFromSessionTable */
  var UtilityAccountNumberRegexErrorMsg = []
  var utRgxNumber = []
  var utRgxNumberInput
  var UtilityAccountNumberRegexErrorMsgInput
  var uanSingleValue = ""
  var uanSingleErrorMsgField
  var clickutilityAccountInputs
  var allAccountNumbers = []
  var uanAllLabels = []
  var uanFieldDefault = []
  var uanFieldDisplayarray = []
  var uanFieldIntDesArray = []
  /* utilityNumberRegexFromSessionTable */

  // get data from UAN config table ----------------------------------------------------
  async function getallDataFromUANConfigTable() {
__ea_trace("modules/usage/usage-il-bayou.ts","getallDataFromUANConfigTable",[],[]);
    var exampleUtilityId = storage.rawGet("utility_id")
    var stateForUANConfig = storage.rawGet("stateForLMIConfig")
    var utilityNameForUANConfig = storage.rawGet("utility_Name")
    const hubDBEndpointUANC = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.uanConfig}/rows?portalId=${window.__ENV__.dataPortalId}&orderBy=uan_field_display_sequence&utility_id=${exampleUtilityId}&state_name=${stateForUANConfig}`
    const responseUANC = await fetch(hubDBEndpointUANC, { method: "GET" })
    const dataUANC = await responseUANC.json()
    const rowsUANC = dataUANC.objects
    if (rowsUANC.length >= 1) {
      rowsUANC.forEach((element, index) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[element,index],["element","index"]);
        var uanFieldDisplay = element.values["4"].name
        if (uanFieldDisplay === "Yes") {
          uanFieldDefault[index] = element.values["5"]
          uanFieldDisplayarray[index] = element.values["4"].name
          var _uanFieldDisSeq = element.values["6"]
          var uanFieldLable = element.values["8"]
          uanAllLabels[index] = uanFieldLable
          var uanFieldIntDes = element.values["8"]
          uanFieldIntDesArray[index] = element.values["8"]
          var uanFieldHlpTxtHeading = element.values["9"]
          var uanFieldHlpTxtInst = element.values["10"]
          utRgxNumber[index] = element.values["11"]
          UtilityAccountNumberRegexErrorMsg[index] = element.values["12"]
          var uanFieldHelpImgTxt = element.values["13"]
          var uanHelpImg = ""
          if (element.values["14"] !== undefined) {
            uanHelpImg = element.values["14"].url
          }
          var _uanConctSeq = element.values["15"]
          var appendField = `<div class="utilityAccountNoWrapper" id="utilityAccountNoWrapper${index}"><label id="MUuaclabel${index}"><span id="utilityAccountNoLabel${index}">${uanFieldLable}</span></label><input type="text" key="${index}" placeholder="${uanFieldIntDes}" class="utilityAccountNo" id="utilityAccountNo${index}" /><div id="utility_acc_num_error_message${index}" class="error-message"></div><p id="utilityAccInsTitle${index}">${uanFieldHlpTxtHeading}</p><p><span class="utilityAccIns${index}">${uanFieldHlpTxtInst}</span><br><br><a href="${uanHelpImg}" id="utilityBillImageAcNo${index}" target="_blank">${uanFieldHelpImgTxt} <span class="utilityName${index}">${utilityNameForUANConfig}</span>.</a></p></div>`
          var existingContent = document.querySelector(".manualAccountFields").innerHTML
          var appendedContent = existingContent + appendField
          document.querySelector(".manualAccountFields").innerHTML = appendedContent
          // getUtilityNumberRegex(uanFieldReg);
          if (index === rowsUANC.length - 1) {
            if (stateForUANConfig === "Illinois") {
              var newElecLabel = element.values["17"]
              var newElecHelpText = element.values["18"]
              var startDateLabel = element.values["19"]
              var startDateHelpText = element.values["20"]
              var endDateLabel = element.values["21"]
              var endDateHelpText = element.values["22"]
              var newElecUsageLabel = element.values["23"]
              var newElecUsageHelpText = element.values["24"]
              var newElecUsageHelpImageText = element.values["25"]
              var newElecUsageHelpImage = ""
              if (element.values["26"] !== undefined) {
                newElecUsageHelpImage = element.values["26"].url
              }

              if (newElecLabel !== "undefined" && newElecLabel !== undefined) {
                document.querySelector("#euiLabel").innerHTML = newElecLabel
              }
              if (newElecHelpText !== "undefined" && newElecHelpText !== undefined) {
                document.querySelector("#euiHelpText").innerHTML = newElecHelpText
              }
              if (startDateLabel !== "undefined" && startDateLabel !== undefined) {
                document.querySelector("#sdofbpLabel").innerHTML = startDateLabel
              }
              if (startDateHelpText !== "undefined" && startDateHelpText !== undefined) {
                document.querySelector("#sdofbpHelpText").innerHTML = startDateHelpText
              }
              if (endDateLabel !== "undefined" && endDateLabel !== undefined) {
                document.querySelector("#edomrbpLabel").innerHTML = endDateLabel
              }
              if (endDateHelpText !== "undefined" && endDateHelpText !== undefined) {
                document.querySelector("#edomrbpHelpText").innerHTML = endDateHelpText
              }
              if (newElecUsageLabel !== "undefined" && newElecUsageLabel !== undefined) {
                document.querySelector("#totalKwhUsageLabel").innerHTML = newElecUsageLabel
              }
              if (newElecUsageHelpText !== "undefined" && newElecUsageHelpText !== undefined) {
                document.querySelector("#totalKwhUsageHelpText").innerHTML = newElecUsageHelpText
              }
              document.querySelector("#totalKwhUsageHelpImageText").innerHTML =
                `<a target="_blank" href="${newElecUsageHelpImage}">${newElecUsageHelpImageText}</a>`
            }
          }
        } else if (uanFieldDisplay === "No") {
          uanFieldDefault[index] = element.values["5"]
          uanFieldDisplayarray[index] = element.values["4"].name
          uanFieldIntDesArray[index] = element.values["8"]
        }
      })
      uanSingleErrorMsgField = document.getElementById("utility_acc_num_error_message0")
      if (uanSingleErrorMsgField == null || uanSingleErrorMsgField === "null") {
        uanSingleErrorMsgField = document.getElementById("utility_acc_num_error_message1")
      }
      if (uanSingleErrorMsgField == null || uanSingleErrorMsgField === "null") {
        uanSingleErrorMsgField = document.getElementById("utility_acc_num_error_message2")
      }
      clickutilityAccountInputs = document.querySelectorAll(".utilityAccountNoWrapper .utilityAccountNo")
      const utilityAccountInputs = document.querySelectorAll(".utilityAccountNoWrapper .utilityAccountNo")
      utilityAccountInputs.forEach((input) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[input],["input"]);
        input.addEventListener("input", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
          const keyAttributeValue = input.getAttribute("key")
          const inputValue = event.target.value
          uanSingleValue = inputValue
          utRgxNumberInput = utRgxNumber[keyAttributeValue]
          UtilityAccountNumberRegexErrorMsgInput = UtilityAccountNumberRegexErrorMsg[keyAttributeValue]
          uanSingleErrorMsgField = document.getElementById(`utility_acc_num_error_message${keyAttributeValue}`)
          validateAccountNumber(null)
        })
      })
    }
  }
  // get data from UAN config table ----------------------------------------------------

  var globPass
  var enrollmentSessionID
  const utilityIdd = storage.rawGet("utility_id")
  var getConsumpionCount = 0

  function validateAccountNumber(abc) {
__ea_trace("modules/usage/usage-il-bayou.ts","validateAccountNumber",[abc],["abc"]);
    if (abc != null && abc !== "") {
      uanSingleErrorMsgField.textContent = ""
      isManualAccNumbsFilled = true
      return null
    } else {
      if (uanSingleValue !== "") {
        const regex = new RegExp(utRgxNumberInput)
        if (regex.test(uanSingleValue)) {
          uanSingleErrorMsgField.textContent = ""
          isManualAccNumbsFilled = true
          return null
        } else {
          if (UtilityAccountNumberRegexErrorMsgInput == null || UtilityAccountNumberRegexErrorMsgInput === "") {
            uanSingleErrorMsgField.textContent = "Please enter a valid account number."
          } else {
            uanSingleErrorMsgField.textContent = UtilityAccountNumberRegexErrorMsgInput
          }
          isManualAccNumbsFilled = false
          return "error"
        }
      } else {
        if (uanFieldDisplayarray.length === 0) {
          isManualAccNumbsFilled = true
          return null
        } else {
          uanSingleErrorMsgField.textContent = "Please enter account number."
          isManualAccNumbsFilled = false
          return "error"
        }
      }
    }
  }
  function checkAllUANFieldOnClick() {
__ea_trace("modules/usage/usage-il-bayou.ts","checkAllUANFieldOnClick",[],[]);
    var inputValueBoolean = false

    for (let index = 0; index < clickutilityAccountInputs.length; index++) {
      const input = clickutilityAccountInputs[index]
      const inputValue = input.value
      const nextElement = input.nextElementSibling.textContent
      if (nextElement === "" || nextElement == null) {
        if (inputValue) {
          inputValueBoolean = false
          allAccountNumbers[index] = inputValue
        } else {
          inputValueBoolean = true
          const keyAttributeValue = input.getAttribute("key")
          document.getElementById(`utility_acc_num_error_message${keyAttributeValue}`).textContent =
            "Please enter account number."
          break
        }
      } else {
        inputValueBoolean = true
        break
      }
    }
    if (inputValueBoolean) {
      return "error"
    } else {
      return true
    }
  }
  function getAccountNumberErrorifExist() {
__ea_trace("modules/usage/usage-il-bayou.ts","getAccountNumberErrorifExist",[],[]);
    var val = validateAccountNumber(firstId)
    var val2 = checkAllUANFieldOnClick()
    if (val === "error" || val2 === "error") {
      return "error"
    } else {
      return null
    }
  }
  function validateAddressFields() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateAddressFields",[],[]);
    var _nameField = document.querySelector(".selectedItemDetails #name").value.trim()
    var serviceAddressField = document.querySelector(".selectedItemDetails #serviceAddress").value.trim()
    var serviceCityField = document.querySelector(".selectedItemDetails #serviceCity").value.trim()
    var serviceStateField = document.querySelector(".selectedItemDetails #serviceState").value.trim()
    var serviceZipCodeField = document.querySelector(".selectedItemDetails #serviceZipCode").value.trim()
    var _serviceAddAttField = document.querySelector(".selectedItemDetails #serviceAddAtt").value.trim()
    var addressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
    var _mailingAddressField = document.querySelector(".selectedItemDetails #mailingAddress").value.trim()
    var _mailingCityField = document.querySelector(".selectedItemDetails #mailingCity").value.trim()
    var _mailingStateField = document.querySelector(".selectedItemDetails #mailingState").value.trim()
    var _mailingZipCodeField = document.querySelector(".selectedItemDetails #mailingZipCode").value.trim()
    if (verifyidenty === "yes") {
      if (serviceAddressField === "") {
        document.querySelector("#serviceAddress_error_message").innerHTML = "Service Address 1 is not found in response"
        return "error"
      } else if (serviceCityField === "") {
        document.querySelector("#serviceCity_error_message").innerHTML = "Service City is not found in response"
        return "error"
      } else if (serviceStateField === "") {
        document.querySelector("#serviceState_error_message").innerHTML = "Service State is not found in response"
        return "error"
      } else if (serviceZipCodeField === "") {
        document.querySelector("#serviceZipCode_error_message").innerHTML = "Service Zip Code is not found in response"
        return "error"
      } else if (serviceAddressField === "") {
        document.querySelector("#serviceAddAtt_error_message").innerHTML =
          "Service Attribution Code is not found in response"
        return "error"
      } else if (addressSameCheckboxField.checked) {
        return null
      } else {
        var ErrorValidationListt = [validateAddress1(), validateCity(), validateState(), validateZipCode()]
        if (ErrorValidationListt.includes("error")) {
          return "error"
        }
      }
    }
  }
  function validateManualAddressFields() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateManualAddressFields",[],[]);
    var addressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
    if (addressSameCheckboxField.checked) {
      if (isManualAccNumbsFilled === false) {
        const utilityAccountInputs = document.querySelectorAll(".utilityAccountNoWrapper .utilityAccountNo")
        utilityAccountInputs.forEach((input) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[input],["input"]);
          const keyAttributeValue = input.getAttribute("key")
          const inputValue = event.target.value
          uanSingleErrorMsgField = document.getElementById(`utility_acc_num_error_message${keyAttributeValue}`)
          if (inputValue == null || inputValue === "" || inputValue === undefined) {
            uanSingleErrorMsgField.innerHTML = "Please fix the error in this field"
          }
        })
        return "error"
      } else {
        var ErrorValidationListt = [
          validateServiceAddress1(),
          validateServiceCity(),
          validateServiceState(),
          validateServiceZipCode(),
          validateMonthYear("sdofbp", "edomrbp"),
          validateTotalKwhUsage(),
        ]
        if (ErrorValidationListt.includes("error")) {
          return "error"
        }
      }
    } else {
      if (isManualAccNumbsFilled === false) {
        const utilityAccountInputs = document.querySelectorAll(".utilityAccountNoWrapper .utilityAccountNo")
        utilityAccountInputs.forEach((input) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[input],["input"]);
          const keyAttributeValue = input.getAttribute("key")
          const inputValue = event.target.value
          uanSingleErrorMsgField = document.getElementById(`utility_acc_num_error_message${keyAttributeValue}`)
          if (inputValue == null || inputValue === "" || inputValue === undefined) {
            uanSingleErrorMsgField.innerHTML = "Please fix the error in this field"
          }
        })
        return "error"
      } else {
        var ErrorValidationListt = [
          validateServiceAddress1(),
          validateServiceCity(),
          validateServiceState(),
          validateServiceZipCode(),
          validateMonthYear("sdofbp", "edomrbp"),
          validateTotalKwhUsage(),
          validateAddress1(),
          validateCity(),
          validateState(),
          validateZipCode(),
        ]
        if (ErrorValidationListt.includes("error")) {
          return "error"
        }
      }
    }
  }

  function _validateHaveonline() {
__ea_trace("modules/usage/usage-il-bayou.ts","_validateHaveonline",[],[]);
    var radioButtons = document.getElementsByName("myInfoRadio")
    for (var i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        _selectRadioValue = radioButtons[i].value
        isChecked = true
        break
      }
    }

    if (!isChecked) {
      document.getElementById("radioNull-error-message").innerHTML = "Please select an option."
      return "error"
    } else {
      document.getElementById("radioNull-error-message").innerHTML = ""
      return null
    }
  }
  function _validateRadio() {
__ea_trace("modules/usage/usage-il-bayou.ts","_validateRadio",[],[]);
    var radioButtons = document.getElementsByName("myInfoRadio")

    for (var i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        _selectRadioValue = radioButtons[i].value
        isChecked = true
        break
      }
    }

    if (!isChecked) {
      document.getElementById("radioNull-error-message").innerHTML = "Please select an option."
      return "error"
    } else {
      document.getElementById("radioNull-error-message").innerHTML = ""
      return null
    }
  }

  // add data in deal record --------------------------------------------------------------------------------------
  async function addDataToDealRecord(url, skipUsage, _globPass, isLMII, programParticipation, id, urlMnl, idMnl) {
__ea_trace("modules/usage/usage-il-bayou.ts","addDataToDealRecord",[url,skipUsage,_globPass,isLMII,programParticipation,id,urlMnl,idMnl],["url","skipUsage","_globPass","isLMII","programParticipation","id","urlMnl","idMnl"]);
    if (isLMII === "Yes") {
      var incomeThreesholdOp = document.querySelector("#income-threshold-radio")
      if (incomeThreesholdOp.checked) {
        storage.rawSet("incomeThreesholdOp", "Yes")
      } else {
        storage.rawSet("incomeThreesholdOp", "No")
      }
      if (manualAccountNumber === true) {
        var lmiFile1,
          lmiFile2,
          lmiFile3,
          lmiFile4,
          lmiFile5,
          lmiFile6,
          lmiFile7,
          lmiFile8,
          lmiFile9,
          lmiFile10,
          lmiFile11,
          lmiFile12
        var lmiId1, lmiId2, lmiId3, lmiId4, lmiId5, lmiId6, lmiId7, lmiId8, lmiId9, lmiId10, lmiId11, lmiId12
        if (url !== undefined) {
          if (url[0]) {
            lmiFile1 = url[0]
          } else {
            lmiFile1 = ""
          }
          if (url[1]) {
            lmiFile2 = url[1]
          } else {
            lmiFile2 = ""
          }
          if (url[2]) {
            lmiFile3 = url[2]
          } else {
            lmiFile3 = ""
          }
          if (url[3]) {
            lmiFile4 = url[3]
          } else {
            lmiFile4 = ""
          }
          if (url[4]) {
            lmiFile5 = url[4]
          } else {
            lmiFile5 = ""
          }
          if (url[5]) {
            lmiFile6 = url[5]
          } else {
            lmiFile6 = ""
          }
          if (url[6]) {
            lmiFile7 = url[6]
          } else {
            lmiFile7 = ""
          }
          if (url[7]) {
            lmiFile8 = url[7]
          } else {
            lmiFile8 = ""
          }
          if (url[8]) {
            lmiFile9 = url[8]
          } else {
            lmiFile9 = ""
          }
          if (url[9]) {
            lmiFile10 = url[9]
          } else {
            lmiFile10 = ""
          }
          if (url[10]) {
            lmiFile11 = url[10]
          } else {
            lmiFile11 = ""
          }
          if (url[11]) {
            lmiFile12 = url[11]
          } else {
            lmiFile12 = ""
          }
        } else {
          lmiFile1 = ""
          lmiFile2 = ""
          lmiFile3 = ""
          lmiFile4 = ""
          lmiFile5 = ""
          lmiFile6 = ""
          lmiFile7 = ""
          lmiFile8 = ""
          lmiFile9 = ""
          lmiFile10 = ""
          lmiFile11 = ""
          lmiFile12 = ""
        }

        if (id !== undefined) {
          if (id[0]) {
            lmiId1 = id[0]
          } else {
            lmiId1 = ""
          }
          if (id[1]) {
            lmiId2 = id[1]
          } else {
            lmiId2 = ""
          }
          if (id[2]) {
            lmiId3 = id[2]
          } else {
            lmiId3 = ""
          }
          if (id[3]) {
            lmiId4 = id[3]
          } else {
            lmiId4 = ""
          }
          if (id[4]) {
            lmiId5 = id[4]
          } else {
            lmiId5 = ""
          }
          if (id[5]) {
            lmiId6 = id[5]
          } else {
            lmiId6 = ""
          }
          if (id[6]) {
            lmiId7 = id[6]
          } else {
            lmiId7 = ""
          }
          if (id[7]) {
            lmiId8 = id[7]
          } else {
            lmiId8 = ""
          }
          if (id[8]) {
            lmiId9 = id[8]
          } else {
            lmiId9 = ""
          }
          if (id[9]) {
            lmiId10 = id[9]
          } else {
            lmiId10 = ""
          }
          if (id[10]) {
            lmiId11 = id[10]
          } else {
            lmiId11 = ""
          }
          if (id[11]) {
            lmiId12 = id[11]
          } else {
            lmiId12 = ""
          }
        } else {
          lmiId1 = ""
          lmiId2 = ""
          lmiId3 = ""
          lmiId4 = ""
          lmiId5 = ""
          lmiId6 = ""
          lmiId7 = ""
          lmiId8 = ""
          lmiId9 = ""
          lmiId10 = ""
          lmiId11 = ""
          lmiId12 = ""
        }

        var fileUrl1,
          fileUrl2,
          fileUrl3,
          fileUrl4,
          fileUrl5,
          fileUrl6,
          fileUrl7,
          fileUrl8,
          fileUrl9,
          fileUrl10,
          fileUrl11,
          fileUrl12
        var fileId1,
          fileId2,
          fileId3,
          fileId4,
          fileId5,
          fileId6,
          fileId7,
          fileId8,
          fileId9,
          fileId10,
          fileId11,
          fileId12
        if (urlMnl !== undefined) {
          if (urlMnl[0]) {
            fileUrl1 = urlMnl[0]
          } else {
            fileUrl1 = ""
          }
          if (urlMnl[1]) {
            fileUrl2 = urlMnl[1]
          } else {
            fileUrl2 = ""
          }
          if (urlMnl[2]) {
            fileUrl3 = urlMnl[2]
          } else {
            fileUrl3 = ""
          }
          if (urlMnl[3]) {
            fileUrl4 = urlMnl[3]
          } else {
            fileUrl4 = ""
          }
          if (urlMnl[4]) {
            fileUrl5 = urlMnl[4]
          } else {
            fileUrl5 = ""
          }
          if (urlMnl[5]) {
            fileUrl6 = urlMnl[5]
          } else {
            fileUrl6 = ""
          }
          if (urlMnl[6]) {
            fileUrl7 = urlMnl[6]
          } else {
            fileUrl7 = ""
          }
          if (urlMnl[7]) {
            fileUrl8 = urlMnl[7]
          } else {
            fileUrl8 = ""
          }
          if (urlMnl[8]) {
            fileUrl9 = urlMnl[8]
          } else {
            fileUrl9 = ""
          }
          if (urlMnl[9]) {
            fileUrl10 = urlMnl[9]
          } else {
            fileUrl10 = ""
          }
          if (urlMnl[10]) {
            fileUrl11 = urlMnl[10]
          } else {
            fileUrl11 = ""
          }
          if (urlMnl[11]) {
            fileUrl12 = urlMnl[11]
          } else {
            fileUrl12 = ""
          }
        } else {
          fileUrl1 = ""
          fileUrl2 = ""
          fileUrl3 = ""
          fileUrl4 = ""
          fileUrl5 = ""
          fileUrl6 = ""
          fileUrl7 = ""
          fileUrl8 = ""
          fileUrl9 = ""
          fileUrl10 = ""
          fileUrl11 = ""
          fileUrl12 = ""
        }

        if (idMnl !== undefined) {
          if (idMnl[0]) {
            fileId1 = idMnl[0]
          } else {
            fileId1 = ""
          }
          if (idMnl[1]) {
            fileId2 = idMnl[1]
          } else {
            fileId2 = ""
          }
          if (idMnl[2]) {
            fileId3 = idMnl[2]
          } else {
            fileId3 = ""
          }
          if (idMnl[3]) {
            fileId4 = idMnl[3]
          } else {
            fileId4 = ""
          }
          if (idMnl[4]) {
            fileId5 = idMnl[4]
          } else {
            fileId5 = ""
          }
          if (idMnl[5]) {
            fileId6 = idMnl[5]
          } else {
            fileId6 = ""
          }
          if (idMnl[6]) {
            fileId7 = idMnl[6]
          } else {
            fileId7 = ""
          }
          if (idMnl[7]) {
            fileId8 = idMnl[7]
          } else {
            fileId8 = ""
          }
          if (idMnl[8]) {
            fileId9 = idMnl[8]
          } else {
            fileId9 = ""
          }
          if (idMnl[9]) {
            fileId10 = idMnl[9]
          } else {
            fileId10 = ""
          }
          if (idMnl[10]) {
            fileId11 = idMnl[10]
          } else {
            fileId11 = ""
          }
          if (idMnl[11]) {
            fileId12 = idMnl[11]
          } else {
            fileId12 = ""
          }
        } else {
          fileId1 = ""
          fileId2 = ""
          fileId3 = ""
          fileId4 = ""
          fileId5 = ""
          fileId6 = ""
          fileId7 = ""
          fileId8 = ""
          fileId9 = ""
          fileId10 = ""
          fileId11 = ""
          fileId12 = ""
        }

        var lmioptionvalue
        var incomeThreeshold = document.querySelector("#income-threshold-radio")
        var programParticipationRadio = document.querySelector("#program-participation-radio")
        var requestIncome = document.querySelector("#request-icome-radio")
        var attestation = document.querySelector("#attestation-radio")
        var attestationLMICheckboxContent = document.querySelector("#LMICheckboxContent")
        var attestationelctsign = document.querySelector("#elctsign").value
        var cencusTrackradio = document.querySelector("#cencus-track-radio")
        var lmiofferId = storage.rawGet("offerIdYesLMI")
        if (incomeThreeshold.checked) {
          lmioptionvalue = "Threshold Opt-Out"
          lmiofferId = storage.rawGet("offerIdNoLMI")
        }
        if (programParticipationRadio.checked) {
          lmioptionvalue = "Program"
          if (selectedProgramSelection === "") {
            selectedProgramSelection === ""
          }
        }
        if (requestIncome.checked) {
          lmioptionvalue = "Income Verification"
        }
        if (attestation.checked) {
          lmioptionvalue = "Attestation"
        }
        if (cencusTrackradio.checked) {
          lmioptionvalue = "Census Tract Map Upload"
        }
        if (programParticipation === "") {
          programParticipation = ""
        }
        if (attestationLMICheckboxContent.checked) {
          attestationLMICheckboxContent = "Yes"
        } else {
          attestationLMICheckboxContent = "No"
        }

        var _email = storage.rawGet("userEmail")
        var _dealnameField = document.querySelector(".selectedItemDetails #name").value.trim()
        var dealserviceAddressField = document.querySelector(".selectedItemDetails #serviceAddress").value.trim()
        var dealserviceAddress2Field = document.querySelector(".selectedItemDetails #serviceAddress2").value.trim()
        if (
          dealserviceAddress2Field == null ||
          dealserviceAddress2Field === "null" ||
          dealserviceAddress2Field === undefined
        ) {
          dealserviceAddress2Field = ""
        }
        var dealserviceCityField = document.querySelector(".selectedItemDetails #serviceCity").value.trim()
        storage.rawSet("city", dealserviceCityField)
        var dealserviceStateField = document.querySelector(".selectedItemDetails #serviceState").value.trim()
        var dealserviceZipCodeField = document.querySelector(".selectedItemDetails #serviceZipCode").value.trim()
        var _dealserviceAddAttField = document.querySelector(".selectedItemDetails #serviceAddAtt").value.trim()
        var dealaddressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
        var dealmailingAddressField = document.querySelector(".selectedItemDetails #mailingAddress").value.trim()
        var dealmailingAddress2Field = document.querySelector(".selectedItemDetails #mailingAddress2").value.trim()
        var dealmailingCityField = document.querySelector(".selectedItemDetails #mailingCity").value.trim()
        var dealmailingStateField = document.querySelector(".selectedItemDetails #mailingState").value.trim()
        var dealmailingZipCodeField = document.querySelector(".selectedItemDetails #mailingZipCode").value.trim()
        var skipUsageSubmission
        var skipBayouSubmission
        var credentialProvider = ""

        var iHaveOnlineAccount = "Yes"
        credentialProvider = "Bayou"
        skipUsageSubmission = "No"
        skipBayouSubmission = "No"
        if (dealaddressSameCheckboxField.checked) {
          dealmailingAddressField = dealserviceAddressField
          dealmailingAddress2Field = dealserviceAddress2Field
          dealmailingCityField = dealserviceCityField
          dealmailingStateField = dealserviceStateField
          dealmailingZipCodeField = dealserviceZipCodeField
        }
        var uanLable1, uanLable2, uanLable3
        var uanValue1, uanValue2, uanValue3
        var isUANrow0Display = true
        var isUANrow1Display = true

        if (uanFieldDisplayarray[0] === "Yes") {
          if (uanAllLabels[0]) {
            uanLable1 = uanAllLabels[0]
          } else {
            uanLable1 = ""
          }
          uanValue1 = allAccountNumbers[0]
        } else if (uanFieldDisplayarray[0] === "No") {
          isUANrow0Display = false
          if (uanFieldIntDesArray[0]) {
            uanLable1 = uanFieldIntDesArray[0]
          } else {
            uanLable1 = ""
          }

          if (uanFieldDefault[0]) {
            uanValue1 = uanFieldDefault[0]
          } else {
            uanValue1 = ""
          }
        }

        if (uanFieldDisplayarray[1] === "Yes") {
          if (uanAllLabels[1]) {
            uanLable2 = uanAllLabels[1]
          } else {
            uanLable2 = ""
          }
          if (isUANrow0Display === true) {
            uanValue2 = allAccountNumbers[1]
          } else {
            uanValue2 = allAccountNumbers[0]
          }
        } else if (uanFieldDisplayarray[1] === "No") {
          isUANrow1Display = false
          if (uanFieldIntDesArray[1]) {
            uanLable2 = uanFieldIntDesArray[1]
          } else {
            uanLable2 = ""
          }
          if (uanFieldDefault[1]) {
            uanValue2 = uanFieldDefault[1]
          } else {
            uanValue2 = ""
          }
        }

        if (uanFieldDisplayarray[2] === "Yes") {
          if (uanAllLabels[2]) {
            uanLable3 = uanAllLabels[2]
          } else {
            uanLable3 = ""
          }
          if (isUANrow0Display === true && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[2]
          } else if (isUANrow0Display === false && isUANrow1Display === false) {
            uanValue3 = allAccountNumbers[0]
          } else if (isUANrow0Display === true && isUANrow1Display === false) {
            uanValue3 = allAccountNumbers[1]
          } else if (isUANrow0Display === false && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[1]
          }
        } else if (uanFieldDisplayarray[2] === "No") {
          if (uanFieldIntDesArray[2]) {
            uanLable3 = uanFieldIntDesArray[2]
          } else {
            uanLable3 = ""
          }
          if (uanFieldDefault[2]) {
            uanValue3 = uanFieldDefault[2]
          } else {
            uanValue3 = ""
          }
        }

        var dealId = storage.rawGet("dealId")
        var concatenatedValue
        if (uanValue1 != null && uanValue1 !== "") {
          concatenatedValue = uanValue1
        }
        if (uanValue2 != null && uanValue2 !== "") {
          concatenatedValue += `-${uanValue2}`
        }
        if (uanValue3 != null && uanValue3 !== "") {
          concatenatedValue += `-${uanValue3}`
        }
        storage.rawSet("combined_utility_account_number", concatenatedValue)
        storage.rawSet("uan1Value", uanValue1)
        storage.rawSet("uan2Value", uanValue2)
        var catchdata = ""

        var FarmCity = storage.rawGet("FarmCity")

        var endDate = document.getElementById("edomrbp").value
        var startDate = document.getElementById("sdofbp").value
        var startDatea = getStartDate(startDate)
        var endDatea = getEndDate(endDate)
        const endDate1 = new Date(endDatea)
        const today1 = new Date()
        const isCurrentMonth =
          endDate1.getMonth() === today1.getMonth() && endDate1.getFullYear() === today1.getFullYear()

        if (isCurrentMonth) {
          const yesterday = new Date(today1)
          yesterday.setDate(today1.getDate() - 1)
          endDatea = formatDateAsMMDDYYYY(yesterday)
        } else {
          endDatea = formatToMMDDYYYY(endDatea)
        }

        var totalUsage = document.getElementById("totalKwhUsage").value
        const totalDays = getDaysBetween(startDate, endDate)

        startDatea = formatToMMDDYYYY(startDatea)

        var electricity_consumption_Wh = totalUsage * 1000
        var electricity_consumption_davg_Wh = (totalUsage * 1000) / totalDays
        var electricity_consumption_Watts = (totalUsage * 1000) / (totalDays * 24)
        var electricity_consumption_kWh = totalUsage
        var electricity_consumption_davg_kWh = totalUsage / totalDays
        var electricity_consumption_kWatts = totalUsage / (totalDays * 24)

        var utilityRate = storage.rawGet("UtilityRate")
        var subSizingFactor = storage.rawGet("SubSizingFactor")
        var standardRate = storage.rawGet("standardRate")
        var _lmiNseRate = storage.rawGet("lmiNseRate")
        var acSystemSize = storage.rawGet("acSystemSize")
        var acKwh = storage.rawGet("acKwh")

        var subscription_size_kWAC =
          (((electricity_consumption_kWh / totalDays) * 365 * subSizingFactor) / acKwh) * acSystemSize
        var gross_electricity_production = (electricity_consumption_kWh / totalDays) * 365 * subSizingFactor
        var estimatedAnnualEleCost = gross_electricity_production * utilityRate
        var payment_amount_per_kwh = utilityRate * standardRate

        storage.rawSet("usage_period_from", startDatea)
        storage.rawSet("usage_period_to", endDatea)
        storage.rawSet("usage_period_days", totalDays)
        storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
        storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
        storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
        storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
        storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
        storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)

        storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
        storage.rawSet("gross_electricity_production", gross_electricity_production)
        storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
        storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)
        storage.rawSet("manualUsageEntry", "Yes")

        storage.rawSet("serviceCity", dealserviceCityField)

        var psvrMulti = "Manual Usage (IL);LMI Review"
        if (totalUsage && totalUsage >= 25000) {
          if (incomeThreeshold.checked) {
            psvrMulti = "Manual Usage (IL);Oversized Usage"
          } else {
            psvrMulti = "Manual Usage (IL);LMI Review;Oversized Usage"
          }
        } else {
          if (incomeThreeshold.checked) {
            psvrMulti = "Manual Usage (IL)"
          } else {
            psvrMulti = "Manual Usage (IL);LMI Review"
          }
        }

        var manualInputReason = ""
        if (credNotVerified === true) {
          manualInputReason = "Credentials Not Verified"
        } else {
          manualInputReason = "Accounts Not Found"
        }

        var [startMonth, startDay, startYear] = startDatea.split("/")
        var [endMonth, endDay, endYear] = endDatea.split("/")
        var startDateForCelender = new Date(Date.UTC(startYear, startMonth - 1, startDay))
        startDateForCelender = startDateForCelender.toISOString()
        var endDateForCelender = new Date(Date.UTC(endYear, endMonth - 1, endDay))
        endDateForCelender = endDateForCelender.toISOString()

        storage.rawSet("isManualSubmission", "Yes")
        if (requestIncome.checked) {
          try {
            const data = {
              properties: {
                deal_id: dealId,
                do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
                credential_provider: credentialProvider,
                enrollmentsessionid: enrollmentSessionID,
                skip_usage_submission: skipUsageSubmission,
                bayous_utility_id: bayouUtility,
                bayous_type: bayouTokenType,
                bayous_id: bayouId,
                bayous_onboarding_token: bayouToken,
                uan_1_label: uanLable1,
                uan_1_value: uanValue1,
                uan_2_label: uanLable2,
                uan_2_value: uanValue2,
                uan_3_label: uanLable3,
                uan_3_value: uanValue3,
                manual_input_reason: manualInputReason,
                post_submission_verification_reason: "Manual Usage",
                utility_bill_file_1_url: fileUrl1,
                utility_bill_file_2_url: fileUrl2,
                utility_bill_file_3_url: fileUrl3,
                utility_bill_file_4_url: fileUrl4,
                utility_bill_file_5_url: fileUrl5,
                utility_bill_file_6_url: fileUrl6,
                utility_bill_file_7_url: fileUrl7,
                utility_bill_file_8_url: fileUrl8,
                utility_bill_file_9_url: fileUrl9,
                utility_bill_file_10_: fileUrl10,
                utility_bill_file_11_: fileUrl11,
                utility_bill_file_12_: fileUrl12,
                utility_bill_file_1_id: fileId1,
                utility_bill_file_2_id: fileId2,
                utility_bill_file_3_id: fileId3,
                utility_bill_file_4_id: fileId4,
                utility_bill_file_5_id: fileId5,
                utility_bill_file_6_id: fileId6,
                utility_bill_file_7_id: fileId7,
                utility_bill_file_8_id: fileId8,
                utility_bill_file_9_id: fileId9,
                utility_bill_file_10_id: fileId10,
                utility_bill_file_11_id: fileId11,
                utility_bill_file_12_id: fileId12,
                skip_bayou_submission: skipBayouSubmission,
                mfa_required: mfaRequired,
                uan_2_internal_value: additionalAttributeItem,
                mail_street_address: dealmailingAddressField,
                mail_street_address_2: dealmailingAddress2Field,
                mail_city: dealmailingCityField,
                mail_state: dealmailingStateField,
                mail_postal_code: dealmailingZipCodeField,
                street_address: dealserviceAddressField,
                street_address_2: dealserviceAddress2Field,
                city: dealserviceCityField,
                service_state_abbreviation: dealserviceStateField,
                postal_code: dealserviceZipCodeField,
                county: dealserviceStateField,
                lmi_option: lmioptionvalue,
                lmi_attest_confirmation: attestationLMICheckboxContent,
                lmi_signature: attestationelctsign,
                income_verification_doc_file_1: lmiFile1,
                income_verification_doc_file_1_id: lmiId1,
                lmi_program_doc_url_1: "",
                lmi_program_doc_url_2: "",
                lmi_program_doc_url_3: "",
                lmi_program_doc_url_4: "",
                lmi_program_doc_url_5: "",
                lmi_program_doc_url_6: "",
                lmi_program_doc_url_7: "",
                lmi_program_doc_url_8: "",
                lmi_program_doc_url_9: "",
                lmi_program_doc_url_10: "",
                lmi_program_doc_url_11: "",
                lmi_program_doc_url_12: "",
                lmi_program_doc_url_1_id: "",
                lmi_program_doc_url_2_id: "",
                lmi_program_doc_url_3_id: "",
                lmi_program_doc_url_4_id: "",
                lmi_program_doc_url_5_id: "",
                lmi_program_doc_url_6_id: "",
                lmi_program_doc_url_7_id: "",
                lmi_program_doc_url_8_id: "",
                lmi_program_doc_url_9_id: "",
                lmi_program_doc_url_10_id: "",
                lmi_program_doc_url_11_id: "",
                lmi_program_doc_url_12_id: "",
                lmi_program_selection: selectedProgramSelection,
                lmi_program_doc_selection: selectedOptText,
                lmi_my_usage: "yes",
                combined_utility_account_number: concatenatedValue,
                product_offer_id: lmiofferId,
                manual_usage_entry: "Yes",
                manual_total_kwh_usage_: totalUsage,
                manual_reading_start_date: startDatea,
                manual_reading_end_date: endDatea,
                il_manual_usage_period_days: totalDays,
                usage_period_from: startDateForCelender,
                usage_period_to: endDateForCelender,
                usage_period_days: totalDays,
                usage_quantity: totalUsage,
                electricity_consumption_wh: electricity_consumption_Wh,
                electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
                electricity_consumption_watts: electricity_consumption_Watts,
                electricity_consumption_kwh: electricity_consumption_kWh,
                electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
                electricity_consumption_kwatts: electricity_consumption_kWatts,
                utility_rate: utilityRate,
                payment_amount_per_kwh: payment_amount_per_kwh,
                sub_sizing_factor: subSizingFactor,
                subscription_size_kwac: subscription_size_kWAC,
                gross_electricity_production: gross_electricity_production,
                il_manual_electricity_consumption_wh: electricity_consumption_Wh,
                il_manual_electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
                il_manual_electricity_consumption_watts: electricity_consumption_Watts,
                il_manual_electricity_consumption_kwh: electricity_consumption_kWh,
                il_manual_electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
                il_manual_electricity_consumption_kwatts: electricity_consumption_kWatts,
                il_manual_payment_amount_per_kwh: payment_amount_per_kwh,
                il_manual_subscription_size_kwac: subscription_size_kWAC,
                il_manual_gross_electricity_production: gross_electricity_production,
                name_1: "Credit Card Fee",
                amount_1: "2.90%",
                form_type: "csf_form",
                spanish_pdf: "No",
                invoice_type: "Electronic",
                payment_frequency: "Monthly, within 60 days after energization",
                subscription_type: "Price per kWh produced by subscription",
                when_applicable_1: "Applicable for Credit Card Payments",
                provider_email: "customercare@nautilussolar.com",
                provider_phone_number: "8669694129",
                provider_website: "www.nautilussolar.com",
                provider_address_dba_name: "Nautilus Community Solar, LLC",
                il_provider_company_name: "Nautilus US Power Holdco, LLC",
                minimum_level_guarantee: "no",
                termination_circ:
                  "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
                require_ares: "No",
                terms_years: "20",
                il_payment_method: "ACH",
                initial_amount: "0",
                vendor_id: "2177",
                nearest_inhabited_area: FarmCity,
                post_submission_verification_reason_multi: psvrMulti,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            catchdata = data
            if (response.ok) {
              storage.rawSet("skipUsage", "No")
              storage.rawSet("utilityProvider", "Bayou")
              await checkConsentConfigurationVariation()
            }
            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            closeProgressBar()
            console.error("Error:", error)
          }
        } else {
          try {
            const data = {
              properties: {
                deal_id: dealId,
                do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
                credential_provider: credentialProvider,
                enrollmentsessionid: enrollmentSessionID,
                skip_usage_submission: skipUsageSubmission,
                bayous_utility_id: bayouUtility,
                bayous_type: bayouTokenType,
                bayous_id: bayouId,
                bayous_onboarding_token: bayouToken,
                uan_1_label: uanLable1,
                uan_1_value: uanValue1,
                uan_2_label: uanLable2,
                uan_2_value: uanValue2,
                uan_3_label: uanLable3,
                uan_3_value: uanValue3,
                manual_input_reason: manualInputReason,
                post_submission_verification_reason: "Manual Usage",
                utility_bill_file_1_url: fileUrl1,
                utility_bill_file_2_url: fileUrl2,
                utility_bill_file_3_url: fileUrl3,
                utility_bill_file_4_url: fileUrl4,
                utility_bill_file_5_url: fileUrl5,
                utility_bill_file_6_url: fileUrl6,
                utility_bill_file_7_url: fileUrl7,
                utility_bill_file_8_url: fileUrl8,
                utility_bill_file_9_url: fileUrl9,
                utility_bill_file_10_: fileUrl10,
                utility_bill_file_11_: fileUrl11,
                utility_bill_file_12_: fileUrl12,
                utility_bill_file_1_id: fileId1,
                utility_bill_file_2_id: fileId2,
                utility_bill_file_3_id: fileId3,
                utility_bill_file_4_id: fileId4,
                utility_bill_file_5_id: fileId5,
                utility_bill_file_6_id: fileId6,
                utility_bill_file_7_id: fileId7,
                utility_bill_file_8_id: fileId8,
                utility_bill_file_9_id: fileId9,
                utility_bill_file_10_id: fileId10,
                utility_bill_file_11_id: fileId11,
                utility_bill_file_12_id: fileId12,
                income_verification_doc_file_1: "",
                income_verification_doc_file_1_id: "",
                skip_bayou_submission: skipBayouSubmission,
                mfa_required: mfaRequired,
                uan_2_internal_value: additionalAttributeItem,
                mail_street_address: dealmailingAddressField,
                mail_street_address_2: dealmailingAddress2Field,
                mail_city: dealmailingCityField,
                mail_state: dealmailingStateField,
                mail_postal_code: dealmailingZipCodeField,
                street_address: dealserviceAddressField,
                street_address_2: dealserviceAddress2Field,
                city: dealserviceCityField,
                service_state_abbreviation: dealserviceStateField,
                postal_code: dealserviceZipCodeField,
                county: dealserviceStateField,
                lmi_option: lmioptionvalue,
                lmi_attest_confirmation: attestationLMICheckboxContent,
                lmi_signature: attestationelctsign,
                lmi_program_doc_url_1: lmiFile1,
                lmi_program_doc_url_2: lmiFile2,
                lmi_program_doc_url_3: lmiFile3,
                lmi_program_doc_url_4: lmiFile4,
                lmi_program_doc_url_5: lmiFile5,
                lmi_program_doc_url_6: lmiFile6,
                lmi_program_doc_url_7: lmiFile7,
                lmi_program_doc_url_8: lmiFile8,
                lmi_program_doc_url_9: lmiFile9,
                lmi_program_doc_url_10: lmiFile10,
                lmi_program_doc_url_11: lmiFile11,
                lmi_program_doc_url_12: lmiFile12,
                lmi_program_doc_url_1_id: lmiId1,
                lmi_program_doc_url_2_id: lmiId2,
                lmi_program_doc_url_3_id: lmiId3,
                lmi_program_doc_url_4_id: lmiId4,
                lmi_program_doc_url_5_id: lmiId5,
                lmi_program_doc_url_6_id: lmiId6,
                lmi_program_doc_url_7_id: lmiId7,
                lmi_program_doc_url_8_id: lmiId8,
                lmi_program_doc_url_9_id: lmiId9,
                lmi_program_doc_url_10_id: lmiId10,
                lmi_program_doc_url_11_id: lmiId11,
                lmi_program_doc_url_12_id: lmiId12,
                lmi_program_selection: selectedProgramSelection,
                lmi_program_doc_selection: selectedOptText,
                lmi_my_usage: "yes",
                combined_utility_account_number: concatenatedValue,
                product_offer_id: lmiofferId,
                manual_usage_entry: "Yes",
                manual_total_kwh_usage_: totalUsage,
                manual_reading_start_date: startDatea,
                manual_reading_end_date: endDatea,
                il_manual_usage_period_days: totalDays,
                usage_period_from: startDateForCelender,
                usage_period_to: endDateForCelender,
                usage_period_days: totalDays,
                usage_quantity: totalUsage,
                electricity_consumption_wh: electricity_consumption_Wh,
                electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
                electricity_consumption_watts: electricity_consumption_Watts,
                electricity_consumption_kwh: electricity_consumption_kWh,
                electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
                electricity_consumption_kwatts: electricity_consumption_kWatts,
                utility_rate: utilityRate,
                payment_amount_per_kwh: payment_amount_per_kwh,
                sub_sizing_factor: subSizingFactor,
                subscription_size_kwac: subscription_size_kWAC,
                gross_electricity_production: gross_electricity_production,
                il_manual_electricity_consumption_wh: electricity_consumption_Wh,
                il_manual_electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
                il_manual_electricity_consumption_watts: electricity_consumption_Watts,
                il_manual_electricity_consumption_kwh: electricity_consumption_kWh,
                il_manual_electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
                il_manual_electricity_consumption_kwatts: electricity_consumption_kWatts,
                il_manual_payment_amount_per_kwh: payment_amount_per_kwh,
                il_manual_subscription_size_kwac: subscription_size_kWAC,
                il_manual_gross_electricity_production: gross_electricity_production,
                name_1: "Credit Card Fee",
                amount_1: "2.90%",
                form_type: "csf_form",
                spanish_pdf: "No",
                invoice_type: "Electronic",
                payment_frequency: "Monthly, within 60 days after energization",
                subscription_type: "Price per kWh produced by subscription",
                when_applicable_1: "Applicable for Credit Card Payments",
                provider_email: "customercare@nautilussolar.com",
                provider_phone_number: "8669694129",
                provider_website: "www.nautilussolar.com",
                provider_address_dba_name: "Nautilus Community Solar, LLC",
                il_provider_company_name: "Nautilus US Power Holdco, LLC",
                minimum_level_guarantee: "no",
                termination_circ:
                  "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
                require_ares: "No",
                terms_years: "20",
                il_payment_method: "ACH",
                initial_amount: "0",
                vendor_id: "2177",
                nearest_inhabited_area: FarmCity,
                post_submission_verification_reason_multi: psvrMulti,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            catchdata = data
            if (response.ok) {
              storage.rawSet("skipUsage", "No")
              storage.rawSet("utilityProvider", "Bayou")
              await checkConsentConfigurationVariation()
            }
            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            closeProgressBar()
            console.error("Error:", error)
          }
        }
      } else {
        var lmiFile1,
          lmiFile2,
          lmiFile3,
          lmiFile4,
          lmiFile5,
          lmiFile6,
          lmiFile7,
          lmiFile8,
          lmiFile9,
          lmiFile10,
          lmiFile11,
          lmiFile12
        var lmiId1, lmiId2, lmiId3, lmiId4, lmiId5, lmiId6, lmiId7, lmiId8, lmiId9, lmiId10, lmiId11, lmiId12
        if (url !== undefined) {
          if (url[0]) {
            lmiFile1 = url[0]
          } else {
            lmiFile1 = ""
          }
          if (url[1]) {
            lmiFile2 = url[1]
          } else {
            lmiFile2 = ""
          }
          if (url[2]) {
            lmiFile3 = url[2]
          } else {
            lmiFile3 = ""
          }
          if (url[3]) {
            lmiFile4 = url[3]
          } else {
            lmiFile4 = ""
          }
          if (url[4]) {
            lmiFile5 = url[4]
          } else {
            lmiFile5 = ""
          }
          if (url[5]) {
            lmiFile6 = url[5]
          } else {
            lmiFile6 = ""
          }
          if (url[6]) {
            lmiFile7 = url[6]
          } else {
            lmiFile7 = ""
          }
          if (url[7]) {
            lmiFile8 = url[7]
          } else {
            lmiFile8 = ""
          }
          if (url[8]) {
            lmiFile9 = url[8]
          } else {
            lmiFile9 = ""
          }
          if (url[9]) {
            lmiFile10 = url[9]
          } else {
            lmiFile10 = ""
          }
          if (url[10]) {
            lmiFile11 = url[10]
          } else {
            lmiFile11 = ""
          }
          if (url[11]) {
            lmiFile12 = url[11]
          } else {
            lmiFile12 = ""
          }
        } else {
          lmiFile1 = ""
          lmiFile2 = ""
          lmiFile3 = ""
          lmiFile4 = ""
          lmiFile5 = ""
          lmiFile6 = ""
          lmiFile7 = ""
          lmiFile8 = ""
          lmiFile9 = ""
          lmiFile10 = ""
          lmiFile11 = ""
          lmiFile12 = ""
        }

        if (id !== undefined) {
          if (id[0]) {
            lmiId1 = id[0]
          } else {
            lmiId1 = ""
          }
          if (id[1]) {
            lmiId2 = id[1]
          } else {
            lmiId2 = ""
          }
          if (id[2]) {
            lmiId3 = id[2]
          } else {
            lmiId3 = ""
          }
          if (id[3]) {
            lmiId4 = id[3]
          } else {
            lmiId4 = ""
          }
          if (id[4]) {
            lmiId5 = id[4]
          } else {
            lmiId5 = ""
          }
          if (id[5]) {
            lmiId6 = id[5]
          } else {
            lmiId6 = ""
          }
          if (id[6]) {
            lmiId7 = id[6]
          } else {
            lmiId7 = ""
          }
          if (id[7]) {
            lmiId8 = id[7]
          } else {
            lmiId8 = ""
          }
          if (id[8]) {
            lmiId9 = id[8]
          } else {
            lmiId9 = ""
          }
          if (id[9]) {
            lmiId10 = id[9]
          } else {
            lmiId10 = ""
          }
          if (id[10]) {
            lmiId11 = id[10]
          } else {
            lmiId11 = ""
          }
          if (id[11]) {
            lmiId12 = id[11]
          } else {
            lmiId12 = ""
          }
        } else {
          lmiId1 = ""
          lmiId2 = ""
          lmiId3 = ""
          lmiId4 = ""
          lmiId5 = ""
          lmiId6 = ""
          lmiId7 = ""
          lmiId8 = ""
          lmiId9 = ""
          lmiId10 = ""
          lmiId11 = ""
          lmiId12 = ""
        }

        var lmioptionvalue
        var incomeThreeshold = document.querySelector("#income-threshold-radio")
        var programParticipationRadio = document.querySelector("#program-participation-radio")
        var requestIncome = document.querySelector("#request-icome-radio")
        var attestation = document.querySelector("#attestation-radio")
        var attestationLMICheckboxContent = document.querySelector("#LMICheckboxContent")
        var attestationelctsign = document.querySelector("#elctsign").value
        var cencusTrackradio = document.querySelector("#cencus-track-radio")
        var lmiofferId = storage.rawGet("offerIdYesLMI")
        if (incomeThreeshold.checked) {
          lmioptionvalue = "Threshold Opt-Out"
          lmiofferId = storage.rawGet("offerIdNoLMI")
        }
        if (programParticipationRadio.checked) {
          lmioptionvalue = "Program"
          if (selectedProgramSelection === "") {
            selectedProgramSelection === ""
          }
        }
        if (requestIncome.checked) {
          lmioptionvalue = "Income Verification"
        }
        if (attestation.checked) {
          lmioptionvalue = "Attestation"
        }
        if (cencusTrackradio.checked) {
          lmioptionvalue = "Census Tract Map Upload"
        }
        if (programParticipation === "") {
          programParticipation = ""
        }
        if (attestationLMICheckboxContent.checked) {
          attestationLMICheckboxContent = "Yes"
        } else {
          attestationLMICheckboxContent = "No"
        }

        var _email = storage.rawGet("userEmail")
        var _dealnameField = document.querySelector(".selectedItemDetails #name").value.trim()
        var dealserviceAddressField = document.querySelector(".selectedItemDetails #serviceAddress").value.trim()
        var dealserviceAddress2Field = document.querySelector(".selectedItemDetails #serviceAddress2").value.trim()
        if (
          dealserviceAddress2Field == null ||
          dealserviceAddress2Field === "null" ||
          dealserviceAddress2Field === undefined
        ) {
          dealserviceAddress2Field = ""
        }
        var dealserviceCityField = document.querySelector(".selectedItemDetails #serviceCity").value.trim()
        storage.rawSet("city", dealserviceCityField)
        var dealserviceStateField = document.querySelector(".selectedItemDetails #serviceState").value.trim()
        var dealserviceZipCodeField = document.querySelector(".selectedItemDetails #serviceZipCode").value.trim()
        var _dealserviceAddAttField = document.querySelector(".selectedItemDetails #serviceAddAtt").value.trim()
        var dealaddressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
        var dealmailingAddressField = document.querySelector(".selectedItemDetails #mailingAddress").value.trim()
        var dealmailingAddress2Field = document.querySelector(".selectedItemDetails #mailingAddress2").value.trim()
        var dealmailingCityField = document.querySelector(".selectedItemDetails #mailingCity").value.trim()
        var dealmailingStateField = document.querySelector(".selectedItemDetails #mailingState").value.trim()
        var dealmailingZipCodeField = document.querySelector(".selectedItemDetails #mailingZipCode").value.trim()
        var skipUsageSubmission
        var skipBayouSubmission
        var credentialProvider = ""

        var iHaveOnlineAccount = "Yes"
        credentialProvider = "Bayou"
        skipUsageSubmission = "No"
        skipBayouSubmission = "No"
        if (dealaddressSameCheckboxField.checked) {
          dealmailingAddressField = dealserviceAddressField
          dealmailingAddress2Field = dealserviceAddress2Field
          dealmailingCityField = dealserviceCityField
          dealmailingStateField = dealserviceStateField
          dealmailingZipCodeField = dealserviceZipCodeField
        }
        var uanLable1, uanLable2, uanLable3
        var uanValue1, uanValue2, uanValue3
        var isUANrow0Display = true
        var isUANrow1Display = true

        if (uanFieldDisplayarray[0] === "Yes") {
          if (uanAllLabels[0]) {
            uanLable1 = uanAllLabels[0]
          } else {
            uanLable1 = ""
          }
          uanValue1 = bayouAccountNo
        } else if (uanFieldDisplayarray[0] === "No") {
          isUANrow0Display = false
          if (uanFieldIntDesArray[0]) {
            uanLable1 = uanFieldIntDesArray[0]
          } else {
            uanLable1 = ""
          }

          if (uanFieldDefault[0]) {
            uanValue1 = uanFieldDefault[0]
          } else {
            uanValue1 = ""
          }
        }

        if (uanFieldDisplayarray[1] === "Yes") {
          if (uanAllLabels[1]) {
            uanLable2 = uanAllLabels[1]
          } else {
            uanLable2 = ""
          }
          if (isUANrow0Display === true) {
            uanValue2 = additionalAttributeValue
          } else {
            uanValue2 = bayouAccountNo
          }
        } else if (uanFieldDisplayarray[1] === "No") {
          isUANrow1Display = false
          if (uanFieldIntDesArray[1]) {
            uanLable2 = uanFieldIntDesArray[1]
          } else {
            uanLable2 = ""
          }
          if (uanFieldDefault[1]) {
            uanValue2 = uanFieldDefault[1]
          } else {
            uanValue2 = ""
          }
        }

        if (uanFieldDisplayarray[2] === "Yes") {
          if (uanAllLabels[2]) {
            uanLable3 = uanAllLabels[2]
          } else {
            uanLable3 = ""
          }
          if (isUANrow0Display === true && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[2]
          } else if (isUANrow0Display === false && isUANrow1Display === false) {
            uanValue3 = bayouAccountNo
          } else if (isUANrow0Display === true && isUANrow1Display === false) {
            uanValue3 = additionalAttributeValue
          } else if (isUANrow0Display === false && isUANrow1Display === true) {
            uanValue3 = additionalAttributeValue
          }
        } else if (uanFieldDisplayarray[2] === "No") {
          if (uanFieldIntDesArray[2]) {
            uanLable3 = uanFieldIntDesArray[2]
          } else {
            uanLable3 = ""
          }
          if (uanFieldDefault[2]) {
            uanValue3 = uanFieldDefault[2]
          } else {
            uanValue3 = ""
          }
        }

        var dealId = storage.rawGet("dealId")
        var concatenatedValue
        if (uanValue1 != null && uanValue1 !== "") {
          concatenatedValue = uanValue1
        }
        if (uanValue2 != null && uanValue2 !== "") {
          concatenatedValue += `-${uanValue2}`
        }
        if (uanValue3 != null && uanValue3 !== "") {
          concatenatedValue += `-${uanValue3}`
        }
        storage.rawSet("combined_utility_account_number", concatenatedValue)
        storage.rawSet("uan1Value", uanValue1)
        storage.rawSet("uan2Value", uanValue2)

        var psvrMulti = ""
        if (incomeThreeshold.checked) {
          psvrMulti = ""
        } else {
          psvrMulti = "LMI Review"
        }

        var catchdata = ""
        if (requestIncome.checked) {
          try {
            const data = {
              properties: {
                deal_id: dealId,
                do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
                credential_provider: credentialProvider,
                enrollmentsessionid: enrollmentSessionID,
                skip_usage_submission: skipUsageSubmission,
                bayous_utility_id: bayouUtility,
                bayous_type: bayouTokenType,
                bayous_id: bayouId,
                bayous_onboarding_token: bayouToken,
                uan_1_label: uanLable1,
                uan_1_value: uanValue1,
                uan_2_label: uanLable2,
                uan_2_value: uanValue2,
                uan_3_label: uanLable3,
                uan_3_value: uanValue3,
                meter_id: meterId,
                utility_type: meterType,
                skip_bayou_submission: skipBayouSubmission,
                rate_class: rateClass,
                combined_utility_account_number: concatenatedValue,
                tarrif_type: rateClass,
                mfa_required: mfaRequired,
                uan_2_internal_value: additionalAttributeItem,
                mail_street_address: dealmailingAddressField,
                mail_street_address_2: dealmailingAddress2Field,
                mail_city: dealmailingCityField,
                mail_state: dealmailingStateField,
                mail_postal_code: dealmailingZipCodeField,
                street_address: dealserviceAddressField,
                street_address_2: dealserviceAddress2Field,
                city: dealserviceCityField,
                service_state_abbreviation: dealserviceStateField,
                postal_code: dealserviceZipCodeField,
                county: dealserviceStateField,
                lmi_option: lmioptionvalue,
                lmi_attest_confirmation: attestationLMICheckboxContent,
                lmi_signature: attestationelctsign,
                income_verification_doc_file_1: lmiFile1,
                income_verification_doc_file_1_id: lmiId1,
                lmi_program_doc_url_1: "",
                lmi_program_doc_url_2: "",
                lmi_program_doc_url_3: "",
                lmi_program_doc_url_4: "",
                lmi_program_doc_url_5: "",
                lmi_program_doc_url_6: "",
                lmi_program_doc_url_7: "",
                lmi_program_doc_url_8: "",
                lmi_program_doc_url_9: "",
                lmi_program_doc_url_10: "",
                lmi_program_doc_url_11: "",
                lmi_program_doc_url_12: "",
                lmi_program_doc_url_1_id: "",
                lmi_program_doc_url_2_id: "",
                lmi_program_doc_url_3_id: "",
                lmi_program_doc_url_4_id: "",
                lmi_program_doc_url_5_id: "",
                lmi_program_doc_url_6_id: "",
                lmi_program_doc_url_7_id: "",
                lmi_program_doc_url_8_id: "",
                lmi_program_doc_url_9_id: "",
                lmi_program_doc_url_10_id: "",
                lmi_program_doc_url_11_id: "",
                lmi_program_doc_url_12_id: "",
                lmi_program_selection: selectedProgramSelection,
                lmi_program_doc_selection: selectedOptText,
                lmi_my_usage: "yes",
                product_offer_id: lmiofferId,
                post_submission_verification_reason_multi: psvrMulti,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            catchdata = data
            if (response.ok) {
              if (skipUsage != null) {
                storage.rawSet("skipUsage", skipUsage)
              }
              storage.rawSet("utilityProvider", "Bayou")
              await getBillsandConsumptionData(
                uanValue1,
                meterId,
                additionalAttributeItem,
                additionalAttributeValue,
                lmioptionvalue,
                isLMII,
                psvrMulti,
              )
            }
            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            closeProgressBar()
            console.error("Error:", error)
          }
        } else {
          try {
            const data = {
              properties: {
                deal_id: dealId,
                do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
                credential_provider: credentialProvider,
                enrollmentsessionid: enrollmentSessionID,
                skip_usage_submission: skipUsageSubmission,
                bayous_utility_id: bayouUtility,
                bayous_type: bayouTokenType,
                bayous_id: bayouId,
                bayous_onboarding_token: bayouToken,
                uan_1_label: uanLable1,
                uan_1_value: uanValue1,
                uan_2_label: uanLable2,
                uan_2_value: uanValue2,
                uan_3_label: uanLable3,
                uan_3_value: uanValue3,
                meter_id: meterId,
                utility_type: meterType,
                skip_bayou_submission: skipBayouSubmission,
                rate_class: rateClass,
                combined_utility_account_number: concatenatedValue,
                //                         bayous_tarrif: rateClass,
                tarrif_type: rateClass,
                mfa_required: mfaRequired,
                uan_2_internal_value: additionalAttributeItem,
                mail_street_address: dealmailingAddressField,
                mail_street_address_2: dealmailingAddress2Field,
                mail_city: dealmailingCityField,
                mail_state: dealmailingStateField,
                mail_postal_code: dealmailingZipCodeField,
                street_address: dealserviceAddressField,
                street_address_2: dealserviceAddress2Field,
                city: dealserviceCityField,
                service_state_abbreviation: dealserviceStateField,
                postal_code: dealserviceZipCodeField,
                county: dealserviceStateField,
                lmi_option: lmioptionvalue,
                lmi_attest_confirmation: attestationLMICheckboxContent,
                lmi_signature: attestationelctsign,
                lmi_program_doc_url_1: lmiFile1,
                lmi_program_doc_url_2: lmiFile2,
                lmi_program_doc_url_3: lmiFile3,
                lmi_program_doc_url_4: lmiFile4,
                lmi_program_doc_url_5: lmiFile5,
                lmi_program_doc_url_6: lmiFile6,
                lmi_program_doc_url_7: lmiFile7,
                lmi_program_doc_url_8: lmiFile8,
                lmi_program_doc_url_9: lmiFile9,
                lmi_program_doc_url_10: lmiFile10,
                lmi_program_doc_url_11: lmiFile11,
                lmi_program_doc_url_12: lmiFile12,
                lmi_program_doc_url_1_id: lmiId1,
                lmi_program_doc_url_2_id: lmiId2,
                lmi_program_doc_url_3_id: lmiId3,
                lmi_program_doc_url_4_id: lmiId4,
                lmi_program_doc_url_5_id: lmiId5,
                lmi_program_doc_url_6_id: lmiId6,
                lmi_program_doc_url_7_id: lmiId7,
                lmi_program_doc_url_8_id: lmiId8,
                lmi_program_doc_url_9_id: lmiId9,
                lmi_program_doc_url_10_id: lmiId10,
                lmi_program_doc_url_11_id: lmiId11,
                lmi_program_doc_url_12_id: lmiId12,
                income_verification_doc_file_1: "",
                income_verification_doc_file_1_id: "",
                lmi_program_selection: selectedProgramSelection,
                lmi_program_doc_selection: selectedOptText,
                lmi_my_usage: "yes",
                product_offer_id: lmiofferId,
                post_submission_verification_reason_multi: psvrMulti,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            catchdata = data
            if (response.ok) {
              if (skipUsage != null) {
                storage.rawSet("skipUsage", skipUsage)
              }
              storage.rawSet("utilityProvider", "Bayou")
              await getBillsandConsumptionData(
                uanValue1,
                meterId,
                additionalAttributeItem,
                additionalAttributeValue,
                lmioptionvalue,
                isLMII,
                psvrMulti,
              )
            }
            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            closeProgressBar()
            console.error("Error:", error)
          }
        }
      }
    } else {
      if (manualAccountNumber === true) {
        var lmiFile1,
          lmiFile2,
          lmiFile3,
          lmiFile4,
          lmiFile5,
          lmiFile6,
          lmiFile7,
          lmiFile8,
          lmiFile9,
          lmiFile10,
          lmiFile11,
          lmiFile12
        var lmiId1, lmiId2, lmiId3, lmiId4, lmiId5, lmiId6, lmiId7, lmiId8, lmiId9, lmiId10, lmiId11, lmiId12
        if (url !== undefined) {
          if (url[0]) {
            lmiFile1 = url[0]
          } else {
            lmiFile1 = ""
          }
          if (url[1]) {
            lmiFile2 = url[1]
          } else {
            lmiFile2 = ""
          }
          if (url[2]) {
            lmiFile3 = url[2]
          } else {
            lmiFile3 = ""
          }
          if (url[3]) {
            lmiFile4 = url[3]
          } else {
            lmiFile4 = ""
          }
          if (url[4]) {
            lmiFile5 = url[4]
          } else {
            lmiFile5 = ""
          }
          if (url[5]) {
            lmiFile6 = url[5]
          } else {
            lmiFile6 = ""
          }
          if (url[6]) {
            lmiFile7 = url[6]
          } else {
            lmiFile7 = ""
          }
          if (url[7]) {
            lmiFile8 = url[7]
          } else {
            lmiFile8 = ""
          }
          if (url[8]) {
            lmiFile9 = url[8]
          } else {
            lmiFile9 = ""
          }
          if (url[9]) {
            lmiFile10 = url[9]
          } else {
            lmiFile10 = ""
          }
          if (url[10]) {
            lmiFile11 = url[10]
          } else {
            lmiFile11 = ""
          }
          if (url[11]) {
            lmiFile12 = url[11]
          } else {
            lmiFile12 = ""
          }
        } else {
          lmiFile1 = ""
          lmiFile2 = ""
          lmiFile3 = ""
          lmiFile4 = ""
          lmiFile5 = ""
          lmiFile6 = ""
          lmiFile7 = ""
          lmiFile8 = ""
          lmiFile9 = ""
          lmiFile10 = ""
          lmiFile11 = ""
          lmiFile12 = ""
        }

        if (id !== undefined) {
          if (id[0]) {
            lmiId1 = id[0]
          } else {
            lmiId1 = ""
          }
          if (id[1]) {
            lmiId2 = id[1]
          } else {
            lmiId2 = ""
          }
          if (id[2]) {
            lmiId3 = id[2]
          } else {
            lmiId3 = ""
          }
          if (id[3]) {
            lmiId4 = id[3]
          } else {
            lmiId4 = ""
          }
          if (id[4]) {
            lmiId5 = id[4]
          } else {
            lmiId5 = ""
          }
          if (id[5]) {
            lmiId6 = id[5]
          } else {
            lmiId6 = ""
          }
          if (id[6]) {
            lmiId7 = id[6]
          } else {
            lmiId7 = ""
          }
          if (id[7]) {
            lmiId8 = id[7]
          } else {
            lmiId8 = ""
          }
          if (id[8]) {
            lmiId9 = id[8]
          } else {
            lmiId9 = ""
          }
          if (id[9]) {
            lmiId10 = id[9]
          } else {
            lmiId10 = ""
          }
          if (id[10]) {
            lmiId11 = id[10]
          } else {
            lmiId11 = ""
          }
          if (id[11]) {
            lmiId12 = id[11]
          } else {
            lmiId12 = ""
          }
        } else {
          lmiId1 = ""
          lmiId2 = ""
          lmiId3 = ""
          lmiId4 = ""
          lmiId5 = ""
          lmiId6 = ""
          lmiId7 = ""
          lmiId8 = ""
          lmiId9 = ""
          lmiId10 = ""
          lmiId11 = ""
          lmiId12 = ""
        }

        var _email = storage.rawGet("userEmail")
        //         var skipThisForNowAndGetInTouch = document.getElementById("skipThisForNowAndGetInTouch");
        var _dealnameField = document.querySelector(".selectedItemDetails #name").value.trim()
        var dealserviceAddressField = document.querySelector(".selectedItemDetails #serviceAddress").value.trim()
        var dealserviceAddress2Field = document.querySelector(".selectedItemDetails #serviceAddress2").value.trim()
        if (
          dealserviceAddress2Field == null ||
          dealserviceAddress2Field === "null" ||
          dealserviceAddress2Field === undefined
        ) {
          dealserviceAddress2Field = ""
        }
        var dealserviceCityField = document.querySelector(".selectedItemDetails #serviceCity").value.trim()
        storage.rawSet("city", dealserviceCityField)
        var dealserviceStateField = document.querySelector(".selectedItemDetails #serviceState").value.trim()
        var dealserviceZipCodeField = document.querySelector(".selectedItemDetails #serviceZipCode").value.trim()
        var _dealserviceAddAttField = document.querySelector(".selectedItemDetails #serviceAddAtt").value.trim()
        var dealaddressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
        var dealmailingAddressField = document.querySelector(".selectedItemDetails #mailingAddress").value.trim()
        var dealmailingAddress2Field = document.querySelector(".selectedItemDetails #mailingAddress2").value.trim()
        var dealmailingCityField = document.querySelector(".selectedItemDetails #mailingCity").value.trim()
        var dealmailingStateField = document.querySelector(".selectedItemDetails #mailingState").value.trim()
        var dealmailingZipCodeField = document.querySelector(".selectedItemDetails #mailingZipCode").value.trim()
        var skipUsageSubmission
        var skipBayouSubmission
        var credentialProvider = ""

        var iHaveOnlineAccount = "Yes"
        credentialProvider = "Bayou"
        skipUsageSubmission = "No"
        skipBayouSubmission = "No"
        if (dealaddressSameCheckboxField.checked) {
          dealmailingAddressField = dealserviceAddressField
          dealmailingAddress2Field = dealserviceAddress2Field
          dealmailingCityField = dealserviceCityField
          dealmailingStateField = dealserviceStateField
          dealmailingZipCodeField = dealserviceZipCodeField
        }
        var uanLable1, uanLable2, uanLable3
        var uanValue1, uanValue2, uanValue3
        var isUANrow0Display = true
        var isUANrow1Display = true

        if (uanFieldDisplayarray[0] === "Yes") {
          if (uanAllLabels[0]) {
            uanLable1 = uanAllLabels[0]
          } else {
            uanLable1 = ""
          }
          uanValue1 = allAccountNumbers[0]
        } else if (uanFieldDisplayarray[0] === "No") {
          isUANrow0Display = false
          if (uanFieldIntDesArray[0]) {
            uanLable1 = uanFieldIntDesArray[0]
          } else {
            uanLable1 = ""
          }

          if (uanFieldDefault[0]) {
            uanValue1 = uanFieldDefault[0]
          } else {
            uanValue1 = ""
          }
        }

        if (uanFieldDisplayarray[1] === "Yes") {
          if (uanAllLabels[1]) {
            uanLable2 = uanAllLabels[1]
          } else {
            uanLable2 = ""
          }
          if (isUANrow0Display === true) {
            uanValue2 = allAccountNumbers[1]
          } else {
            uanValue2 = allAccountNumbers[0]
          }
        } else if (uanFieldDisplayarray[1] === "No") {
          isUANrow1Display = false
          if (uanFieldIntDesArray[1]) {
            uanLable2 = uanFieldIntDesArray[1]
          } else {
            uanLable2 = ""
          }
          if (uanFieldDefault[1]) {
            uanValue2 = uanFieldDefault[1]
          } else {
            uanValue2 = ""
          }
        }

        if (uanFieldDisplayarray[2] === "Yes") {
          if (uanAllLabels[2]) {
            uanLable3 = uanAllLabels[2]
          } else {
            uanLable3 = ""
          }
          if (isUANrow0Display === true && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[2]
          } else if (isUANrow0Display === false && isUANrow1Display === false) {
            uanValue3 = allAccountNumbers[0]
          } else if (isUANrow0Display === true && isUANrow1Display === false) {
            uanValue3 = allAccountNumbers[1]
          } else if (isUANrow0Display === false && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[1]
          }
        } else if (uanFieldDisplayarray[2] === "No") {
          if (uanFieldIntDesArray[2]) {
            uanLable3 = uanFieldIntDesArray[2]
          } else {
            uanLable3 = ""
          }
          if (uanFieldDefault[2]) {
            uanValue3 = uanFieldDefault[2]
          } else {
            uanValue3 = ""
          }
        }

        var dealId = storage.rawGet("dealId")
        var concatenatedValue
        if (uanValue1 != null && uanValue1 !== "") {
          concatenatedValue = uanValue1
        }
        if (uanValue2 != null && uanValue2 !== "") {
          concatenatedValue += `-${uanValue2}`
        }
        if (uanValue3 != null && uanValue3 !== "") {
          concatenatedValue += `-${uanValue3}`
        }
        storage.rawSet("combined_utility_account_number", concatenatedValue)
        storage.rawSet("uan1Value", uanValue1)
        storage.rawSet("uan2Value", uanValue2)
        var nolmiofferId = storage.rawGet("offerIdNoLMI")
        var catchdata = ""

        var FarmCity = storage.rawGet("FarmCity")

        var endDate = document.getElementById("edomrbp").value
        var startDate = document.getElementById("sdofbp").value
        var startDatea = getStartDate(startDate)
        var endDatea = getEndDate(endDate)
        const endDate1 = new Date(endDatea)
        const today1 = new Date()
        const isCurrentMonth =
          endDate1.getMonth() === today1.getMonth() && endDate1.getFullYear() === today1.getFullYear()

        if (isCurrentMonth) {
          const yesterday = new Date(today1)
          yesterday.setDate(today1.getDate() - 1)
          endDatea = formatDateAsMMDDYYYY(yesterday)
        } else {
          endDatea = formatToMMDDYYYY(endDatea)
        }

        var totalUsage = document.getElementById("totalKwhUsage").value
        const totalDays = getDaysBetween(startDate, endDate)

        startDatea = formatToMMDDYYYY(startDatea)

        var electricity_consumption_Wh = totalUsage * 1000
        var electricity_consumption_davg_Wh = (totalUsage * 1000) / totalDays
        var electricity_consumption_Watts = (totalUsage * 1000) / (totalDays * 24)
        var electricity_consumption_kWh = totalUsage
        var electricity_consumption_davg_kWh = totalUsage / totalDays
        var electricity_consumption_kWatts = totalUsage / (totalDays * 24)

        var utilityRate = storage.rawGet("UtilityRate")
        var subSizingFactor = storage.rawGet("SubSizingFactor")
        var standardRate = storage.rawGet("standardRate")
        var _lmiNseRate = storage.rawGet("lmiNseRate")
        var acSystemSize = storage.rawGet("acSystemSize")
        var acKwh = storage.rawGet("acKwh")

        var subscription_size_kWAC =
          (((electricity_consumption_kWh / totalDays) * 365 * subSizingFactor) / acKwh) * acSystemSize
        var gross_electricity_production = (electricity_consumption_kWh / totalDays) * 365 * subSizingFactor
        var estimatedAnnualEleCost = gross_electricity_production * utilityRate
        var payment_amount_per_kwh = utilityRate * standardRate

        storage.rawSet("usage_period_from", startDatea)
        storage.rawSet("usage_period_to", endDatea)
        storage.rawSet("usage_period_days", totalDays)
        storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
        storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
        storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
        storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
        storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
        storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)

        storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
        storage.rawSet("gross_electricity_production", gross_electricity_production)
        storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
        storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)
        storage.rawSet("manualUsageEntry", "Yes")

        storage.rawSet("serviceCity", dealserviceCityField)

        var psvrMulti = "Manual Usage (IL)"
        if (totalUsage && totalUsage >= 25000) {
          psvrMulti = "Manual Usage (IL);Oversized Usage"
        } else {
          psvrMulti = "Manual Usage (IL)"
        }

        var manualInputReason = ""
        if (credNotVerified === true) {
          manualInputReason = "Credentials Not Verified"
        } else {
          manualInputReason = "Accounts Not Found"
        }

        var [startMonth, startDay, startYear] = startDatea.split("/")
        var [endMonth, endDay, endYear] = endDatea.split("/")
        var startDateForCelender = new Date(Date.UTC(startYear, startMonth - 1, startDay))
        startDateForCelender = startDateForCelender.toISOString()
        var endDateForCelender = new Date(Date.UTC(endYear, endMonth - 1, endDay))
        endDateForCelender = endDateForCelender.toISOString()

        storage.rawSet("isManualSubmission", "Yes")

        try {
          const data = {
            properties: {
              deal_id: dealId,
              do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
              credential_provider: credentialProvider,
              enrollmentsessionid: enrollmentSessionID,
              skip_usage_submission: skipUsageSubmission,
              bayous_utility_id: bayouUtility,
              bayous_type: bayouTokenType,
              bayous_id: bayouId,
              bayous_onboarding_token: bayouToken,
              uan_1_label: uanLable1,
              uan_1_value: uanValue1,
              uan_2_label: uanLable2,
              uan_2_value: uanValue2,
              uan_3_label: uanLable3,
              uan_3_value: uanValue3,
              manual_input_reason: manualInputReason,
              post_submission_verification_reason: "Manual Usage",
              utility_bill_file_1_url: lmiFile1,
              utility_bill_file_2_url: lmiFile2,
              utility_bill_file_3_url: lmiFile3,
              utility_bill_file_4_url: lmiFile4,
              utility_bill_file_5_url: lmiFile5,
              utility_bill_file_6_url: lmiFile6,
              utility_bill_file_7_url: lmiFile7,
              utility_bill_file_8_url: lmiFile8,
              utility_bill_file_9_url: lmiFile9,
              utility_bill_file_10_: lmiFile10,
              utility_bill_file_11_: lmiFile11,
              utility_bill_file_12_: lmiFile12,
              utility_bill_file_1_id: lmiId1,
              utility_bill_file_2_id: lmiId2,
              utility_bill_file_3_id: lmiId3,
              utility_bill_file_4_id: lmiId4,
              utility_bill_file_5_id: lmiId5,
              utility_bill_file_6_id: lmiId6,
              utility_bill_file_7_id: lmiId7,
              utility_bill_file_8_id: lmiId8,
              utility_bill_file_9_id: lmiId9,
              utility_bill_file_10_id: lmiId10,
              utility_bill_file_11_id: lmiId11,
              utility_bill_file_12_id: lmiId12,
              skip_bayou_submission: skipBayouSubmission,
              combined_utility_account_number: concatenatedValue,
              mfa_required: mfaRequired,
              uan_2_internal_value: additionalAttributeItem,
              mail_street_address: dealmailingAddressField,
              mail_street_address_2: dealmailingAddress2Field,
              mail_city: dealmailingCityField,
              mail_state: dealmailingStateField,
              mail_postal_code: dealmailingZipCodeField,
              street_address: dealserviceAddressField,
              street_address_2: dealserviceAddress2Field,
              city: dealserviceCityField,
              service_state_abbreviation: dealserviceStateField,
              postal_code: dealserviceZipCodeField,
              county: dealserviceStateField,
              manual_usage_entry: "Yes",
              manual_total_kwh_usage_: totalUsage,
              manual_reading_start_date: startDatea,
              manual_reading_end_date: endDatea,
              il_manual_usage_period_days: totalDays,
              usage_period_from: startDateForCelender,
              usage_period_to: endDateForCelender,
              usage_period_days: totalDays,
              usage_quantity: totalUsage,
              electricity_consumption_wh: electricity_consumption_Wh,
              electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
              electricity_consumption_watts: electricity_consumption_Watts,
              electricity_consumption_kwh: electricity_consumption_kWh,
              electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
              electricity_consumption_kwatts: electricity_consumption_kWatts,
              utility_rate: utilityRate,
              payment_amount_per_kwh: payment_amount_per_kwh,
              sub_sizing_factor: subSizingFactor,
              subscription_size_kwac: subscription_size_kWAC,
              gross_electricity_production: gross_electricity_production,
              il_manual_electricity_consumption_wh: electricity_consumption_Wh,
              il_manual_electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
              il_manual_electricity_consumption_watts: electricity_consumption_Watts,
              il_manual_electricity_consumption_kwh: electricity_consumption_kWh,
              il_manual_electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
              il_manual_electricity_consumption_kwatts: electricity_consumption_kWatts,
              il_manual_payment_amount_per_kwh: payment_amount_per_kwh,
              il_manual_subscription_size_kwac: subscription_size_kWAC,
              il_manual_gross_electricity_production: gross_electricity_production,
              product_offer_id: nolmiofferId,
              name_1: "Credit Card Fee",
              amount_1: "2.90%",
              form_type: "csf_form",
              spanish_pdf: "No",
              invoice_type: "Electronic",
              payment_frequency: "Monthly, within 60 days after energization",
              subscription_type: "Price per kWh produced by subscription",
              when_applicable_1: "Applicable for Credit Card Payments",
              provider_email: "customercare@nautilussolar.com",
              provider_phone_number: "8669694129",
              provider_website: "www.nautilussolar.com",
              provider_address_dba_name: "Nautilus Community Solar, LLC",
              il_provider_company_name: "Nautilus US Power Holdco, LLC",
              minimum_level_guarantee: "no",
              termination_circ:
                "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
              require_ares: "No",
              terms_years: "20",
              il_payment_method: "ACH",
              initial_amount: "0",
              vendor_id: "2177",
              nearest_inhabited_area: FarmCity,
              post_submission_verification_reason_multi: psvrMulti,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          if (response.ok) {
            storage.rawSet("skipUsage", "No")
            storage.rawSet("utilityProvider", "Bayou")
            await checkConsentConfigurationVariation()
          }
          const result = await response.json()
          responseFromAPI = JSON.stringify(result)
        } catch (error) {
          closeProgressBar()
          console.error("Error:", error)
        }
      } else {
        var _email = storage.rawGet("userEmail")
        var _dealnameField = document.querySelector(".selectedItemDetails #name").value.trim()
        var dealserviceAddressField = document.querySelector(".selectedItemDetails #serviceAddress").value.trim()
        var dealserviceAddress2Field = document.querySelector(".selectedItemDetails #serviceAddress2").value.trim()
        if (
          dealserviceAddress2Field == null ||
          dealserviceAddress2Field === "null" ||
          dealserviceAddress2Field === undefined
        ) {
          dealserviceAddress2Field = ""
        }
        var dealserviceCityField = document.querySelector(".selectedItemDetails #serviceCity").value.trim()
        storage.rawSet("city", dealserviceCityField)
        var dealserviceStateField = document.querySelector(".selectedItemDetails #serviceState").value.trim()
        var dealserviceZipCodeField = document.querySelector(".selectedItemDetails #serviceZipCode").value.trim()
        var _dealserviceAddAttField = document.querySelector(".selectedItemDetails #serviceAddAtt").value.trim()
        var dealaddressSameCheckboxField = document.querySelector(".selectedItemDetails #addressSameCheckbox")
        var dealmailingAddressField = document.querySelector(".selectedItemDetails #mailingAddress").value.trim()
        var dealmailingAddress2Field = document.querySelector(".selectedItemDetails #mailingAddress2").value.trim()
        var dealmailingCityField = document.querySelector(".selectedItemDetails #mailingCity").value.trim()
        var dealmailingStateField = document.querySelector(".selectedItemDetails #mailingState").value.trim()
        var dealmailingZipCodeField = document.querySelector(".selectedItemDetails #mailingZipCode").value.trim()
        var skipUsageSubmission
        var skipBayouSubmission
        var credentialProvider = ""

        var iHaveOnlineAccount = "Yes"
        credentialProvider = "Bayou"
        skipUsageSubmission = "No"
        skipBayouSubmission = "No"
        if (dealaddressSameCheckboxField.checked) {
          dealmailingAddressField = dealserviceAddressField
          dealmailingAddress2Field = dealserviceAddress2Field
          dealmailingCityField = dealserviceCityField
          dealmailingStateField = dealserviceStateField
          dealmailingZipCodeField = dealserviceZipCodeField
        }
        var uanLable1, uanLable2, uanLable3
        var uanValue1, uanValue2, uanValue3
        var isUANrow0Display = true
        var isUANrow1Display = true

        if (uanFieldDisplayarray[0] === "Yes") {
          if (uanAllLabels[0]) {
            uanLable1 = uanAllLabels[0]
          } else {
            uanLable1 = ""
          }
          uanValue1 = bayouAccountNo
        } else if (uanFieldDisplayarray[0] === "No") {
          isUANrow0Display = false
          if (uanFieldIntDesArray[0]) {
            uanLable1 = uanFieldIntDesArray[0]
          } else {
            uanLable1 = ""
          }

          if (uanFieldDefault[0]) {
            uanValue1 = uanFieldDefault[0]
          } else {
            uanValue1 = ""
          }
        }

        if (uanFieldDisplayarray[1] === "Yes") {
          if (uanAllLabels[1]) {
            uanLable2 = uanAllLabels[1]
          } else {
            uanLable2 = ""
          }
          if (isUANrow0Display === true) {
            uanValue2 = additionalAttributeValue
          } else {
            uanValue2 = bayouAccountNo
          }
        } else if (uanFieldDisplayarray[1] === "No") {
          isUANrow1Display = false
          if (uanFieldIntDesArray[1]) {
            uanLable2 = uanFieldIntDesArray[1]
          } else {
            uanLable2 = ""
          }
          if (uanFieldDefault[1]) {
            uanValue2 = uanFieldDefault[1]
          } else {
            uanValue2 = ""
          }
        }

        if (uanFieldDisplayarray[2] === "Yes") {
          if (uanAllLabels[2]) {
            uanLable3 = uanAllLabels[2]
          } else {
            uanLable3 = ""
          }
          if (isUANrow0Display === true && isUANrow1Display === true) {
            uanValue3 = allAccountNumbers[2]
          } else if (isUANrow0Display === false && isUANrow1Display === false) {
            uanValue3 = bayouAccountNo
          } else if (isUANrow0Display === true && isUANrow1Display === false) {
            uanValue3 = additionalAttributeValue
          } else if (isUANrow0Display === false && isUANrow1Display === true) {
            uanValue3 = additionalAttributeValue
          }
        } else if (uanFieldDisplayarray[2] === "No") {
          if (uanFieldIntDesArray[2]) {
            uanLable3 = uanFieldIntDesArray[2]
          } else {
            uanLable3 = ""
          }
          if (uanFieldDefault[2]) {
            uanValue3 = uanFieldDefault[2]
          } else {
            uanValue3 = ""
          }
        }

        var dealId = storage.rawGet("dealId")
        var concatenatedValue
        if (uanValue1 != null && uanValue1 !== "") {
          concatenatedValue = uanValue1
        }
        if (uanValue2 != null && uanValue2 !== "") {
          concatenatedValue += `-${uanValue2}`
        }
        if (uanValue3 != null && uanValue3 !== "") {
          concatenatedValue += `-${uanValue3}`
        }
        storage.rawSet("combined_utility_account_number", concatenatedValue)
        storage.rawSet("uan1Value", uanValue1)
        storage.rawSet("uan2Value", uanValue2)
        var nolmiofferId = storage.rawGet("offerIdNoLMI")
        var catchdata = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
              credential_provider: credentialProvider,
              enrollmentsessionid: enrollmentSessionID,
              skip_usage_submission: skipUsageSubmission,
              bayous_utility_id: bayouUtility,
              bayous_type: bayouTokenType,
              bayous_id: bayouId,
              bayous_onboarding_token: bayouToken,
              uan_1_label: uanLable1,
              uan_1_value: uanValue1,
              uan_2_label: uanLable2,
              uan_2_value: uanValue2,
              uan_3_label: uanLable3,
              uan_3_value: uanValue3,
              meter_id: meterId,
              utility_type: meterType,
              skip_bayou_submission: skipBayouSubmission,
              rate_class: rateClass,
              combined_utility_account_number: concatenatedValue,
              //                         bayous_tarrif: rateClass,
              tarrif_type: rateClass,
              mfa_required: mfaRequired,
              uan_2_internal_value: additionalAttributeItem,
              mail_street_address: dealmailingAddressField,
              mail_street_address_2: dealmailingAddress2Field,
              mail_city: dealmailingCityField,
              mail_state: dealmailingStateField,
              mail_postal_code: dealmailingZipCodeField,
              street_address: dealserviceAddressField,
              street_address_2: dealserviceAddress2Field,
              city: dealserviceCityField,
              service_state_abbreviation: dealserviceStateField,
              postal_code: dealserviceZipCodeField,
              county: dealserviceStateField,
              product_offer_id: nolmiofferId,
              //                             post_submission_verification_reason_multi: ''
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          if (response.ok) {
            if (skipUsage != null) {
              storage.rawSet("skipUsage", skipUsage)
            }
            storage.rawSet("utilityProvider", "Bayou")
            await getBillsandConsumptionData(
              uanValue1,
              meterId,
              additionalAttributeItem,
              additionalAttributeValue,
              null,
              "No",
              "",
            )
          }
          const result = await response.json()
          responseFromAPI = JSON.stringify(result)
        } catch (error) {
          closeProgressBar()
          console.error("Error:", error)
        }
      }
    }
    storage.rawSet("uan_2_internal_value", additionalAttributeItem)
  }
  async function getBillsandConsumptionData(
    accountNumber,
    meterId,
    meterAddAtt,
    meterAddAttVal,
    lmioptionvalue,
    _isLMI,
    psvrMulti,
  ) {
__ea_trace("modules/usage/usage-il-bayou.ts","getBillsandConsumptionData",[accountNumber,meterId,meterAddAtt,meterAddAttVal,lmioptionvalue,_isLMI,psvrMulti],["accountNumber","meterId","meterAddAtt","meterAddAttVal","lmioptionvalue","_isLMI","psvrMulti"]);
    var _contactId = storage.rawGet("contactId")
    var deallId = storage.rawGet("dealId")
    var customerId = storage.rawGet("BayouContactId")
    var FarmCity = storage.rawGet("FarmCity")
    var _catchdata = ""
    try {
      var data
      if (storage.rawGet("utility_id") === "AMCIPS-SF") {
        data = {
          customer_id: customerId,
          account_number: accountNumber,
        }
      } else {
        data = {
          customer_id: customerId,
          account_number: accountNumber,
          meter_id: meterId,
          meter_additional_attribute: meterAddAtt,
          meter_additional_attribute_value: meterAddAttVal,
        }
      }
      const response = await fetch("https://api.nautilussolar.com/api/getConsumption", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      _catchdata = data
      const dataa = await response.json()
      var _consumRes = JSON.stringify(dataa)

      if (response.ok) {
        var usage_period_from = dataa.data.usage_period_from
        var usage_period_to = dataa.data.usage_period_to
        var usage_period_days = dataa.data.usage_period_days
        var electricity_consumption_Wh = dataa.data.electricity_consumption_Wh
        var electricity_consumption_davg_Wh = dataa.data.electricity_consumption_davg_Wh
        var electricity_consumption_Watts = dataa.data.electricity_consumption_Watts
        var electricity_consumption_kWh = dataa.data.electricity_consumption_kWh
        var electricity_consumption_davg_kWh = dataa.data.electricity_consumption_davg_kWh
        var electricity_consumption_kWatts = dataa.data.electricity_consumption_kWatts
        var utilityRate = storage.rawGet("UtilityRate")
        var subSizingFactor = storage.rawGet("SubSizingFactor")
        var standardRate = storage.rawGet("standardRate")
        var lmiNseRate = storage.rawGet("lmiNseRate")
        var acSystemSize = storage.rawGet("acSystemSize")
        var acKwh = storage.rawGet("acKwh")
        var subscription_size_kWAC =
          (((electricity_consumption_kWh / usage_period_days) * 365 * subSizingFactor) / acKwh) * acSystemSize
        var gross_electricity_production = (electricity_consumption_kWh / usage_period_days) * 365 * subSizingFactor
        var estimatedAnnualEleCost = gross_electricity_production * utilityRate

        var isLMI = storage.rawGet("isLMI")

        if ((isLMI = "Yes" && lmioptionvalue != null && lmioptionvalue !== "Threshold Opt-Out")) {
          var _payment_amount_per_kwh = utilityRate * lmiNseRate
        } else {
          var payment_amount_per_kwh = utilityRate * standardRate
        }

        storage.rawSet("usage_period_from", usage_period_from)
        storage.rawSet("usage_period_to", usage_period_to)
        storage.rawSet("usage_period_days", usage_period_days)
        storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
        storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
        storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
        storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
        storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
        storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)
        storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
        storage.rawSet("gross_electricity_production", gross_electricity_production)
        storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
        storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)

        var fileurl0 = "",
          fileurl1 = "",
          fileurl2 = "",
          fileurl3 = "",
          fileurl4 = "",
          fileurl5 = "",
          fileurl6 = "",
          fileurl7 = "",
          fileurl8 = "",
          fileurl9 = "",
          fileurl10 = "",
          fileurl11 = ""
        var fileid0 = "",
          fileid1 = "",
          fileid2 = "",
          fileid3 = "",
          fileid4 = "",
          fileid5 = "",
          fileid6 = "",
          fileid7 = "",
          fileid8 = "",
          fileid9 = "",
          fileid10 = "",
          fileid11 = ""
        for (var i = 0; i < dataa.data.bills.length; i++) {
          if (i === 0) {
            fileurl0 = dataa.data.bills[i].hubspot.url
            fileid0 = dataa.data.bills[i].hubspot.id
          }
          if (i === 1) {
            fileurl1 = dataa.data.bills[i].hubspot.url
            fileid1 = dataa.data.bills[i].hubspot.id
          }
          if (i === 2) {
            fileurl2 = dataa.data.bills[i].hubspot.url
            fileid2 = dataa.data.bills[i].hubspot.id
          }
          if (i === 3) {
            fileurl3 = dataa.data.bills[i].hubspot.url
            fileid3 = dataa.data.bills[i].hubspot.id
          }
          if (i === 4) {
            fileurl4 = dataa.data.bills[i].hubspot.url
            fileid4 = dataa.data.bills[i].hubspot.id
          }
          if (i === 5) {
            fileurl5 = dataa.data.bills[i].hubspot.url
            fileid5 = dataa.data.bills[i].hubspot.id
          }
          if (i === 6) {
            fileurl6 = dataa.data.bills[i].hubspot.url
            fileid6 = dataa.data.bills[i].hubspot.id
          }
          if (i === 7) {
            fileurl7 = dataa.data.bills[i].hubspot.url
            fileid7 = dataa.data.bills[i].hubspot.id
          }
          if (i === 8) {
            fileurl8 = dataa.data.bills[i].hubspot.url
            fileid8 = dataa.data.bills[i].hubspot.id
          }
          if (i === 9) {
            fileurl9 = dataa.data.bills[i].hubspot.url
            fileid9 = dataa.data.bills[i].hubspot.id
          }
          if (i === 10) {
            fileurl10 = dataa.data.bills[i].hubspot.url
            fileid10 = dataa.data.bills[i].hubspot.id
          }
          if (i === 11) {
            fileurl11 = dataa.data.bills[i].hubspot.url
            fileid11 = dataa.data.bills[i].hubspot.id
          }
          if (i === 0) {
          }
        }
        const consumption = Number(electricity_consumption_davg_kWh)
        if (!Number.isNaN(consumption) && consumption >= 68.5) {
          psvrMulti = "Oversized Usage"
          if (isLMI === "Yes" && lmioptionvalue !== "Threshold Opt-Out") {
            psvrMulti = "LMI Review;Oversized Usage"
          }
        } else {
          if (isLMI === "Yes" && lmioptionvalue !== "Threshold Opt-Out") {
            psvrMulti = "LMI Review"
          }
        }
      } else {
        if (getConsumpionCount <= 10) {
          isGetConsumptionFaild = false
          closeNoAccountAlert()
          checkedValue = ""
          document.querySelector("#euiLabel").style.display = "none"
          document.querySelector("#euiHelpText").style.display = "none"
          document.querySelector("#totalKwhUsageHelpImageText").style.display = "none"
          document.querySelector(".elec-usage-info-manual").style.display = "none"
          document.querySelector(".utilityPictureIpiaap3Wrapper").style.display = "none"
          setTimeout(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
            openProgressBar("We are securing your data.")
            await getBillsandConsumptionData(
              accountNumber,
              meterId,
              meterAddAtt,
              meterAddAttVal,
              lmioptionvalue,
              isLMI,
              psvrMulti,
            )
          }, 2000)
          getConsumpionCount++
        } else {
          isGetConsumptionFaild = true
          openNoAccountAlert()
          checkedValue = "manualFile"
          document.querySelector("#euiLabel").innerHTML = "Collection of Usage Details"
          document.querySelector("#euiLabel").style.display = "block"
          document.querySelector("#euiHelpText").style.display = "block"
          document.querySelector("#totalKwhUsageHelpImageText").style.display = "block"
          document.querySelector(".elec-usage-info-manual").style.display = "block"
          document.querySelector(".utilityPictureIpiaap3Wrapper").style.display = "block"
        }
        return
      }
      try {
        const prop = {
          properties: {
            deal_id: deallId,
            usage_period_from: usage_period_from,
            usage_period_to: usage_period_to,
            usage_period_days: usage_period_days,
            electricity_consumption_wh: electricity_consumption_Wh,
            electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
            electricity_consumption_watts: electricity_consumption_Watts,
            electricity_consumption_kwh: electricity_consumption_kWh,
            electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
            electricity_consumption_kwatts: electricity_consumption_kWatts,
            utility_rate: utilityRate,
            payment_amount_per_kwh: payment_amount_per_kwh,
            sub_sizing_factor: subSizingFactor,
            subscription_size_kwac: subscription_size_kWAC,
            gross_electricity_production: gross_electricity_production,
            utility_bill_file_1_url: fileurl0,
            utility_bill_file_2_url: fileurl1,
            utility_bill_file_3_url: fileurl2,
            utility_bill_file_4_url: fileurl3,
            utility_bill_file_5_url: fileurl4,
            utility_bill_file_6_url: fileurl5,
            utility_bill_file_7_url: fileurl6,
            utility_bill_file_8_url: fileurl7,
            utility_bill_file_9_url: fileurl8,
            utility_bill_file_10_: fileurl9,
            utility_bill_file_11_: fileurl10,
            utility_bill_file_12_: fileurl11,
            utility_bill_file_1_id: fileid0,
            utility_bill_file_2_id: fileid1,
            utility_bill_file_3_id: fileid2,
            utility_bill_file_4_id: fileid3,
            utility_bill_file_5_id: fileid4,
            utility_bill_file_6_id: fileid5,
            utility_bill_file_7_id: fileid6,
            utility_bill_file_8_id: fileid7,
            utility_bill_file_9_id: fileid8,
            utility_bill_file_10_id: fileid9,
            utility_bill_file_11_id: fileid10,
            utility_bill_file_12_id: fileid11,
            name_1: "Credit Card Fee",
            amount_1: "2.90%",
            form_type: "csf_form",
            spanish_pdf: "No",
            invoice_type: "Electronic",
            payment_frequency: "Monthly, within 60 days after energization",
            subscription_type: "Price per kWh produced by subscription",
            when_applicable_1: "Applicable for Credit Card Payments",
            provider_email: "customercare@nautilussolar.com",
            provider_phone_number: "8669694129",
            provider_website: "www.nautilussolar.com",
            provider_address_dba_name: "Nautilus Community Solar, LLC",
            il_provider_company_name: "Nautilus US Power Holdco, LLC",
            minimum_level_guarantee: "no",
            termination_circ:
              "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
            require_ares: "No",
            terms_years: "20",
            il_payment_method: "ACH",
            initial_amount: "0",
            vendor_id: "2177",
            nearest_inhabited_area: FarmCity,
            post_submission_verification_reason_multi: psvrMulti,
            //                         consumption_data_response: consumRes
          },
        }
        const resp = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(prop),
        })
        _catchdata = prop
        if (resp.ok) {
          await checkConsentConfigurationVariation()
        }

        const res = await resp.json()
        responseFromAPI = JSON.stringify(res)
      } catch (error) {
        console.error("Error:", error)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function addManualCunsomptionData(url, _skipUsage, isLMII, id) {
__ea_trace("modules/usage/usage-il-bayou.ts","addManualCunsomptionData",[url,_skipUsage,isLMII,id],["url","_skipUsage","isLMII","id"]);
    if (isLMII === "Yes") {
      var lmiFile1,
        lmiFile2,
        lmiFile3,
        lmiFile4,
        lmiFile5,
        lmiFile6,
        lmiFile7,
        lmiFile8,
        lmiFile9,
        lmiFile10,
        lmiFile11,
        lmiFile12
      var lmiId1, lmiId2, lmiId3, lmiId4, lmiId5, lmiId6, lmiId7, lmiId8, lmiId9, lmiId10, lmiId11, lmiId12

      if (url !== undefined) {
        if (url[0]) {
          lmiFile1 = url[0]
        } else {
          lmiFile1 = ""
        }
        if (url[1]) {
          lmiFile2 = url[1]
        } else {
          lmiFile2 = ""
        }
        if (url[2]) {
          lmiFile3 = url[2]
        } else {
          lmiFile3 = ""
        }
        if (url[3]) {
          lmiFile4 = url[3]
        } else {
          lmiFile4 = ""
        }
        if (url[4]) {
          lmiFile5 = url[4]
        } else {
          lmiFile5 = ""
        }
        if (url[5]) {
          lmiFile6 = url[5]
        } else {
          lmiFile6 = ""
        }
        if (url[6]) {
          lmiFile7 = url[6]
        } else {
          lmiFile7 = ""
        }
        if (url[7]) {
          lmiFile8 = url[7]
        } else {
          lmiFile8 = ""
        }
        if (url[8]) {
          lmiFile9 = url[8]
        } else {
          lmiFile9 = ""
        }
        if (url[9]) {
          lmiFile10 = url[9]
        } else {
          lmiFile10 = ""
        }
        if (url[10]) {
          lmiFile11 = url[10]
        } else {
          lmiFile11 = ""
        }
        if (url[11]) {
          lmiFile12 = url[11]
        } else {
          lmiFile12 = ""
        }
      } else {
        lmiFile1 = ""
        lmiFile2 = ""
        lmiFile3 = ""
        lmiFile4 = ""
        lmiFile5 = ""
        lmiFile6 = ""
        lmiFile7 = ""
        lmiFile8 = ""
        lmiFile9 = ""
        lmiFile10 = ""
        lmiFile11 = ""
        lmiFile12 = ""
      }

      if (id !== undefined) {
        if (id[0]) {
          lmiId1 = id[0]
        } else {
          lmiId1 = ""
        }
        if (id[1]) {
          lmiId2 = id[1]
        } else {
          lmiId2 = ""
        }
        if (id[2]) {
          lmiId3 = id[2]
        } else {
          lmiId3 = ""
        }
        if (id[3]) {
          lmiId4 = id[3]
        } else {
          lmiId4 = ""
        }
        if (id[4]) {
          lmiId5 = id[4]
        } else {
          lmiId5 = ""
        }
        if (id[5]) {
          lmiId6 = id[5]
        } else {
          lmiId6 = ""
        }
        if (id[6]) {
          lmiId7 = id[6]
        } else {
          lmiId7 = ""
        }
        if (id[7]) {
          lmiId8 = id[7]
        } else {
          lmiId8 = ""
        }
        if (id[8]) {
          lmiId9 = id[8]
        } else {
          lmiId9 = ""
        }
        if (id[9]) {
          lmiId10 = id[9]
        } else {
          lmiId10 = ""
        }
        if (id[10]) {
          lmiId11 = id[10]
        } else {
          lmiId11 = ""
        }
        if (id[11]) {
          lmiId12 = id[11]
        } else {
          lmiId12 = ""
        }
      } else {
        lmiId1 = ""
        lmiId2 = ""
        lmiId3 = ""
        lmiId4 = ""
        lmiId5 = ""
        lmiId6 = ""
        lmiId7 = ""
        lmiId8 = ""
        lmiId9 = ""
        lmiId10 = ""
        lmiId11 = ""
        lmiId12 = ""
      }
      var _email = storage.rawGet("userEmail")
      var dealId = storage.rawGet("dealId")
      var catchdata = ""
      var FarmCity = storage.rawGet("FarmCity")
      var endDate = document.getElementById("edomrbp").value
      var startDate = document.getElementById("sdofbp").value
      var startDatea = getStartDate(startDate)
      var endDatea = getEndDate(endDate)
      const endDate1 = new Date(endDatea)
      const today1 = new Date()
      const isCurrentMonth =
        endDate1.getMonth() === today1.getMonth() && endDate1.getFullYear() === today1.getFullYear()

      if (isCurrentMonth) {
        const yesterday = new Date(today1)
        yesterday.setDate(today1.getDate() - 1)
        endDatea = formatDateAsMMDDYYYY(yesterday)
      } else {
        endDatea = formatToMMDDYYYY(endDatea)
      }

      var totalUsage = document.getElementById("totalKwhUsage").value
      const totalDays = getDaysBetween(startDate, endDate)

      startDatea = formatToMMDDYYYY(startDatea)

      var electricity_consumption_Wh = totalUsage * 1000
      var electricity_consumption_davg_Wh = (totalUsage * 1000) / totalDays
      var electricity_consumption_Watts = (totalUsage * 1000) / (totalDays * 24)
      var electricity_consumption_kWh = totalUsage
      var electricity_consumption_davg_kWh = totalUsage / totalDays
      var electricity_consumption_kWatts = totalUsage / (totalDays * 24)

      var utilityRate = storage.rawGet("UtilityRate")
      var subSizingFactor = storage.rawGet("SubSizingFactor")
      var standardRate = storage.rawGet("standardRate")
      var _lmiNseRate = storage.rawGet("lmiNseRate")
      var acSystemSize = storage.rawGet("acSystemSize")
      var acKwh = storage.rawGet("acKwh")

      var subscription_size_kWAC =
        (((electricity_consumption_kWh / totalDays) * 365 * subSizingFactor) / acKwh) * acSystemSize
      var gross_electricity_production = (electricity_consumption_kWh / totalDays) * 365 * subSizingFactor
      var estimatedAnnualEleCost = gross_electricity_production * utilityRate
      var payment_amount_per_kwh = utilityRate * standardRate

      storage.rawSet("usage_period_from", startDatea)
      storage.rawSet("usage_period_to", endDatea)
      storage.rawSet("usage_period_days", totalDays)
      storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
      storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
      storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
      storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
      storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
      storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)

      storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
      storage.rawSet("gross_electricity_production", gross_electricity_production)
      storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
      storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)
      storage.rawSet("manualUsageEntry", "No")

      var manualInputReason = ""
      manualInputReason = "Get Consumption Failure"

      var [startMonth, startDay, startYear] = startDatea.split("/")
      var [endMonth, endDay, endYear] = endDatea.split("/")
      var startDateForCelender = new Date(Date.UTC(startYear, startMonth - 1, startDay))
      startDateForCelender = startDateForCelender.toISOString()
      var endDateForCelender = new Date(Date.UTC(endYear, endMonth - 1, endDay))
      endDateForCelender = endDateForCelender.toISOString()

      try {
        const data = {
          properties: {
            deal_id: dealId,
            manual_input_reason: manualInputReason,
            post_submission_verification_reason: manualInputReason,
            manual_total_kwh_usage_: totalUsage,
            manual_reading_start_date: startDatea,
            manual_reading_end_date: endDatea,
            il_manual_usage_period_days: totalDays,
            usage_period_from: startDateForCelender,
            usage_period_to: endDateForCelender,
            usage_period_days: totalDays,
            usage_quantity: totalUsage,
            electricity_consumption_wh: electricity_consumption_Wh,
            electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
            electricity_consumption_watts: electricity_consumption_Watts,
            electricity_consumption_kwh: electricity_consumption_kWh,
            electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
            electricity_consumption_kwatts: electricity_consumption_kWatts,
            utility_rate: utilityRate,
            payment_amount_per_kwh: payment_amount_per_kwh,
            sub_sizing_factor: subSizingFactor,
            subscription_size_kwac: subscription_size_kWAC,
            gross_electricity_production: gross_electricity_production,
            il_manual_electricity_consumption_wh: electricity_consumption_Wh,
            il_manual_electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
            il_manual_electricity_consumption_watts: electricity_consumption_Watts,
            il_manual_electricity_consumption_kwh: electricity_consumption_kWh,
            il_manual_electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
            il_manual_electricity_consumption_kwatts: electricity_consumption_kWatts,
            il_manual_payment_amount_per_kwh: payment_amount_per_kwh,
            il_manual_subscription_size_kwac: subscription_size_kWAC,
            il_manual_gross_electricity_production: gross_electricity_production,
            utility_bill_file_1_url: lmiFile1,
            utility_bill_file_2_url: lmiFile2,
            utility_bill_file_3_url: lmiFile3,
            utility_bill_file_4_url: lmiFile4,
            utility_bill_file_5_url: lmiFile5,
            utility_bill_file_6_url: lmiFile6,
            utility_bill_file_7_url: lmiFile7,
            utility_bill_file_8_url: lmiFile8,
            utility_bill_file_9_url: lmiFile9,
            utility_bill_file_10_: lmiFile10,
            utility_bill_file_11_: lmiFile11,
            utility_bill_file_12_: lmiFile12,
            utility_bill_file_1_id: lmiId1,
            utility_bill_file_2_id: lmiId2,
            utility_bill_file_3_id: lmiId3,
            utility_bill_file_4_id: lmiId4,
            utility_bill_file_5_id: lmiId5,
            utility_bill_file_6_id: lmiId6,
            utility_bill_file_7_id: lmiId7,
            utility_bill_file_8_id: lmiId8,
            utility_bill_file_9_id: lmiId9,
            utility_bill_file_10_id: lmiId10,
            utility_bill_file_11_id: lmiId11,
            utility_bill_file_12_id: lmiId12,
            name_1: "Credit Card Fee",
            amount_1: "2.90%",
            form_type: "csf_form",
            spanish_pdf: "No",
            invoice_type: "Electronic",
            payment_frequency: "Monthly, within 60 days after energization",
            subscription_type: "Price per kWh produced by subscription",
            when_applicable_1: "Applicable for Credit Card Payments",
            provider_email: "customercare@nautilussolar.com",
            provider_phone_number: "8669694129",
            provider_website: "www.nautilussolar.com",
            provider_address_dba_name: "Nautilus Community Solar, LLC",
            il_provider_company_name: "Nautilus US Power Holdco, LLC",
            minimum_level_guarantee: "no",
            termination_circ:
              "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
            require_ares: "No",
            terms_years: "20",
            il_payment_method: "ACH",
            initial_amount: "0",
            vendor_id: "2177",
            nearest_inhabited_area: FarmCity,
          },
        }
        const response = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        catchdata = data
        if (response.ok) {
          storage.rawSet("skipUsage", "No")
          storage.rawSet("utilityProvider", "Bayou")
          await checkConsentConfigurationVariation()
        }
        const result = await response.json()
        responseFromAPI = JSON.stringify(result)
      } catch (error) {
        closeProgressBar()
        console.error("Error:", error)
      }
    } else {
      var lmiFile1,
        lmiFile2,
        lmiFile3,
        lmiFile4,
        lmiFile5,
        lmiFile6,
        lmiFile7,
        lmiFile8,
        lmiFile9,
        lmiFile10,
        lmiFile11,
        lmiFile12
      var lmiId1, lmiId2, lmiId3, lmiId4, lmiId5, lmiId6, lmiId7, lmiId8, lmiId9, lmiId10, lmiId11, lmiId12
      if (url !== undefined) {
        if (url[0]) {
          lmiFile1 = url[0]
        } else {
          lmiFile1 = ""
        }
        if (url[1]) {
          lmiFile2 = url[1]
        } else {
          lmiFile2 = ""
        }
        if (url[2]) {
          lmiFile3 = url[2]
        } else {
          lmiFile3 = ""
        }
        if (url[3]) {
          lmiFile4 = url[3]
        } else {
          lmiFile4 = ""
        }
        if (url[4]) {
          lmiFile5 = url[4]
        } else {
          lmiFile5 = ""
        }
        if (url[5]) {
          lmiFile6 = url[5]
        } else {
          lmiFile6 = ""
        }
        if (url[6]) {
          lmiFile7 = url[6]
        } else {
          lmiFile7 = ""
        }
        if (url[7]) {
          lmiFile8 = url[7]
        } else {
          lmiFile8 = ""
        }
        if (url[8]) {
          lmiFile9 = url[8]
        } else {
          lmiFile9 = ""
        }
        if (url[9]) {
          lmiFile10 = url[9]
        } else {
          lmiFile10 = ""
        }
        if (url[10]) {
          lmiFile11 = url[10]
        } else {
          lmiFile11 = ""
        }
        if (url[11]) {
          lmiFile12 = url[11]
        } else {
          lmiFile12 = ""
        }
      } else {
        lmiFile1 = ""
        lmiFile2 = ""
        lmiFile3 = ""
        lmiFile4 = ""
        lmiFile5 = ""
        lmiFile6 = ""
        lmiFile7 = ""
        lmiFile8 = ""
        lmiFile9 = ""
        lmiFile10 = ""
        lmiFile11 = ""
        lmiFile12 = ""
      }

      if (id !== undefined) {
        if (id[0]) {
          lmiId1 = id[0]
        } else {
          lmiId1 = ""
        }
        if (id[1]) {
          lmiId2 = id[1]
        } else {
          lmiId2 = ""
        }
        if (id[2]) {
          lmiId3 = id[2]
        } else {
          lmiId3 = ""
        }
        if (id[3]) {
          lmiId4 = id[3]
        } else {
          lmiId4 = ""
        }
        if (id[4]) {
          lmiId5 = id[4]
        } else {
          lmiId5 = ""
        }
        if (id[5]) {
          lmiId6 = id[5]
        } else {
          lmiId6 = ""
        }
        if (id[6]) {
          lmiId7 = id[6]
        } else {
          lmiId7 = ""
        }
        if (id[7]) {
          lmiId8 = id[7]
        } else {
          lmiId8 = ""
        }
        if (id[8]) {
          lmiId9 = id[8]
        } else {
          lmiId9 = ""
        }
        if (id[9]) {
          lmiId10 = id[9]
        } else {
          lmiId10 = ""
        }
        if (id[10]) {
          lmiId11 = id[10]
        } else {
          lmiId11 = ""
        }
        if (id[11]) {
          lmiId12 = id[11]
        } else {
          lmiId12 = ""
        }
      } else {
        lmiId1 = ""
        lmiId2 = ""
        lmiId3 = ""
        lmiId4 = ""
        lmiId5 = ""
        lmiId6 = ""
        lmiId7 = ""
        lmiId8 = ""
        lmiId9 = ""
        lmiId10 = ""
        lmiId11 = ""
        lmiId12 = ""
      }
      var _email = storage.rawGet("userEmail")
      var dealId = storage.rawGet("dealId")
      var catchdata = ""
      var FarmCity = storage.rawGet("FarmCity")
      var endDate = document.getElementById("edomrbp").value
      var startDate = document.getElementById("sdofbp").value
      var startDatea = getStartDate(startDate)
      var endDatea = getEndDate(endDate)
      const endDate1 = new Date(endDatea)
      const today1 = new Date()
      const isCurrentMonth =
        endDate1.getMonth() === today1.getMonth() && endDate1.getFullYear() === today1.getFullYear()

      if (isCurrentMonth) {
        const yesterday = new Date(today1)
        yesterday.setDate(today1.getDate() - 1)
        endDatea = formatDateAsMMDDYYYY(yesterday)
      } else {
        endDatea = formatToMMDDYYYY(endDatea)
      }

      var totalUsage = document.getElementById("totalKwhUsage").value
      var totalDays = getDaysBetween(startDate, endDate)

      startDatea = formatToMMDDYYYY(startDatea)

      var electricity_consumption_Wh = totalUsage * 1000
      var electricity_consumption_davg_Wh = (totalUsage * 1000) / totalDays
      var electricity_consumption_Watts = (totalUsage * 1000) / (totalDays * 24)
      var electricity_consumption_kWh = totalUsage
      var electricity_consumption_davg_kWh = totalUsage / totalDays
      var electricity_consumption_kWatts = totalUsage / (totalDays * 24)

      var utilityRate = storage.rawGet("UtilityRate")
      var subSizingFactor = storage.rawGet("SubSizingFactor")
      var standardRate = storage.rawGet("standardRate")
      var _lmiNseRate = storage.rawGet("lmiNseRate")
      var acSystemSize = storage.rawGet("acSystemSize")
      var acKwh = storage.rawGet("acKwh")

      var subscription_size_kWAC =
        (((electricity_consumption_kWh / totalDays) * 365 * subSizingFactor) / acKwh) * acSystemSize
      var gross_electricity_production = (electricity_consumption_kWh / totalDays) * 365 * subSizingFactor
      var estimatedAnnualEleCost = gross_electricity_production * utilityRate
      var payment_amount_per_kwh = utilityRate * standardRate

      storage.rawSet("usage_period_from", startDatea)
      storage.rawSet("usage_period_to", endDatea)
      storage.rawSet("usage_period_days", totalDays)
      storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
      storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
      storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
      storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
      storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
      storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)

      storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
      storage.rawSet("gross_electricity_production", gross_electricity_production)
      storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
      storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)
      storage.rawSet("manualUsageEntry", "No")

      var manualInputReason = ""
      manualInputReason = "Get Consumption Failure"

      var [startMonth, startDay, startYear] = startDatea.split("/")
      var [endMonth, endDay, endYear] = endDatea.split("/")
      var startDateForCelender = new Date(Date.UTC(startYear, startMonth - 1, startDay))
      startDateForCelender = startDateForCelender.toISOString()
      var endDateForCelender = new Date(Date.UTC(endYear, endMonth - 1, endDay))
      endDateForCelender = endDateForCelender.toISOString()

      try {
        const data = {
          properties: {
            deal_id: dealId,
            manual_input_reason: manualInputReason,
            post_submission_verification_reason: manualInputReason,
            manual_total_kwh_usage_: totalUsage,
            manual_reading_start_date: startDatea,
            manual_reading_end_date: endDatea,
            il_manual_usage_period_days: totalDays,
            usage_period_from: startDateForCelender,
            usage_period_to: endDateForCelender,
            usage_period_days: totalDays,
            usage_quantity: totalUsage,
            electricity_consumption_wh: electricity_consumption_Wh,
            electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
            electricity_consumption_watts: electricity_consumption_Watts,
            electricity_consumption_kwh: electricity_consumption_kWh,
            electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
            electricity_consumption_kwatts: electricity_consumption_kWatts,
            utility_rate: utilityRate,
            payment_amount_per_kwh: payment_amount_per_kwh,
            sub_sizing_factor: subSizingFactor,
            subscription_size_kwac: subscription_size_kWAC,
            gross_electricity_production: gross_electricity_production,
            il_manual_electricity_consumption_wh: electricity_consumption_Wh,
            il_manual_electricity_consumption_davg_wh: electricity_consumption_davg_Wh,
            il_manual_electricity_consumption_watts: electricity_consumption_Watts,
            il_manual_electricity_consumption_kwh: electricity_consumption_kWh,
            il_manual_electricity_consumption_davg_kwh: electricity_consumption_davg_kWh,
            il_manual_electricity_consumption_kwatts: electricity_consumption_kWatts,
            il_manual_payment_amount_per_kwh: payment_amount_per_kwh,
            il_manual_subscription_size_kwac: subscription_size_kWAC,
            il_manual_gross_electricity_production: gross_electricity_production,
            utility_bill_file_1_url: lmiFile1,
            utility_bill_file_2_url: lmiFile2,
            utility_bill_file_3_url: lmiFile3,
            utility_bill_file_4_url: lmiFile4,
            utility_bill_file_5_url: lmiFile5,
            utility_bill_file_6_url: lmiFile6,
            utility_bill_file_7_url: lmiFile7,
            utility_bill_file_8_url: lmiFile8,
            utility_bill_file_9_url: lmiFile9,
            utility_bill_file_10_: lmiFile10,
            utility_bill_file_11_: lmiFile11,
            utility_bill_file_12_: lmiFile12,
            utility_bill_file_1_id: lmiId1,
            utility_bill_file_2_id: lmiId2,
            utility_bill_file_3_id: lmiId3,
            utility_bill_file_4_id: lmiId4,
            utility_bill_file_5_id: lmiId5,
            utility_bill_file_6_id: lmiId6,
            utility_bill_file_7_id: lmiId7,
            utility_bill_file_8_id: lmiId8,
            utility_bill_file_9_id: lmiId9,
            utility_bill_file_10_id: lmiId10,
            utility_bill_file_11_id: lmiId11,
            utility_bill_file_12_id: lmiId12,
            name_1: "Credit Card Fee",
            amount_1: "2.90%",
            form_type: "csf_form",
            spanish_pdf: "No",
            invoice_type: "Electronic",
            payment_frequency: "Monthly, within 60 days after energization",
            subscription_type: "Price per kWh produced by subscription",
            when_applicable_1: "Applicable for Credit Card Payments",
            provider_email: "customercare@nautilussolar.com",
            provider_phone_number: "8669694129",
            provider_website: "www.nautilussolar.com",
            provider_address_dba_name: "Nautilus Community Solar, LLC",
            il_provider_company_name: "Nautilus US Power Holdco, LLC",
            minimum_level_guarantee: "no",
            termination_circ:
              "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
            require_ares: "No",
            terms_years: "20",
            il_payment_method: "ACH",
            initial_amount: "0",
            vendor_id: "2177",
            nearest_inhabited_area: FarmCity,
          },
        }
        const response = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        catchdata = data
        if (response.ok) {
          storage.rawSet("skipUsage", "No")
          storage.rawSet("utilityProvider", "Bayou")
          await checkConsentConfigurationVariation()
        }
        const result = await response.json()
        responseFromAPI = JSON.stringify(result)
      } catch (error) {
        closeProgressBar()
        console.error("Error:", error)
      }
    }
  }

  async function saveallkeypiecesfromcompleteddeal() {
__ea_trace("modules/usage/usage-il-bayou.ts","saveallkeypiecesfromcompleteddeal",[],[]);
    var contactId = storage.rawGet("contactId")
    var deallId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        contactId: contactId,
      }
      const response = await fetch(apiUrl("FetchAssociatedDealsBasedOnContactId"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var _dealRecordLength = dataa.userValue.associations.deals.results.length
      var dealIdLog = dataa.userValue.associations.deals.results

      for (var i = 0; i < dealIdLog.length; i++) {
        if (deallId !== dealIdLog[i].id) {
          var deal = dealIdLog[i].id
          var _catchdata = ""
          try {
            const data = {
              deal_id: deal,
            }
            const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            catchdata = data
            const dataa = await response.json()
            responseFromAPI = JSON.stringify(dataa)
            var l_dealStage = dataa.userValue.properties.dealstage
            var credential_provider = dataa.userValue.properties.credential_provider
            var _l_dealId = dataa.userValue.id

            if (
              l_dealStage === 127892578 /* completed */ ||
              l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */ ||
              l_dealStage === 127892575 /* Staged (Sales Pipeline) */ ||
              l_dealStage === 127892570 /* Submitted (Sales Pipeline) */ ||
              l_dealStage === 127892574 /* Verified (Sales Pipeline) */ ||
              l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */
            ) {
              if (credential_provider === "Bayou") {
                var bayous_onboarding_tokenn = dataa.userValue.properties.bayous_onboarding_token
                var utility_usernamee = dataa.userValue.properties.utility_username
                var utility_passwordd = dataa.userValue.properties.utility_password
                var bayous_id = dataa.userValue.properties.bayous_id
                var bayous_type = dataa.userValue.properties.bayous_type
                var bayou_get_bills_sent = dataa.userValue.properties.bayou_get_bills_sent
                var bayou_get_bills_resp = dataa.userValue.properties.bayou_get_bills_resp
                var bill_status = dataa.userValue.properties.bill_status
                var bayous_utility_id = dataa.userValue.properties.bayous_utility_id
                var catchdata = ""
                try {
                  const data = {
                    properties: {
                      deal_id: deallId,
                      bayous_onboarding_token: bayous_onboarding_tokenn,
                      utility_username: utility_usernamee,
                      utility_password: utility_passwordd,
                      bayous_id: bayous_id,
                      bayous_type: bayous_type,
                      bayou_get_bills_sent: bayou_get_bills_sent,
                      bayou_get_bills_resp: bayou_get_bills_resp,
                      bill_status: bill_status,
                      bayous_utility_id: bayous_utility_id,
                    },
                  }
                  const response = await fetch(apiUrl("UpdateDealRecord"), {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                  })
                  catchdata = data
                  const dataa = await response.json()
                  responseFromAPI = JSON.stringify(dataa)

                } catch (error) {
                  console.error("Error:", error)
                }
              }
            } else {
              console.error("Completed deal not found")
            }
          } catch (error) {
            console.error("Error:", error)
          }
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  // Get utility button click ----------------------------------------------------------
  document.getElementById("get-utility-info").addEventListener("click", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    openProgressBar("We are securing your data.")
    var isLMII = storage.rawGet("isLMI")
    var _ErrorValidationList = ""
    if (isLMII === "Yes") {
      if (isGetConsumptionFaild === false) {
        if (manualAccountNumber === true) {
          _ErrorValidationList = [
            validateManualAddressFields(),
            fileFinalButtonValidation(false, false, true),
            getAccountNumberErrorifExist(),
          ]
        } else {
          var ErrorValidationList = [validateAddressFields()]
        }
        var isvalidated = RequireNotRequire()
        if (ErrorValidationList.includes("error")) {
          closeProgressBar()
          document.getElementById("finalCheck-error").innerHTML = "please fix the error before submitting"
        } else if (isvalidated !== true) {
          closeProgressBar()
          document.getElementById("finalCheck-error").innerHTML = "please fix the error before submitting"
        } else {
          document.getElementById("finalCheck-error").innerHTML = ""
          if (verifyidenty === "yes") {
            var incomeThreesholdd = document.querySelector("#income-threshold-radio")
            var _requestIncomee = document.querySelector("#request-icome-radio")
            var attestationRadio = document.querySelector("#attestation-radio")
            if (incomeThreesholdd.checked || attestationRadio.checked) {
              ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
                try {
                  if (manualAccountNumber === true) {
                    var [urlMnl, idMnl] = await uploadFileToServer("manualFile")
                  } else {
                    var url = ""
                    var id = ""
                  }

                  var skipUsage = "No"
                  addDataToDealRecord(url, skipUsage, globPass, isLMII, selectedValue, id, urlMnl, idMnl)
                } catch (error) {
                  closeProgressBar()
                  alert(error)
                  window.location.href = "/il-usage"
                }
              })()
            } else {
              ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
                try {
                  if (manualAccountNumber === true) {
                    var [urlMnl, idMnl] = await uploadFileToServer("manualFile")
                    var [url, id] = await uploadFileToServer()
                    var skipUsage = "No"
                    addDataToDealRecord(url, skipUsage, globPass, isLMII, selectedValue, id, urlMnl, idMnl)
                  } else {
                    const [url, id] = await uploadFileToServer()
                    var skipUsage = "No"
                    addDataToDealRecord(url, skipUsage, globPass, isLMII, selectedValue, id)
                  }
                } catch (error) {
                  closeProgressBar()
                  alert(error)
                  window.location.href = "/il-usage"
                }
              })()
            }
          } else if (verifyidenty === "no") {
            closeProgressBar()
            document.getElementById("verification-error-message").innerHTML =
              "Please select an account number before continuing"
            var sectionId = "haveOnlineAccountMainDiv"
            var section = document.getElementById(sectionId)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          } else if (verifyidenty === undefined) {
            closeProgressBar()
            document.getElementById("verification-error-message").innerHTML =
              "Please select an account number before continuing"
            var sectionId = "haveOnlineAccountMainDiv"
            var section = document.getElementById(sectionId)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          }
        }
      } else {
        ErrorValidationList = [
          validateMonthYear("sdofbp", "edomrbp"),
          validateTotalKwhUsage(),
          fileFinalButtonValidation(false, false, true),
        ]
        if (ErrorValidationList.includes("error")) {
          closeProgressBar()
          document.getElementById("finalCheck-error").innerHTML =
            "please fix the error inside usage details before submitting"
        } else {
          document.getElementById("finalCheck-error").innerHTML = ""
          ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
            try {
              var [url, id] = await uploadFileToServer("manualFile")
              var skipUsage = "No"
              addManualCunsomptionData(url, skipUsage, isLMII, id)
            } catch (error) {
              closeProgressBar()
              alert(error)
              window.location.href = "/il-usage"
            }
          })()
        }
      }
    } else {
      if (isGetConsumptionFaild === false) {
        if (manualAccountNumber === true) {
          ErrorValidationList = [
            validateManualAddressFields(),
            fileFinalButtonValidation(false, false, true),
            getAccountNumberErrorifExist(),
          ]
        } else {
          var ErrorValidationList = [validateAddressFields()]
        }
        if (ErrorValidationList.includes("error")) {
          closeProgressBar()
          document.getElementById("finalCheck-error").innerHTML = "please fix the error before submitting"
        } else {
          document.getElementById("finalCheck-error").innerHTML = ""
          if (verifyidenty === "yes") {
            ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
              try {
                if (manualAccountNumber === true) {
                  var [url, id] = await uploadFileToServer("manualFile")
                }
                var skipUsage = "No"
                addDataToDealRecord(url, skipUsage, globPass, isLMII, selectedValue, id)
              } catch (error) {
                closeProgressBar()
                alert(error)
                window.location.href = "/il-usage"
              }
            })()
          } else if (verifyidenty === "no") {
            closeProgressBar()
            document.getElementById("verification-error-message").innerHTML =
              "Please select an account number before continuing"
            var sectionId = "haveOnlineAccountMainDiv"
            var section = document.getElementById(sectionId)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          } else if (verifyidenty === undefined) {
            closeProgressBar()
            document.getElementById("verification-error-message").innerHTML =
              "Please select an account number before continuing"
            var sectionId = "haveOnlineAccountMainDiv"
            var section = document.getElementById(sectionId)
            if (section) {
              section.scrollIntoView({ behavior: "smooth" })
            }
          }
        }
      } else {
        ErrorValidationList = [
          validateMonthYear("sdofbp", "edomrbp"),
          validateTotalKwhUsage(),
          fileFinalButtonValidation(false, false, true),
        ]
        if (ErrorValidationList.includes("error")) {
          closeProgressBar()
          document.getElementById("finalCheck-error").innerHTML =
            "please fix the error inside usage details before submitting"
        } else {
          document.getElementById("finalCheck-error").innerHTML = ""
          ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
            try {
              var [url, id] = await uploadFileToServer("manualFile")
              var skipUsage = "No"
              addManualCunsomptionData(url, skipUsage, isLMII, id)
            } catch (error) {
              closeProgressBar()
              alert(error)
              window.location.href = "/il-usage"
            }
          })()
        }
      }
    }
  })
  async function saveDataToDealRecord(_fileUrl) {
__ea_trace("modules/usage/usage-il-bayou.ts","saveDataToDealRecord",[_fileUrl],["_fileUrl"]);
    var _email = storage.rawGet("userEmail")
    var iHaveOnlineAccount = ""
    var credentialProvider = ""
    iHaveOnlineAccount = "Yes"
    credentialProvider = "Bayou"

    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          do_you_have_an_account_with_utility_service_provider: iHaveOnlineAccount,
          credential_provider: credentialProvider,
          enrollmentsessionid: enrollmentSessionID,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  document.getElementById("save-remind").addEventListener("click", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    ;(async () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
      try {
        const url = ""
        saveDataToDealRecord(url)
      } catch (_error) {
        saveDataToDealRecord()
      }
    })()
  })
  // Save my place and remind me --------------------------------------------------------------------------------

  // get utility name and logo from session config table ----------------------------------------------------
  function getDataFromSessionConfigTable(utilityIdd) {
__ea_trace("modules/usage/usage-il-bayou.ts","getDataFromSessionConfigTable",[utilityIdd],["utilityIdd"]);
    // live site table id - 15223637
    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&limit=${limit}&offset=${offset}`
    fetch(hubDBEndpoint, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[data],["data"]);
        const matchingRows = data.objects.filter((row) => row.values[1] === utilityIdd)
        const rows = data.objects
        if (matchingRows.length >= 1) {
          allRows = allRows.concat(matchingRows)
        }
        if (rows.length === limit) {
          // There might be more rows, fetch the next page
          offset += limit
          return getDataFromSessionConfigTable(utilityIdd)
        }

        var utilityName = allRows[0].values[5]
        var utilityLogoImage = allRows[0].values[17].url
        var forgetPw = allRows[0].values[27]
        var forgetUs = allRows[0].values[28]
        var CreateAnAccBtn = allRows[0].values[29]
        var utiNameItem = document.getElementsByClassName("utilityName")
        var forgetPwitem = document.getElementById("forgetPw")
        var forgetUsitem = document.getElementById("forgetUs")
        var createAnAccountItem = document.getElementById("createAnAccount")

        if (utilityName !== undefined && utilityName !== "undefined") {
          if (utiNameItem.length > 0) {
            for (var i = 0; i < utiNameItem.length; i++) {
              utiNameItem[i].innerText = utilityName
            }
          }
        }

        if (utilityLogoImage !== undefined) {
          document.getElementById("utilityLogoImage").src = utilityLogoImage
          document.getElementById("utilityName").innerText = ""
        } else {
          document.getElementById("utilityName").innerText = utilityName
          document.getElementsById("utilityLogoImage").src = ""
        }

        if (forgetPw.startsWith("https://")) {
          forgetPwitem.href = forgetPw
        } else if (forgetPw.startsWith("http://")) {
          forgetPwitem.href = forgetPw
        } else {
          forgetPwitem.href = `https://${forgetPw}`
        }

        if (forgetUs.startsWith("https://")) {
          forgetUsitem.href = forgetUs
        } else if (forgetUs.startsWith("http://")) {
          forgetUsitem.href = forgetUs
        } else {
          forgetUsitem.href = `https://${forgetUs}`
        }

        if (CreateAnAccBtn.startsWith("https://")) {
          createAnAccountItem.href = CreateAnAccBtn
        } else if (CreateAnAccBtn.startsWith("http://")) {
          createAnAccountItem.href = CreateAnAccBtn
        } else {
          createAnAccountItem.href = `https://${CreateAnAccBtn}`
        }
        storage.rawSet("utilityRate", allRows[0].values[78])
        storage.rawSet("subSizingFactor", allRows[0].values[79])
        storage.rawSet("standardRate", allRows[0].values[80])
        storage.rawSet("lmiNseRate", allRows[0].values[81])
        storage.rawSet("acSystemSize", allRows[0].values[82])
        storage.rawSet("acKwh", allRows[0].values[84])
      })
      .catch((_error) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[_error],["_error"]);})
  }
  var limit = 1000
  var offset = 0
  var allRows = []
  getDataFromSessionConfigTable(utilityIdd)
  // get utility name and logo from session config table ----------------------------------------------------

  // get data from UAN config table ----------------------------------------------------
  async function getDataFromUANConfigTable() {
__ea_trace("modules/usage/usage-il-bayou.ts","getDataFromUANConfigTable",[],[]);
    var exampleUtilityId = storage.rawGet("utility_id")
    var stateForUANConfig = storage.rawGet("stateForLMIConfig")
    var _utilityNameForUANConfig = storage.rawGet("utility_Name")
    const hubDBEndpointUANC = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.uanConfig}/rows?portalId=${window.__ENV__.dataPortalId}&orderBy=uan_field_display_sequence&utility_id=${exampleUtilityId}&state_name=${stateForUANConfig}`
    const responseUANC = await fetch(hubDBEndpointUANC, { method: "GET" })
    const dataUANC = await responseUANC.json()
    const rowsUANC = dataUANC.objects
    if (rowsUANC.length >= 1) {
      rowsUANC.forEach((element, _index) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[element,_index],["element","_index"]);
        var _uanFieldDisplaySequence = element.values["6"]
        if (element.values["16"] !== undefined && element.values["16"] !== "undefined") {
          var additionalAttributes = element.values["16"]
          additionalAttributeItem = additionalAttributes
        }
      })
    }
  }
  // get data from UAN config table ----------------------------------------------------

  // -- uploaded file to file manager and return file url ---------------------------------------------------
  var _uploadedurl = []

  // update Deal Stage -------------------------------------------------------------------------------
  async function _updateDealStage(value) {
__ea_trace("modules/usage/usage-il-bayou.ts","_updateDealStage",[value],["value"]);
    await delay(2000)
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  //- update deaLstage -------------------------------------------------------------------------------
  async function delay(ms) {
__ea_trace("modules/usage/usage-il-bayou.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
  async function checkConsentConfigurationVariation() {
__ea_trace("modules/usage/usage-il-bayou.ts","checkConsentConfigurationVariation",[],[]);
    var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")
    if (is_enrolled_for_bayou === "yes") {
      await saveallkeypiecesfromcompleteddeal()
    }

    var consetPaymentReq
    var SessionLocalStorage = JSON.parse(storage.rawGet("UtilitySessionDetails"))
    if (SessionLocalStorage["33"] === 0) {
      consetPaymentReq = "No"
    } else if (SessionLocalStorage["33"] === 1) {
      consetPaymentReq = "Yes"
    } else {
      consetPaymentReq = "No"
    }
    var consentDisplayelementList = JSON.parse(storage.rawGet("consentDisplayelementList"))
    if (consentDisplayelementList != null) {
      if (consentDisplayelementList.length > 0) {
        if (consetPaymentReq === "Yes") {
          //                     await updateDealStage('127892568');
          storage.rawSet("rp", "QxtVq")
          closeProgressBar()
          window.location.href = "/il-my-consent"
        } else {
          //                     await updateDealStage('127892567');
          storage.rawSet("rp", "NpEv")
          closeProgressBar()
          window.location.href = "/il-my-consent"
        }
      } else {
        closeProgressBar()
        window.location.href = "/il-my-consent"
      }
    } else {
      closeProgressBar()
      window.location.href = "/il-my-consent"
    }
  }

  /* ----------------------------------------- lmi script code ------------------------ */
  //index DB for LMI
  var request = indexedDB.open("LmiDatabase", 1)
  var db
  var objectStore
  request.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    console.error(`LMI Database error: ${event.target.errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    db = event.target.result
    getAllFilesFromIndexedDB("LmiDatabase")
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var db = event.target.result

    // Create an object store (similar to a table in relational databases)
    objectStore = db.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }

  var requestMB = indexedDB.open("ManualBillDatabase", 1)
  var dbMB
  var objectStoreMB
  requestMB.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    console.error(`Manual Bill Database error: ${event.target.errorCode}`)
  }
  requestMB.onsuccess = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    dbMB = event.target.result
    getAllFilesFromIndexedDB("ManualBillDatabase")
  }
  requestMB.onupgradeneeded = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var dbMB = event.target.result

    // Create an object store (similar to a table in relational databases)
    objectStoreMB = dbMB.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStoreMB.createIndex("name", "name", { unique: false })
  }
  //index DB for Manual Bill

  // Function to save file to IndexedDB
  function saveFileToIndexedDB(file, checkValue, manualCheck) {
__ea_trace("modules/usage/usage-il-bayou.ts","saveFileToIndexedDB",[file,checkValue,manualCheck],["file","checkValue","manualCheck"]);
    try {
      var reader = new FileReader()
      reader.onload = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
        var arrayBuffer = event.target.result
        // Create an object to store both the file name and the ArrayBuffer

        var fileObject = {
          name: file.name,
          type: file.type,
          data: arrayBuffer,
          checkValue: checkValue,
        }
        var transaction
        if (manualCheck === "manualFile") {
          transaction = dbMB.transaction(["files"], "readwrite")
        } else {
          transaction = db.transaction(["files"], "readwrite")
        }
        var objectStore = transaction.objectStore("files")
        // Save the ArrayBuffer in the object store
        var request = objectStore.put(fileObject)
        request.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
          console.error(`Error saving file: ${event.target.errorCode}`)
        }
      }
      reader.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
        console.error("Error reading file:", event.target.error)
      }
      // Read the file as ArrayBuffer
      reader.readAsArrayBuffer(file)
    } catch (e) {
      console.error(`error while saving to index db ${e}`)
    }
  }
  function getAllFilesFromIndexedDB(dbIdenty) {
__ea_trace("modules/usage/usage-il-bayou.ts","getAllFilesFromIndexedDB",[dbIdenty],["dbIdenty"]);
    var transaction
    var objectStoren
    if (dbIdenty === "LmiDatabase") {
      transaction = db.transaction(["files"], "readonly")
      objectStoren = transaction.objectStore("files")
    } else if (dbIdenty === "ManualBillDatabase") {
      transaction = dbMB.transaction(["files"], "readonly")
      objectStoren = transaction.objectStore("files")
    }

    var filess = []
    var censusFile = []
    var incomeFile = []
    var manualFile = []
    var index = 0
    var checkValue = storage.rawGet("checkedValue")

    // Open a cursor to iterate over all objects in the object store
    objectStoren.openCursor().onsuccess = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
      var cursor = event.target.result
      if (cursor) {
        var fileName = cursor.value.name
        var blobData = cursor.value.data
        var fileType = cursor.value.type
        var file = new File([blobData], fileName, { type: fileType }) // Provide a default type
        index++
        if (dbIdenty === "ManualBillDatabase") {
          manualFile.push(file)
        } else {
          if (checkValue === "cencus") {
            censusFile.push(file)
          } else if (checkValue === "blue") {
            incomeFile.push(file)
          } else {
            filess.push(file)
          }
        }
        cursor.continue()
      } else {
        if (index !== 0) {
          if (filess.length > 0) {
            handleFilesNew(filess, false, false, false)
          }
          if (censusFile.length > 0) {
            handleFilesNew(censusFile, true, false, false)
          }
          if (manualFile.length > 0) {
            handleFilesNew(manualFile, false, false, true)
          }
          if (incomeFile.length > 0) {
            handleFilesNew(incomeFile, false, true, false)
          }
        }
      }
    }
  }
  // Function to clear the entire IndexedDB database
  function clearDatabase() {
__ea_trace("modules/usage/usage-il-bayou.ts","clearDatabase",[],[]);
    var transaction = db.transaction(db.objectStoreNames, "readwrite")

    transaction.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
      console.erorr("Error clearing database:", event.target.errorCode)
    }

    Array.from(db.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  function clearManualDatabase() {
__ea_trace("modules/usage/usage-il-bayou.ts","clearManualDatabase",[],[]);
    var transaction = dbMB.transaction(dbMB.objectStoreNames, "readwrite")

    transaction.onerror = (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
      console.error("Error clearing database:", event.target.errorCode)
    }

    Array.from(dbMB.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  //End of Indexed Db///
  var swiper
  var censusSwiper
  var incomeSwiper
  var manualSwiper

  function RequireNotRequire() {
__ea_trace("modules/usage/usage-il-bayou.ts","RequireNotRequire",[],[]);
    var isValidationSuccess = false
    var _isRequireFieldEmpty = false
    var _incomdeExceedElement = document.querySelector("#Income_Exceed_Threshold")
    var _programParticipation = document.querySelector("#Program_Participation")
    var _requestIncomCheck = document.querySelector("#Request_Income_Check")
    var RadioName = document.getElementsByName("color")
    var isAnyChecked = false

    for (var i = 0; i < RadioName.length; i++) {
      if (RadioName[i].checked) {
        isAnyChecked = true
        checkedValue = RadioName[i].value
        break
      }
    }

    if (!isAnyChecked) {
      document.querySelector("#NoRadioSelected_error_message").innerHTML = "Please select an option."
      return false
    } else {
      var _tempErrorList = []
      document.querySelector("#NoRadioSelected_error_message").innerHTML = ""

      switch (checkedValue) {
        case "red":
          {
            isValidationSuccess = true
          }
          break
        case "green":
          {
            var tempErrorList = [validateSelectedOption(), fileFinalButtonValidation(false, false, false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "blue":
          {
            if (listOfincomeFiles.length === 0) {
              document.getElementById("income-file-error-message").textContent = "Please upload file to proceed"
              isValidationSuccess = false
              return
            }
            var tempErrorList = [fileFinalButtonValidation(false, true, false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "orange":
          {
            var tempErrorList = [validateCheckSignature()]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "cencus":
          {
            if (listOfCensusFiles.length === 0) {
              document.getElementById("Cencus_track_map_upload_error_message").textContent =
                "Please upload file to proceed"
              isValidationSuccess = false
              return
            }
            var tempErrorList = [fileFinalButtonValidation(true, false, false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
      }
    }
    return isValidationSuccess
  }
  function initSwiper() {
__ea_trace("modules/usage/usage-il-bayou.ts","initSwiper",[],[]);
    swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Program_Participation .swiper-button-next",
        prevEl: "#Program_Participation .swiper-button-prev",
      },
    })
    document.querySelector("#Program_Participation .swiper-button-next").innerHTML = "<span>Next</span>"
    document.querySelector("#Program_Participation .swiper-button-prev").innerHTML = "<span>Previous</span>"
  }
  function initCensusSwiper() {
__ea_trace("modules/usage/usage-il-bayou.ts","initCensusSwiper",[],[]);
    censusSwiper = new Swiper(".census-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Cencus_tract_map_upload .swiper-button-next",
        prevEl: "#Cencus_tract_map_upload .swiper-button-prev",
      },
    })

    document.querySelector("#Cencus_tract_map_upload .swiper-button-next").innerHTML = "<span>Next</span>"
    document.querySelector("#Cencus_tract_map_upload .swiper-button-prev").innerHTML = "<span>Previous</span>"
  }
  function initincomeSwiper() {
__ea_trace("modules/usage/usage-il-bayou.ts","initincomeSwiper",[],[]);
    incomeSwiper = new Swiper(".income-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Request_Income_Check .swiper-button-next",
        prevEl: "#Request_Income_Check .swiper-button-prev",
      },
    })

    document.querySelector("#Request_Income_Check .swiper-button-next").innerHTML = "<span>Next</span>"
    document.querySelector("#Request_Income_Check .swiper-button-prev").innerHTML = "<span>Previous</span>"
  }
  function initManualSwiper() {
__ea_trace("modules/usage/usage-il-bayou.ts","initManualSwiper",[],[]);
    manualSwiper = new Swiper(".manual-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#upload-picture-main .swiper-button-next",
        prevEl: "#upload-picture-main .swiper-button-prev",
      },
    })
    document.querySelector("#upload-picture-main .swiper-button-next").innerHTML = "<span>Next</span>"
    document.querySelector("#upload-picture-main .swiper-button-prev").innerHTML = "<span>Previous</span>"
  }
  function fileFinalButtonValidation(isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","fileFinalButtonValidation",[isUploadCensus,isUploadincome,isUploadManual],["isUploadCensus","isUploadincome","isUploadManual"]);
    if (isUploadCensus) {
      document.getElementById("census-file-error-message").innerHTML = ""
      var errorMessageElement = document.getElementById("census-file-error-message")
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)

      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
      } else {
        document.getElementById("census-file-error-message").innerHTML = "No file selected. Please choose a file."
        return "error"
      }
    } else if (isUploadincome) {
      document.getElementById("income-file-error-message").innerHTML = ""
      var errorMessageElement = document.getElementById("income-file-error-message")
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)

      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
      } else {
        document.getElementById("income-file-error-message").innerHTML = "No file selected. Please choose a file."
        return "error"
      }
    } else if (isUploadManual) {
      if (listOfmanualFiles == null || listOfmanualFiles.length === 0) {
        document.getElementById("manual-file-error-message").innerHTML = "No file selected. Please choose a file."
        return "error"
      }
    } else {
      document.getElementById("file-error-message").innerHTML = ""
      var errorMessageElement = document.getElementById("file-error-message")
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)

      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
      } else {
        document.getElementById("file-error-message").innerHTML = "No file selected. Please choose a file."
        return "error"
      }
    }
  }
  function _captureFromCamera() {
__ea_trace("modules/usage/usage-il-bayou.ts","_captureFromCamera",[],[]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "image/*"
    inputElement.capture = "camera"
    inputElement.addEventListener("change", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
      handleFilesNew(this.files)
    })

    inputElement.click()
  }
  function removeImageOpenPopup(isCensus, isincome, ismanual) {
__ea_trace("modules/usage/usage-il-bayou.ts","removeImageOpenPopup",[isCensus,isincome,ismanual],["isCensus","isincome","ismanual"]);
    if (isCensus) {
      document.querySelector(".census-RemoveFilePopup").style.display = "block"
    } else if (isincome) {
      document.querySelector(".income-RemoveFilePopup").style.display = "block"
    } else if (ismanual) {
      document.querySelector(".manual-RemoveFilePopup").style.display = "block"
    } else {
      document.querySelector(".RemoveFilePopup").style.display = "block"
    }
  }
  function removeCurrentImage(isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","removeCurrentImage",[isUploadCensus,isUploadincome,isUploadManual],["isUploadCensus","isUploadincome","isUploadManual"]);
    if (isUploadCensus) {
      if (censusSwiper !== undefined) {
        var activeIndex = censusSwiper.activeIndex
        document.getElementById("census-file-error-message").innerHTML = ""

        listOfCensusFiles.splice(activeIndex, 1) // Remove the file from the list
        censusSwiper.removeSlide(activeIndex) // Remove the slide from Swiper
        document.getElementById("censusfileCount").textContent = `Total files selected: ${listOfCensusFiles.length}`

        initCensusSwiper()
        var fileNameDisplay = document.getElementById("censusfileNameDisplay")
        fileNameDisplay.textContent = `File Name: ${listOfCensusFiles.map((f) => f.name).join(", ")}`

        document.querySelector(".census-RemoveFilePopup").style.display = "none"
      }
    } else if (isUploadincome) {
      if (incomeSwiper !== undefined) {
        var activeIndex = incomeSwiper.activeIndex
        document.getElementById("income-file-error-message").innerHTML = ""

        listOfincomeFiles.splice(activeIndex, 1) // Remove the file from the list
        incomeSwiper.removeSlide(activeIndex) // Remove the slide from Swiper
        document.getElementById("incomefileCount").textContent = `Total files selected: ${listOfincomeFiles.length}`

        initincomeSwiper()
        var fileNameDisplay = document.getElementById("incomefileNameDisplay")
        fileNameDisplay.textContent = `File Name: ${listOfincomeFiles.map((f) => f.name).join(", ")}`

        document.querySelector(".income-RemoveFilePopup").style.display = "none"
      }
    } else if (isUploadManual) {
      if (manualSwiper !== undefined) {
        var activeIndex = manualSwiper.activeIndex
        document.getElementById("manual-file-error-message").innerHTML = ""

        listOfmanualFiles.splice(activeIndex, 1) // Remove the file from the list
        manualSwiper.removeSlide(activeIndex) // Remove the slide from Swiper
        document.getElementById("manualfileCount").textContent = `Total files selected: ${listOfmanualFiles.length}`

        initManualSwiper()
        var fileNameDisplay = document.getElementById("manualfileNameDisplay")
        fileNameDisplay.textContent = `File Name: ${listOfmanualFiles.map((f) => f.name).join(", ")}`

        document.querySelector(".manual-RemoveFilePopup").style.display = "none"
      }
    } else {
      if (swiper !== undefined) {
        var activeIndex = swiper.activeIndex
        document.getElementById("file-error-message").innerHTML = ""

        listOfFiles.splice(activeIndex, 1) // Remove the file from the list
        swiper.removeSlide(activeIndex) // Remove the slide from Swiper
        document.getElementById("fileCount").textContent = `Total files selected: ${listOfFiles.length}`

        initSwiper() // Reinitialize Swiper

        var fileNameDisplay = document.getElementById("fileNameDisplay")
        fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f) => f.name).join(", ")}`

        document.querySelector(".RemoveFilePopup").style.display = "none"
      }
    }
  }

  function removeImageClosePopup(isCensus, isincome, ismanual) {
__ea_trace("modules/usage/usage-il-bayou.ts","removeImageClosePopup",[isCensus,isincome,ismanual],["isCensus","isincome","ismanual"]);
    if (isCensus) {
      document.querySelector(".census-RemoveFilePopup").style.display = "none"
    } else if (isincome) {
      document.querySelector(".income-RemoveFilePopup").style.display = "none"
    } else if (ismanual) {
      document.querySelector(".manual-RemoveFilePopup").style.display = "none"
    } else {
      document.querySelector(".RemoveFilePopup").style.display = "none"
    }
  }
  function triggerFilePicker() {
__ea_trace("modules/usage/usage-il-bayou.ts","triggerFilePicker",[],[]);
    document.getElementById("file-error-message").innerHTML = ""
    document.querySelector("#fileInput").click()
  }
  function triggerCensusFilePicker() {
__ea_trace("modules/usage/usage-il-bayou.ts","triggerCensusFilePicker",[],[]);
    document.getElementById("census-file-error-message").innerHTML = ""
    document.querySelector("#censusFileInput").click()
  }
  function triggerincomeFilePicker() {
__ea_trace("modules/usage/usage-il-bayou.ts","triggerincomeFilePicker",[],[]);
    document.getElementById("income-file-error-message").innerHTML = ""
    document.querySelector("#incomeFileInput").click()
  }
  function triggerFilemanualPicker() {
__ea_trace("modules/usage/usage-il-bayou.ts","triggerFilemanualPicker",[],[]);
    document.getElementById("manual-file-error-message").innerHTML = ""
    document.querySelector("#manualfileInput").click()
  }

  document.getElementById("fileInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false, false)
  })
  document.getElementById("censusFileInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, true, false, false)
  })
  document.getElementById("incomeFileInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, true, false)
  })
  document.getElementById("manualfileInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false, true)
  })

  function triggerFileInput(event, isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","triggerFileInput",[event,isUploadCensus,isUploadincome,isUploadManual],["event","isUploadCensus","isUploadincome","isUploadManual"]);
    event.preventDefault()
    if (isUploadCensus) {
      document.querySelector('#censusMobileCamera input[type="file"]').click()
    } else if (isUploadincome) {
      document.querySelector('#incomeMobileCamera input[type="file"]').click()
    } else if (isUploadManual) {
      document.querySelector('#manualmobileCamera input[type="file"]').click()
    } else {
      document.querySelector('#mobileCamera input[type="file"]').click()
    }
  }
  document.getElementById("imageInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var _file = event.target.files[0]
    handleFilesNew(event.target.files, false, false, false)
  })
  document.getElementById("censusImageInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var _file = event.target.files[0]
    handleFilesNew(event.target.files, true, false, false)
  })
  document.getElementById("incomeImageInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var _file = event.target.files[0]
    handleFilesNew(event.target.files, false, true, false)
  })
  document.getElementById("manualimageInput").addEventListener("change", (event) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[event],["event"]);
    var _file = event.target.files[0]
    handleFilesNew(event.target.files, false, false, true)
  })
  function dragOverHandler(event, isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","dragOverHandler",[event,isUploadCensus,isUploadincome,isUploadManual],["event","isUploadCensus","isUploadincome","isUploadManual"]);
    event.preventDefault()
    if (isUploadCensus) {
      document.querySelector(".page1lmileftright_myusage #censusDropArea").classList.add("active")
    } else if (isUploadincome) {
      document.querySelector(".page1lmileftright_myusage #incomeDropArea").classList.add("active")
    } else if (isUploadManual) {
      document.querySelector("#manualdropArea").classList.add("active")
    } else {
      document.querySelector(".page1lmileftright_myusage #dropArea").classList.add("active")
    }
  }
  function dropHandler(event, isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","dropHandler",[event,isUploadCensus,isUploadincome,isUploadManual],["event","isUploadCensus","isUploadincome","isUploadManual"]);
    event.preventDefault()
    if (isUploadCensus) {
      document.querySelector(".page1lmileftright_myusage #censusDropArea").classList.remove("active")
    } else if (isUploadincome) {
      document.querySelector(".page1lmileftright_myusage #incomeDropArea").classList.remove("active")
    } else if (isUploadManual) {
      document.querySelector("#manualdropArea").classList.remove("active")
    } else {
      document.querySelector(".page1lmileftright_myusage #dropArea").classList.remove("active")
    }

    var files = event.dataTransfer.files
    if (isUploadCensus) {
      document.getElementById("census-file-error-message").innerHTML = ""
    } else if (isUploadincome) {
      document.getElementById("income-file-error-message").innerHTML = ""
    } else if (isUploadManual) {
      document.getElementById("manual-file-error-message").innerHTML = ""
    } else {
      document.getElementById("file-error-message").innerHTML = ""
    }
    if (files.length > 0) {
      handleFilesNew(files, isUploadCensus, isUploadincome, isUploadManual)
    }
  }
  function _browseFiles(isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","_browseFiles",[isUploadCensus,isUploadincome,isUploadManual],["isUploadCensus","isUploadincome","isUploadManual"]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "application/pdf, image/*"
    inputElement.addEventListener("change", function () {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
      handleFilesNew(this.files, isUploadCensus, isUploadincome, isUploadManual)
    })

    inputElement.click()
  }
  var _file
  var _isInvalidFileType = false
  var _isExceededSize = false
  var listOfFiles = []
  var listOfCensusFiles = []
  var listOfincomeFiles = []
  var listOfmanualFiles = []

  function handleFilesNew(files, isUploadCensus, isUploadincome, isUploadManual) {
__ea_trace("modules/usage/usage-il-bayou.ts","handleFilesNew",[files,isUploadCensus,isUploadincome,isUploadManual],["files","isUploadCensus","isUploadincome","isUploadManual"]);
    var maxFiles = 12
    var totalfilecount = 0
    if (isUploadCensus) {
      totalfilecount = listOfCensusFiles.length + files.length
    } else if (isUploadincome) {
      totalfilecount = listOfincomeFiles.length + files.length
    } else if (isUploadManual) {
      totalfilecount = listOfmanualFiles.length + files.length
    } else {
      totalfilecount = listOfFiles.length + files.length
    }

    if (files.length > 0 && totalfilecount <= maxFiles) {
      var allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/bmp", "image/webp"]
      var _totalSize = 0
      for (var i = 0; i < files.length; i++) {
        var file = files[i]
        if (!allowedTypes.includes(file.type)) {
          if (isUploadCensus) {
            document.getElementById("census-file-error-message").innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else if (isUploadincome) {
            document.getElementById("income-file-error-message").innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else if (isUploadManual) {
            document.getElementById("manual-file-error-message").innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else {
            document.getElementById("file-error-message").innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          }
          return
        }
      }
      if (file.size > 10 * 1024 * 1024) {
        if (isUploadCensus) {
          document.getElementById("census-file-error-message").innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else if (isUploadincome) {
          document.getElementById("income-file-error-message").innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else if (isUploadManual) {
          document.getElementById("manual-file-error-message").innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else {
          document.getElementById("file-error-message").innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        }
        return
      }
      var fileNameDisplay
      var previewContainer
      if (isUploadCensus) {
        fileNameDisplay = document.getElementById("censusfileNameDisplay")
        previewContainer = document.getElementById("censusPreviewContainer")
      } else if (isUploadincome) {
        fileNameDisplay = document.getElementById("incomefileNameDisplay")
        previewContainer = document.getElementById("incomePreviewContainer")
      } else if (isUploadManual) {
        fileNameDisplay = document.getElementById("manualfileNameDisplay")
        previewContainer = document.querySelector("#upload-picture-main #manualpreviewContainer")
      } else {
        fileNameDisplay = document.getElementById("fileNameDisplay")
        previewContainer = document.getElementById("previewContainer")
      }

      for (var j = 0; j < files.length; j++) {
        var file = files[j]
        var reader = new FileReader()
        var preview = document.createElement("div")
        preview.className = "swiper-slide"
        preview.innerHTML = `<img src="" alt="Preview Image" width="100%" height="auto" id="imageNo${j}">`
        previewContainer.appendChild(preview)

        reader.onload = ((preview, file) => (e) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[e],["e"]);
          if (file.type === "application/pdf") {
            pdfjsLib.getDocument(e.target.result).promise.then((pdf) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[pdf],["pdf"]);
              pdf.getPage(1).then((page) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[page],["page"]);
                var canvas = document.createElement("canvas")
                var context = canvas.getContext("2d")
                var viewport = page.getViewport({ scale: 1.5 })
                canvas.height = viewport.height
                canvas.width = viewport.width
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                }
                page.render(renderContext).promise.then(() => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
                  preview.querySelector("img").src = canvas.toDataURL("image/jpeg")
                })
              })
            })
          } else {
            preview.querySelector("img").src = e.target.result
          }
          var _blobUrl = URL.createObjectURL(file)
          if (isUploadCensus) {
            initCensusSwiper()
          } else if (isUploadincome) {
            initincomeSwiper()
          } else if (isUploadManual) {
            initManualSwiper()
          } else {
            initSwiper()
          }
        })(preview, file)

        reader.readAsDataURL(file)
        if (isUploadCensus) {
          listOfCensusFiles.push(file)
        } else if (isUploadincome) {
          listOfincomeFiles.push(file)
        } else if (isUploadManual) {
          listOfmanualFiles.push(file)
        } else {
          listOfFiles.push(file)
        }
      }

      if (isUploadCensus) {
        document.getElementById("censusfileCount").textContent = `Total files selected: ${listOfCensusFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfCensusFiles.map((f) => f.name).join(", ")}`
      } else if (isUploadincome) {
        document.getElementById("incomefileCount").textContent = `Total files selected: ${listOfincomeFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfincomeFiles.map((f) => f.name).join(", ")}`
      } else if (isUploadManual) {
        document.getElementById("manualfileCount").textContent = `Total files selected: ${listOfmanualFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfmanualFiles.map((f) => f.name).join(", ")}`
      } else {
        document.getElementById("fileCount").textContent = `Total files selected: ${listOfFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f) => f.name).join(", ")}`
      }
    } else {
      if (isUploadCensus) {
        document.getElementById("census-file-error-message").innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else if (isUploadincome) {
        document.getElementById("income-file-error-message").innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else if (isUploadManual) {
        document.getElementById("manual-file-error-message").innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else {
        document.getElementById("file-error-message").innerHTML = `Please select between 1 and ${maxFiles} files.`
      }
    }
  }

  var _uploadedurl = []
  var _uploadedIds = []
  async function uploadFileToServer(value) {
__ea_trace("modules/usage/usage-il-bayou.ts","uploadFileToServer",[value],["value"]);
    clearDatabase()

    // Use the global variable listOfFiles to send files in the API call
    const uploadedUrls = [] // Array to store uploaded URLs
    const uploadedIds = [] // Array to store uploaded URLs
    var theList
    storage.rawSet("checkedValue", checkedValue)
    if (value === "manualFile") {
      clearManualDatabase()
      theList = listOfmanualFiles
    } else {
      if (checkedValue === "cencus") {
        theList = listOfCensusFiles
      } else if (checkedValue === "blue") {
        theList = listOfincomeFiles
      } else {
        theList = listOfFiles
      }
    }

    for (const file of theList) {
      const formData = new FormData()
      const originalName = file.name

      const safeName = originalName
        .replace(/[\u0000-\u001F\u007F-\u009F]/g, "")
        .replace(/[^\x00-\x7F]/g, "")
        .replace(/\s+/g, " ")

      formData.append("file", file, safeName)
      formData.append("name", safeName)

      const requestOptions = {
        method: "POST",
        body: formData,
      }

      // Make the API call
      const response = await fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", requestOptions)
      responseFromAPI = await response.json()
      if (response.ok) {
        saveFileToIndexedDB(file, checkedValue, value)
        uploadedUrls.push(responseFromAPI.response.url)
        uploadedIds.push(responseFromAPI.response.id)
      } else {
        throw new Error("Error uploading file")
      }
      if (response.status === 500 || response.status === 404) {
      }
    }
    return [uploadedUrls, uploadedIds]
  }

  // -- uploaded file to file manager ---------------------------------------------------
  function _removeAllImages() {
__ea_trace("modules/usage/usage-il-bayou.ts","_removeAllImages",[],[]);
    document.getElementById("file-error-message").innerHTML = ""
    listOfFiles = []
    while (swiper.slides.length > 0) {
      swiper.removeSlide(0)
    }
    document.getElementById("fileCount").textContent = `Total files selected: ${listOfFiles.length}`
    initSwiper()
    var fileNameDisplay = document.getElementById("fileNameDisplay")
    fileNameDisplay.textContent = "File Name: "
  }
  var optns = document.querySelector(".page1lmileftright_myusage #incomeThreshold-options")
  var replacementDiv = document.querySelector(".page1lmileftright_myusage #appendDocument")
  var selectedProgramSelection = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    var selectedValue = optns.value
    var selectedOption = optns.options[optns.selectedIndex]
    selectedProgramSelection = selectedOption.textContent
    var selectedOptionValue = selectedValue
    if (selectedOptionValue !== "") {
      const filesArray = selectedOptionValue.split(",").map((file) => file.trim())
      const selectBox = document.querySelector(".page1lmileftright_myusage #appendDocument #programFilesOptions")
      selectBox.innerHTML = '<option selected="" disabled="">Select an option</option>'

      removeCurrentImage(false)

      // Loop through the array and create option elements
      filesArray.forEach((file) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[file],["file"]);
        const option = document.createElement("option")
        option.value = file
        option.textContent = file
        selectBox.appendChild(option)
      })
      replacementDiv.innerHTML = ""
      replacementDiv.appendChild(selectBox)
    } else {
      replacementDiv.innerHTML = ""
    }
  })

  document.querySelector(".page1lmileftright_myusage #incomeThreshold-options").addEventListener("change", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    validateSelectedOption()
  })
  document.querySelector(".page1lmileftright_myusage #programFilesOptions").addEventListener("change", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    validateSelectedOption()
  })

  // append selected option's value below selectbox ----------
  var optns = document.querySelector(".page1lmileftright_myusage #incomeThreshold-options")
  var optns2 = document.querySelector(".page1lmileftright_myusage #programFilesOptions")
  var selectedValue = ""
  var selectedOptText = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    selectedValue = optns.options[optns.selectedIndex]
    selectedValue = selectedValue.innerText
  })
  optns2.addEventListener("change", () => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
    selectedOptText = optns2.value
  })

  function validateSelectedOption() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateSelectedOption",[],[]);
    var selectedOption = document.querySelector(".page1lmileftright_myusage #incomeThreshold-options").value
    var selectedOption1 = document.querySelector(".page1lmileftright_myusage #programFilesOptions").value
    var optionError = document.querySelector(".page1lmileftright_myusage #optionError")
    var optionError1 = document.querySelector(".page1lmileftright_myusage #optionError1")

    if (selectedOption === "Select an option") {
      optionError.innerHTML = "Please select an option."
      return "error"
    } else {
      optionError.innerHTML = ""
      if (selectedOption1 === "Select an option") {
        optionError1.innerHTML = "Please select an option."
        return "error"
      } else {
        optionError1.innerHTML = ""
        return null
      }
    }
  }
  function validateCheckSignature() {
__ea_trace("modules/usage/usage-il-bayou.ts","validateCheckSignature",[],[]);
    var LMICheckboxContent = document.querySelector(".page1lmileftright_myusage #LMICheckboxContent")
    var elctsign = document.querySelector(".page1lmileftright_myusage #elctsign").value
    var attestation_error = document.querySelector(".page1lmileftright_myusage #attestation_error_message")

    if (!LMICheckboxContent.checked || elctsign === "" || elctsign === " " || elctsign == null) {
      attestation_error.innerHTML = "There are errors in the form above. Please scroll up and correct them to continue"
      return "error"
    } else {
      attestation_error.innerHTML = ""
      return null
    }
  }
  function toggleContent(radio) {
__ea_trace("modules/usage/usage-il-bayou.ts","toggleContent",[radio],["radio"]);
    var itemsContainer = document.querySelector(".ipiaap-items")
    var itemsContainer1 = document.querySelector(".ipiaap-items-1")
    var itemsContainer2 = document.querySelector(".ipiaap-items-2")
    var itemsContainer3 = document.querySelector(".ipiaap-items-3")
    // Toggle visibility based on the selected radio button's value
    itemsContainer.style.display = radio.value === "green" ? "block" : "none"
    itemsContainer1.style.display = radio.value === "orange" ? "block" : "none"
    itemsContainer2.style.display = radio.value === "cencus" ? "block" : "none"
    itemsContainer3.style.display = radio.value === "blue" ? "block" : "none"
  }

  var _utilityIdSession
  var LmiAvailability
  var LmiCensusAvailability
  var _DisplayLmiElementList = []
  var _requireLmiElementList = []
  var LMICensusTractLevels

  var _sampleSessiontype
  var _sampleOriginType

  if (storage.rawGet("attcode") != null) {
    _sampleOriginType = "Invite"
    _sampleSessiontype = "Consumer Completing"
  } else {
    _sampleOriginType = "Direct"
    _sampleSessiontype = "Consumer Only"
  }

  var offerId = ""
  var _lmiCensusTractLevel = ""

  async function getAvailability() {
__ea_trace("modules/usage/usage-il-bayou.ts","getAvailability",[],[]);
    openProgressBar("We are getting in contact with your utility service provider.")
    var exampleUtilityId = storage.rawGet("utility_id")
    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    var _IsUtilityIdMatched = false
    if (rows.length >= 1) {
      storage.rawSet("Session Config ID", rows[0].id)
      rows.forEach((element) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          if (element.values["24"] !== undefined) {
            storage.rawSet("credentialProvider", element.values["24"].name)
          }
          _IsUtilityIdMatched = true
          _utilityIdSession = element.values["1"]
          if (element.values["68"]) {
            LMICensusTractLevels = element.values["68"].name
          }
          if (element.values["30"] === "1") {
            LmiAvailability = "Yes"
          } else if (element.values["30"] === "0") {
            LmiAvailability = "No"
          } else {
            LmiAvailability = ""
          }
          if (element.values["31"] === "1") {
            LmiCensusAvailability = "Yes"
          } else if (element.values["31"] === "0") {
            LmiCensusAvailability = "No"
          } else {
            LmiCensusAvailability = ""
          }
          var isLMII = storage.rawGet("isLMI")
          if (isLMII === "Yes") {
            lmiFlow()
          } else {
            getOfferIDFromFarmProductsNoLMI()
            closeProgressBar()
          }
        } else {
          closeProgressBar()
        }
      })
    } else {
      closeProgressBar()
    }
  }
  async function getOfferIDFromFarmProductsNoLMI() {
__ea_trace("modules/usage/usage-il-bayou.ts","getOfferIDFromFarmProductsNoLMI",[],[]);
    var farmId = storage.rawGet("FarmID")
    var OfferTypeVal = "Open"
    try {
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.farms}/rows?portalId=${window.__ENV__.dataPortalId}&farm_id=${farmId}&offer_type=${OfferTypeVal}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        offerId = rows[0].values[3]
        storage.rawSet("offerIdNoLMI", offerId)
      }
    } catch (error) {
      console.error("Error in Farm Product hubdb fetch block:", error)
    }
  }
  async function getOfferIDFromFarmProductsYesLMI() {
__ea_trace("modules/usage/usage-il-bayou.ts","getOfferIDFromFarmProductsYesLMI",[],[]);
    var farmId = storage.rawGet("FarmID")
    var OfferTypeVal = "LMI"
    try {
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.farms}/rows?portalId=${window.__ENV__.dataPortalId}&farm_id=${farmId}&offer_type=${OfferTypeVal}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        offerId = rows[0].values[3]
        storage.rawSet("offerIdYesLMI", offerId)
      }
    } catch (error) {
      console.error("Error in Farm Products hubdb fetch block:", error)
    }
  }
  async function lmiFlow() {
__ea_trace("modules/usage/usage-il-bayou.ts","lmiFlow",[],[]);
    if (LmiAvailability === "No") {
      await getOfferIDFromFarmProductsNoLMI()
      closeProgressBar()
    } else if (LmiAvailability === "Yes" && LmiCensusAvailability === "No") {
      await getOfferIDFromFarmProductsYesLMI()
      await getOfferIDFromFarmProductsNoLMI()
      exampleUtilityId = storage.rawGet("utility_id")
      var stateForLMIConfig = storage.rawGet("stateForLMIConfig")
      const hubDBEndpointLMIC = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.lmiConfig}/rows?portalId=${window.__ENV__.dataPortalId}&orderBy=lmi_sequence&utility_id=${exampleUtilityId}&state=${stateForLMIConfig}`
      const responseLMIC = await fetch(hubDBEndpointLMIC, { method: "GET" })
      const dataLMIC = await responseLMIC.json()
      const rowsLMIC = dataLMIC.objects
      document.querySelector("#Income_Exceed_Threshold").style.display = "none"
      document.querySelector("#Program_Participation").style.display = "none"
      document.querySelector("#Request_Income_Check").style.display = "none"
      document.querySelector("#Attestation").style.display = "none"
      document.querySelector("#Attestation .LMICheckCont").style.display = "none"
      document.querySelector("#Attestation .LMISignature").style.display = "none"
      document.querySelector("#Cencus_tract_map_upload").style.display = "none"
      document.querySelector("#Cencus_tract_map_upload .ipiaap-items-2").style.display = "none"
      document.querySelector("#Cencus_tract_map_upload #cencus-track-radio").style.display = "none"
      document.querySelector("#Cencus_tract_map_upload .LMISignature").style.display = "none"
      if (rowsLMIC.length >= 1) {
        rowsLMIC.forEach((element) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[element],["element"]);
          var lmiOptAvl = element.values["5"].name
          var lmiOptType = element.values["6"].name
          var lmiSeq = element.values["4"]
          var lmiOptText = element.values["7"]
          var lmiInLineText = element.values["9"]
          var lmiCheckbox = element.values["12"].name
          var lmiSignature = element.values["16"].name
          var lmiCheckContent = element.values["13"]
          var fileUploadControl = element.values["14"]
          var lmiOptionLinkText = element.values["17"]
          var lmiOptionLink
          if (lmiOptionLinkText) {
            lmiOptionLink = element.values["8"]
          }
          if (lmiOptAvl === "Yes" && lmiOptType === "Threshold Opt-Out") {
            document.querySelector(".lmifieldswrapper .iethItem").setAttribute("order", lmiSeq)
            document.querySelector("#Income_Exceed_Threshold").style.display = "block"
            document.querySelector("#Income_Exceed_Threshold .lmiOptText").innerHTML = lmiOptText
            document.querySelector("#Income_Exceed_Threshold .lmiInLineTxt").innerHTML = lmiInLineText
            if (lmiOptionLink) {
              document.querySelector("#Income_Exceed_Threshold .lmiLinkTxt").innerHTML =
                `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
            }
          } else if (lmiOptAvl === "Yes" && lmiOptType === "Program") {
            document.querySelector(".lmifieldswrapper .ppItem").setAttribute("order", lmiSeq)
            document.querySelector("#Program_Participation").style.display = "block"
            document.querySelector("#Program_Participation .lmiOptText").innerHTML = lmiOptText
            document.querySelector("#Program_Participation .lmiInLineTxt").innerHTML = lmiInLineText
            if (lmiOptionLink) {
              document.querySelector("#Program_Participation .lmiLinkTxt").innerHTML =
                `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
            }
            var lmiProgOpts = element.values["10"]
            var lmiDocsOpts = element.values["11"]
            var lmiProgOptsarray = lmiProgOpts.split(",")
            var prgselectbx = document.querySelector("#Program_Participation #incomeThreshold-options")
            lmiProgOptsarray.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
              var option = document.createElement("option")
              option.text = item
              prgselectbx.add(option)
            })

            var lmiDocsOptsitems = lmiDocsOpts.split("|")
            var lmiDocsOptsresult = []
            lmiDocsOptsitems.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
              var parts = item.split(":")
              var key = parts[0]
              var value = parts[1].split(",")
              var obj = {}
              obj[key] = value
              lmiDocsOptsresult.push(obj)
              var prgselectbxoptionsAll = prgselectbx.querySelectorAll("option")
              prgselectbxoptionsAll.forEach((option) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[option],["option"]);
                if (option.text === key) {
                  option.setAttribute("value", value)
                }
              })
            })
          } else if (lmiOptAvl === "Yes" && lmiOptType === "Income Verification") {
            document.querySelector(".lmifieldswrapper .rICItem").setAttribute("order", lmiSeq)
            document.querySelector("#Request_Income_Check").style.display = "block"
            document.querySelector("#Request_Income_Check .lmiOptText").innerHTML = lmiOptText
            document.querySelector("#Request_Income_Check .lmiInLineTxt").innerHTML = lmiInLineText
            if (lmiOptionLink) {
              document.querySelector("#Request_Income_Check .lmiLinkTxt").innerHTML =
                `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
            }
          } else if (lmiOptAvl === "Yes" && lmiOptType === "Attestation") {
            document.querySelector(".lmifieldswrapper .attsItem").setAttribute("order", lmiSeq)
            document.querySelector("#Attestation").style.display = "block"
            document.querySelector("#Attestation .lmiOptText").innerHTML = lmiOptText
            document.querySelector("#Attestation .lmiInLineTxt").innerHTML = lmiInLineText
            if (lmiCheckbox === "Yes") {
              document.querySelector("#Attestation .LMICheckCont").style.display = "block"
              document.querySelector("#Attestation .LMICheckCont label span").innerHTML = lmiCheckContent
            }
            if (lmiSignature === "Yes") {
              document.querySelector("#Attestation .LMISignature").style.display = "block"
            }
            if (lmiOptionLink) {
              document.querySelector("#Attestation .lmiLinkTxt").innerHTML =
                `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
            }
          } else if (lmiOptAvl === "Yes" && lmiOptType === "Census Tract Map Upload") {
            document.querySelector(".lmifieldswrapper .ctmuItem").setAttribute("order", lmiSeq)
            document.querySelector("#Cencus_tract_map_upload").style.display = "block"
            document.querySelector("#Cencus_tract_map_upload .lmiOptText").innerHTML = lmiOptText
            document.querySelector("#Cencus_tract_map_upload .lmiInLineTxt").innerHTML = lmiInLineText
            if (lmiSignature === "Yes") {
              document.querySelector("#Cencus_tract_map_upload .LMISignature").style.display = "block"
            }
            if (lmiOptionLink) {
              document.querySelector("#Cencus_tract_map_upload .lmiLinkTxt").innerHTML =
                `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
            }
            if (fileUploadControl.name === "Yes") {
              document.querySelector("#Cencus_tract_map_upload #cencus-track-radio").style.display = "block"
            }
          }
        })
      }
      var lmifieldswrapperul = document.querySelector(".lmifieldswrapper")
      var lmifieldswrapperlistItems = Array.from(lmifieldswrapperul.querySelectorAll(".list"))
      lmifieldswrapperlistItems.sort((a, b) => a.getAttribute("order") - b.getAttribute("order"))
      lmifieldswrapperul.innerHTML = ""
      lmifieldswrapperlistItems.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
        lmifieldswrapperul.appendChild(item)
      })
      // show hide widgets
      closeProgressBar()
    } else if (LmiAvailability === "Yes" && LmiCensusAvailability === "Yes") {
      await getOfferIDFromFarmProductsYesLMI()
      await getOfferIDFromFarmProductsNoLMI()
      const hensonApiUrl = "https://hansen.danmarcrm.com/lmiHansen.php"
      const requestBody = {
        line1: document.querySelector("#page_1_my_info_widget #address1").value.trim(),
        city: document.querySelector("#page_1_my_info_widget #city").value.trim(),
        state: document.querySelector("#page_1_my_info_widget #state").value,
        zip: document.querySelector("#page_1_my_info_widget #code").value.trim(),
      }
      var _catchdata = ""
      try {
        const response = await fetch(hensonApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        })
        _catchdata = requestBody
        const responseData = await response.json()
        responseFromAPI = JSON.stringify(responseData)
        if (responseData.result === "valid") {
          _lmiCensusTractLevel = LMICensusTractLevels
          closeProgressBar()
        } else if (responseData.result === "notvalid") {
          _lmiCensusTractLevel = LMICensusTractLevels
          exampleUtilityId = storage.rawGet("utility_id")
          var stateForLMIConfig = storage.rawGet("stateForLMIConfig")

          const hubDBEndpointLMIC = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.lmiConfig}/rows?portalId=${window.__ENV__.dataPortalId}&orderBy=lmi_sequence&utility_id=${exampleUtilityId}&state=${stateForLMIConfig}`
          const responseLMIC = await fetch(hubDBEndpointLMIC, { method: "GET" })
          const dataLMIC = await responseLMIC.json()
          const rowsLMIC = dataLMIC.objects

          document.querySelector("#Income_Exceed_Threshold").style.display = "none"
          document.querySelector("#Program_Participation").style.display = "none"
          document.querySelector("#Request_Income_Check").style.display = "none"
          document.querySelector("#Attestation").style.display = "none"
          document.querySelector("#Attestation .LMICheckCont").style.display = "none"
          document.querySelector("#Attestation .LMISignature").style.display = "none"
          document.querySelector("#Cencus_tract_map_upload").style.display = "none"
          document.querySelector("#Cencus_tract_map_upload .ipiaap-items-2").style.display = "none"
          document.querySelector("#Cencus_tract_map_upload #cencus-track-radio").style.display = "none"
          document.querySelector("#Cencus_tract_map_upload .LMISignature").style.display = "none"
          if (rowsLMIC.length >= 1) {
            rowsLMIC.forEach((element) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[element],["element"]);
              var lmiOptAvl = element.values["5"].name
              var lmiOptType = element.values["6"].name
              var lmiSeq = element.values["4"]
              var lmiOptText = element.values["7"]
              var lmiInLineText = element.values["9"]
              var lmiCheckbox = element.values["12"].name
              var lmiSignature = element.values["16"].name
              var lmiCheckContent = element.values["13"]
              var fileUploadControl = element.values["14"]
              var lmiOptionLinkText = element.values["17"]
              var lmiOptionLink
              if (lmiOptionLinkText) {
                lmiOptionLink = element.values["8"]
              }

              if (lmiOptAvl === "Yes" && lmiOptType === "Threshold Opt-Out") {
                document.querySelector(".lmifieldswrapper .iethItem").setAttribute("order", lmiSeq)
                document.querySelector("#Income_Exceed_Threshold").style.display = "block"
                document.querySelector("#Income_Exceed_Threshold .lmiOptText").innerHTML = lmiOptText
                document.querySelector("#Income_Exceed_Threshold .lmiInLineTxt").innerHTML = lmiInLineText
                if (lmiOptionLink) {
                  document.querySelector("#Income_Exceed_Threshold .lmiLinkTxt").innerHTML =
                    `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
                }
              } else if (lmiOptAvl === "Yes" && lmiOptType === "Program") {
                document.querySelector(".lmifieldswrapper .ppItem").setAttribute("order", lmiSeq)
                document.querySelector("#Program_Participation").style.display = "block"
                document.querySelector("#Program_Participation .lmiOptText").innerHTML = lmiOptText
                document.querySelector("#Program_Participation .lmiInLineTxt").innerHTML = lmiInLineText
                if (lmiOptionLink) {
                  document.querySelector("#Program_Participation .lmiLinkTxt").innerHTML =
                    `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
                }
                var lmiProgOpts = element.values["10"]
                var lmiDocsOpts = element.values["11"]
                var lmiProgOptsarray = lmiProgOpts.split(",")
                var prgselectbx = document.querySelector("#Program_Participation #incomeThreshold-options")
                lmiProgOptsarray.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
                  var option = document.createElement("option")
                  option.text = item
                  prgselectbx.add(option)
                })

                var lmiDocsOptsitems = lmiDocsOpts.split("|")
                var lmiDocsOptsresult = []
                lmiDocsOptsitems.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
                  var parts = item.split(":")
                  var key = parts[0]
                  var value = parts[1].split(",")
                  var obj = {}
                  obj[key] = value
                  lmiDocsOptsresult.push(obj)
                  var prgselectbxoptionsAll = prgselectbx.querySelectorAll("option")
                  prgselectbxoptionsAll.forEach((option) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[option],["option"]);
                    if (option.text === key) {
                      option.setAttribute("value", value)
                    }
                  })
                })
              } else if (lmiOptAvl === "Yes" && lmiOptType === "Income Verification") {
                document.querySelector(".lmifieldswrapper .rICItem").setAttribute("order", lmiSeq)
                document.querySelector("#Request_Income_Check").style.display = "block"
                document.querySelector("#Request_Income_Check .lmiOptText").innerHTML = lmiOptText
                document.querySelector("#Request_Income_Check .lmiInLineTxt").innerHTML = lmiInLineText
                if (lmiOptionLink) {
                  document.querySelector("#Request_Income_Check .lmiLinkTxt").innerHTML =
                    `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
                }
              } else if (lmiOptAvl === "Yes" && lmiOptType === "Attestation") {
                document.querySelector(".lmifieldswrapper .attsItem").setAttribute("order", lmiSeq)
                document.querySelector("#Attestation").style.display = "block"
                document.querySelector("#Attestation .lmiOptText").innerHTML = lmiOptText
                document.querySelector("#Attestation .lmiInLineTxt").innerHTML = lmiInLineText
                if (lmiCheckbox === "Yes") {
                  document.querySelector("#Attestation .LMICheckCont").style.display = "block"
                  document.querySelector("#Attestation .LMICheckCont label span").innerHTML = lmiCheckContent
                }
                if (lmiSignature === "Yes") {
                  document.querySelector("#Attestation .LMISignature").style.display = "block"
                }
                if (lmiOptionLink) {
                  document.querySelector("#Attestation .lmiLinkTxt").innerHTML =
                    `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
                }
              } else if (lmiOptAvl === "Yes" && lmiOptType === "Census Tract Map Upload") {
                document.querySelector(".lmifieldswrapper .ctmuItem").setAttribute("order", lmiSeq)
                document.querySelector("#Cencus_tract_map_upload").style.display = "block"
                document.querySelector("#Cencus_tract_map_upload .lmiOptText").innerHTML = lmiOptText
                document.querySelector("#Cencus_tract_map_upload .lmiInLineTxt").innerHTML = lmiInLineText
                if (lmiSignature === "Yes") {
                  document.querySelector("#Cencus_tract_map_upload .LMISignature").style.display = "block"
                }
                if (lmiOptionLink) {
                  document.querySelector("#Cencus_tract_map_upload .lmiLinkTxt").innerHTML =
                    `<a href="${lmiOptionLink}">${lmiOptionLinkText}</a>`
                }
                if (fileUploadControl.name === "Yes") {
                  document.querySelector("#Cencus_tract_map_upload #cencus-track-radio").style.display = "block"
                }
              }
            })
          } else {
          }
          var lmifieldswrapperul = document.querySelector(".lmifieldswrapper")
          var lmifieldswrapperlistItems = Array.from(lmifieldswrapperul.querySelectorAll(".list"))
          lmifieldswrapperlistItems.sort((a, b) => a.getAttribute("order") - b.getAttribute("order"))
          lmifieldswrapperul.innerHTML = ""
          lmifieldswrapperlistItems.forEach((item) => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[item],["item"]);
            lmifieldswrapperul.appendChild(item)
          })
          closeProgressBar()
        } else {
          closeProgressBar()
          alert("Unexpected Error")
          location.reload()
        }
        if (response.status === 500 || response.status === 404) {
        }
      } catch (error) {
        console.error("Error calling API:", error)
      }
    }
  }

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")
  var isLMII = storage.rawGet("isLMI")
  if (isLMII === "Yes") {
    document.querySelector(".lmifieldswrapper").style.display = "block"
  } else {
    document.querySelector(".lmifieldswrapper").style.display = "none"
    setTimeout(() => {
__ea_trace("modules/usage/usage-il-bayou.ts","(anon)",[],[]);
      document.querySelector(".lmifieldswrapper").remove()
    }, 2000)
  }
  if (is_enrolled_for_bayou === "yes") {
    GetDataFromDealRecordMulti()
    getallDataFromUANConfigTable()
  } else {
    GetDataFromDealRecord()
    getallDataFromUANConfigTable()
  }

  document.getElementById("program-participation-radio").click()

  // ─── Wire formerly-inline handlers ────────────────────────────────────────────

  // Radio toggles (LMI options)
  bind("#income-threshold-radio", "click", (e) => toggleContent(e.currentTarget))
  bind("#program-participation-radio", "click", (e) => toggleContent(e.currentTarget))
  bind("#cencus-track-radio", "click", (e) => toggleContent(e.currentTarget))
  bind("#request-icome-radio", "click", (e) => toggleContent(e.currentTarget))
  bind("#attestation-radio", "click", (e) => toggleContent(e.currentTarget))

  // Manual upload area (#manualdesktopCamera)
  bind("#manualdropArea", "drop", (e) => dropHandler(e, false, false, true))
  bind("#manualdropArea", "dragover", (e) => dragOverHandler(e, false, false, true))
  bind("#manualdropArea", "click", () => triggerFilemanualPicker())
  bind("#manualmobileCamera img", "click", (e) => triggerFileInput(e)) // NOTE: no booleans, targets #fileInput not #manualfileInput
  bind("#manualmobileCamera a", "click", (e) => triggerFileInput(e))
  bind("#manualdesktopCamera .uploadRemoveButtons button:not([id])", "click", () => triggerFilemanualPicker())
  bind("#manualremoveimagebutton", "click", () => removeImageOpenPopup(false, false, true))
  bind(".manual-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () =>
    removeCurrentImage(false, false, true),
  )
  bind(".manual-RemoveFilePopup #keepIt", "click", () => removeImageClosePopup(false, false, true))

  // Standard utility upload area (#mobileCamera / #dropArea)
  bind("#dropArea", "drop", (e) => dropHandler(e, false, false, false))
  bind("#dropArea", "dragover", (e) => dragOverHandler(e, false, false, false))
  bind("#dropArea", "click", () => triggerFilePicker())
  bind("#mobileCamera img", "click", (e) => triggerFileInput(e, false, false))
  bind("#mobileCamera a", "click", (e) => triggerFileInput(e, false, false))
  bind("#Program_Participation .uploadRemoveButtons button:not([id])", "click", () => triggerFilePicker())
  bind("#removeimagebutton", "click", () => removeImageOpenPopup(false, false, false))
  bind(".RemoveFilePopup .removefilePopButtons button:not([id])", "click", () =>
    removeCurrentImage(false, false, false),
  )
  bind(".RemoveFilePopup #keepIt", "click", () => removeImageClosePopup(false, false, false))

  // Census upload area (#censusDropArea)
  bind("#censusDropArea", "drop", (e) => dropHandler(e, true, false, false))
  bind("#censusDropArea", "dragover", (e) => dragOverHandler(e, true, false, false))
  bind("#censusDropArea", "click", () => triggerCensusFilePicker())
  bind("#censusMobileCamera img", "click", (e) => triggerFileInput(e, true, false))
  bind("#censusMobileCamera a", "click", (e) => triggerFileInput(e, true, false))
  bind("#Cencus_tract_map_upload .uploadRemoveButtons button:not([id])", "click", () => triggerCensusFilePicker())
  bind("#censusRemoveimagebutton", "click", () => removeImageOpenPopup(true, false, false))
  bind(".census-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () =>
    removeCurrentImage(true, false, false),
  )
  bind(".census-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(true, false, false))

  // Income upload area (#incomeDropArea)
  bind("#incomeDropArea", "drop", (e) => dropHandler(e, false, true, false))
  bind("#incomeDropArea", "dragover", (e) => dragOverHandler(e, false, true, false))
  bind("#incomeDropArea", "click", () => triggerincomeFilePicker())
  bind("#incomeMobileCamera img", "click", (e) => triggerFileInput(e, false, true))
  bind("#incomeMobileCamera a", "click", (e) => triggerFileInput(e, false, true))
  bind("#Request_Income_Check .uploadRemoveButtons button:not([id])", "click", () => triggerincomeFilePicker())
  bind("#incomeRemoveimagebutton", "click", () => removeImageOpenPopup(false, true, false))
  bind(".income-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () =>
    removeCurrentImage(false, true, false),
  )
  bind(".income-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(false, true, false))
}
